export const ASPECTS = {
  base11: "1:1",
  base21: "2:1",
  base12: "1:2",
  base169: "16:9",
  base916: "9:16",
  base219: "21:9",
  base921: "9:21",
  base23: "2:3",
  base32: "3:2",
  base25: "2:5",
  base52: "5:2",
  base13: "1:3",
  base31: "3:1",
  base149: "14:9",
  base914: "9:14",
  base53: "5:3",
  base35: "3:5",
  base43: "4:3",
  base34: "3:4",
  base100143: "100:143",
  base143100: "143:100",
  base100185: "100:185",
  base185100: "185:100",
  base100235: "100:235",
  base235100: "235:100",
};

export const MJARGUMENTS = {
  base: "",
  basehd: "--hd",
  basevibe: "--vibe",
  basevibefast: "--vibefast",
  basetest: "--test",
  basestyle60000: "--version 3 --stylize 60000",
  basestyle25000: "--version 3 --stylize 25000",
  basestyle15000: "--version 3 --stylize 15000",
  basestyle10000: "--version 3 --stylize 10000",
  basestyle3750: "--version 3 --stylize 3750",
  basestyle1250: "--version 3 --stylize 1250",
  basestyle400: "--version 3 --stylize 625",
  basequality1: "--version 3 --quality 1",
  basequality05: "--version 3 --quality 0.5",
  basequality025: "--version 3 --quality 0.25",
  basequality2: "--version 3 --quality 2",
  basequality5: "--version 3 --quality 5",
  basestop80: "--stop 80",
  basestop70: "--stop 70",
  basestop60: "--stop 60",
  basestop50: "--stop 50",
};

export const SDARGUMENTS = {
  cfg: {
    base: "",
    basec1: "-C 1",
    basec3: "-C 3",
    basec10: "-C 10",
    basec15: "-C 15",
    basec20: "-C 20",
    basec30: "-C 30",
    basec50: "-C 50",
    basec100: "-C 100",
  },
  steps: {
    base: "",
    bases1: "-s 1",
    bases5: "-s 5",
    bases10: "-s 10",
    bases20: "-s 20",
    bases30: "-s 30",
    bases70: "-s 70",
  },
  sampler: {
    base: "",
    baseheun: "-A k_heun",
    baseeuler: "-A k_euler",
    baseeulerancestral: "-A k_euler_ancestral",
    basedpm2: "-A k_dpm_2",
    basedpm2ancestral: "-A k_dpm_2_ancestral",
    baseddim: "-A ddim",
    baseplms: "-A plms",
  },
};

export const BASEMODIFICATIONS_sd = {
  basestyle: '!dream "keyword of a Utah Teapot " -S 1179427124',
  basephoto: '!dream "keyword, photo of a Utah Teapot " -S 1179427124',
  basemade: '!dream "Utah teapot made of keyword" -S 1179427124',
  basecolor: '!dream "keyword color, photo of a Utah teapot" -S 1179427124',
  baseanime: '!dream "keyword style, anime of a Utah teapot" -S 1179427124',
  basegame: '!dream "keyword style, a Utah teapot" -S 1179427124',
};

export const BASEMODIFICATIONS = {
  baseart: "https://s.mj.run/PD_i8SNJkdg Utah Teapot, digital art --ar 16:9",
  basephoto: "https://s.mj.run/PD_i8SNJkdg a photo of a Utah Teapot --ar 16:9",
  basemade: "https://s.mj.run/PD_i8SNJkdg Utah Teapot made of --ar 16:9",
};

export const PHYSICALMEDIUMS = {
  drawingtypes: {
    illustration: "illustration",
    drawing: "Drawing",
    doodle: "Doodle",
    handdrawn: "Hand-Drawn",
    childrensdrawing: "Childrens Drawing",
    masterpiece: "Masterpiece",
    dotart: "Dot Art",
    pointillism: "Pointillism",
    stipple: "Stipple",
    lineart: "Line Art",
    crosshatch: "Crosshatch",
    figuredrawing: "Figure drawing",
    storybookillustration: "Storybook Illustration",
    illustratedbooklet: "Illustrated Booklet",
    assemblydrawing: "Assembly Drawing",
    visualnovel: "Visual Novel",
    graphicnovel: "Graphic Novel",
    cartographic: "Cartographic",
    illumanu: "Illuminated Manuscript",
    anatomical: "Anatomical Drawing",
  },
  pencilmediums: {
    charcoal: "charcoal",
    graphitePencil: "graphite Pencil",
    colorPencil: "color Pencil",
  },
  penmediums: {
    ballpointpen: "Ballpoint Pen",
    fountainpen: "Fountain Pen",
    gelpen: "Gel Pen",
    dryerasemarker: "Dry-Erase Marker",
    weterasemarker: "Wet-Erase Marker",
    whiteboard: "Whiteboard",
    inkPen: "Ink and Pen",
    calligraphy: "calligraphy",
    inkpainting: "inkpainting",
    marker: "marker",
  },

  crayonchalkmediums: {
    chalk: "Chalk Art",
    conte: "conte",
    pastel: "Pastel  Art",
    crayon: "crayon",
  },

  paintmediums: {
    painting: "Painting",
    hardedgepainting: "Hard Edge Painting",
    detailedpainting: "Detailed Painting",
    speedpainting: "Speedpainting",
    fauxpainting: "Faux Painting",
    colorfieldpainting: "Color Field Painting",
    stilllife: "Still-Life",
    scrollpainting: "Scroll Painting",
    fineart: "Fine Art",
    modernart: "Modern Art",
    brushwork: "Brushwork",
    chinesepainting: "Chinese Painting",
    tibetanpainting: "Tibetan Painting",
    japanesepainting: "Japanese Painting",
    koreanpainting: "Korean Painting",
    papermarbling: "Paper-Marbling",
    hydrodipping: "Hydro-Dipping",
    hydrodipped: "Hydrodipped",
    artwork: "Artwork",
    mural: "Mural",
    streetart: "Street Art",
    caveart: "Cave Art",
    rockart: "Rock Art",
    sandpainting: "Sandpainting",
    easteregg: "Easter Egg",
    eggdecorating: "Egg Decorating",
    oilPainting: "oil Painting",
    glassPaint: "glass Paint",
    watercolor: "Watercolor Art",
    tempera: "Tempera Art",
    goache: "Goache Art",
    sprayPaint: "sprayPaint",
    airbrush: "airbrush",
  },
  textmediums: {
    text: "Text",
    typeface: "Typeface",
    font: "Font",
    letters: "Letters",
    writtenletters: "Written Letters",
    writtenlettersteapot: "Written Letters 'Teapot'",
    writtenwords: "Written Words",
    writtenwordsteapot: "Written Words 'Teapot'",
    words: "Words",
    wordsteapot: "Words 'Teapot'",
    lexemes: "Lexemes",
    lexemesteapot: "Lexemes 'Teapot'",
    graphmes: "Graphemes",
    says: "Says",
    saysteapot: "Says Teapot",
    caption: "Caption",
    captionteapot: "Caption 'Teapot'",
  },

  printedmediums: {
    businesscard: "Buisness Card",
    booklet: "Booklet",
    popupbook: "Pop-up Book",
    instructionmanual: "Instruction Manual",
    ikeaguide: "IKEA Guide",
    legoinstructionguide: "Lego Instruction Manual",
    poster: "Poster",
    movieposter: "Movie Poster",
    concertposter: "Concert Poster",
    photocollage: "Photocollage",
    fotocollage: "Fotocollage",
    risograph: "Risograph",
    viscosityprint: "Viscosity Print",
    transferprint: "Transfer Printing",
    flexography: "Flexography",
    baghprint: "Bagh Print",
    bagruprint: "Bagru Print",
    drypoint: "Drypoint",
    metalcut: "Metalcut",
    blueprint: "Blueprint",
    sticker: "Sticker",
    diecutsticker: "Die-cut sticker",
    watermark: "Watermark",
    barcode: "Barcode",
    qrcode: "QR Code",
    pokemon: "Pokemon",
    pokemoncard: "Pokemon Card",
    pokmon: "Pokémon",
    pokmoncard: "Pokémon Card",
    blueprint2: "blueprint",
    concept: "Concept Art",
    collage: "collage",
    block: "Block Printing",
    prop: "Propaganda Poster",
    sears: "Sears Catalog",
    prod: "Product Photo",
    elecPhoto: "Election Photo",
    elecPoster: "Election Poster",
    screen: "Screen Painting",
    mono: "Mono Printing",
    litho: "Lithography",
    scroll: "scroll",
    stamp: "stamp",
    scientificdiagram: "Scientific Diagram",
    magazine: "magazine",
    ad: "Advertisement",
    postage: "postage",
    woodblock: "Wood Block Print",
    newspaper: "Newspaper",
  },
  physicalmediums: {
    origami: "Origami",
    rigidorigami: "Rigid Origami",
    kirigami: "Kirigami",
    moneygami: "Moneygami",
    wetfolding: "Wet-Folding",
    irisfolding: "Iris-Folding",
    chinesepaperfolding: "Chinese Paper Art",
    sonobe: "Sonobe",
    mosaic: "Mosaic",
    micromosaic: "Micromosaic",
    glassmosaic: "Glass Mosaic",
    photographicmosaic: "Photographic Mosaic",
    impressionistmosaic: "Impressionist Mosaic",
    pietradura: "Pietra Dura",
    encaustictile: "Encaustic Tile",
    frame: "Frame",
    framed: "Framed",
    woodenframe: "Wooden Frame",
    woodenframed: "Wooden Framed",
    banner: "Banner",
    signage: "Signage",

    carving: "Carving",
    pyrography: "Pyrography",
    modeling: "Modeling",
    model: "Model",
    whittling: "Whittling",
    woodcarving: "Wood-Carving",
    woodturning: "Woodturning",
    chipcarving: "Chip-Carving",
    chipwork: "Chip-Work",
    bentwood: "Bentwood",
    intarsia: "Intarsia",
    marquetry: "Marquetry",
    woodmarquetry: "Wood Marquetry",
    strawmarquetry: "Straw Marquetry",
    scrimshaw: "Scrimshaw",
    sgraffito: "Sgraffito",
    hardstonecarving: "Hardstone Carving",
    leathercrafting: "Leather Crafting",
    bejeweled: "Bejeweled",
    engravedgem: "Engraved Gem",
    lapidary: "Lapidary",
    icecarving: "Ice-Carving",
    intaglio: "Intaglio",
    carvedlacquer: "Carved Lacquer",
    papercutting: "Papercutting ",
    papermodel: "Paper Model ",
    papermache: "Paper-Mache",
    stringart: "String-Art",
    fretwork: "Fretwork",
    card: "Card",
    mezzotint: "Mezzotint",
    aquatint: "Aquatint",
    linocut: "Linocut",
    balloonmodelling: "Balloon Modelling ",
    balloontwisting: "Balloon Twisting ",
    oshibana: "Oshibana",
    circuit: "Circuit",
    circuitry: "Circuitry",
    lithophane: "Lithophane",
    figurine: "Figurine",

    overglaze: "Overglaze",
    inglaze: "Inglaze",
    saltglazepottery: "Salt Glaze Pottery",
    tinglazedpottery: "Tin-Glazed Pottery",
    cameoglass: "Cameo Glass",
    enameledglass: "Enameled Glass",
    paleolithicpottery: "Paleolithic Pottery",
    neolithicpottery: "Neolithic Pottery",
    earthenware: "Earthenware",
    stoneware: "Stoneware",
    slipware: "Slipware",
    chintzware: "Chintzware",
    agateware: "Agateware",
    lustreware: "Lustreware",
    bonecarving: "Bone Carving",
    ornament: "Ornament",
    lightart: "Light Art",
    lightpainting: "Light Painting",
    light_painting: "Lightpainting",
    projectionmapping: "Projection Mapping",
    artsandcrafts: "Arts and Crafts",
    resin: "Resin",
    enamelpin: "Enamel Pin",
    beadwork: "Beadwork",
    beadsandstring: "Beads and String",
    beadsandyarn: "Beads and Yarn",
    stickerbomb: "Sticker Bomb",
    coffeestain: "Coffee Stain",
    smokeart: "Smoke Art",
    hedgetrimming: "Hedge Trimming",
    sitespecificart: "Site-Specific art",
    publicart: "Public Art",
    ironwork: "Ironwork",
    carpentry: "Carpentry",
    jigsaw: "Jigsaw",
    puzzle: "Puzzle",
    maze: "Maze",
    toy: "Toy",
    diorama: "Diorama",
    shoe: "Shoe",
    shoes: "Shoes",
    hat: "Hat",
    hatmaking: "Hatmaking",

    balloon: "Balloon",
    gildedframe: "Gilded Frame",
    gildedframed: "Gilded Framed",
    glassetching: "Glass Etching",
    glaze: "Glaze",
    mixedmedia: "Mixed Media",
    negativespace: "Negative Space",
    outlined: "Outlined",
    stencil: "Stencil",

    base: "",
    sketch: "sketch",
    acrylic: "acrylic",
    latex: "latex",
    glitter: "glitter",
    latte2: "Latte Art",

    storyboard: "storyboard",

    line: "Line Art",

    foundobj: "Found Objects",
    etching: "etching",

    installation: "Installation Art",

    tattoo: "tattoo",
    applique: "applique",
    enameled: "enameled",
    jewelry: "jewelry",
    azulejo: "azulejo",

    goldleaf: "goldleaf",
    lacquer: "lacquer",

    isotype: "Isotype",
    reliefcarving: "Relief Carving",
    religiousart: "Religious Art",
  },

  fabricmediums: {
    quilt: "quilt",
    lace: "lace",
    embroidery: "embroidery",
    macrame: "macrame",
    knitted: "knitted",
    rug: "rug",
    weave: "weave",
    cashmere: "Cashmere",
    cotton: "Cotton",
    denim: "Denim",
    felted: "felted",
    pincushion: "Pincushion",
    crochet: "crochet",
    lurex: "Lurex",
    pillow: "Pillow",
    carpet: "Carpet",
    cushion: "Cushion",
    blanket: "Blanket",
    twine: "Twine",
    velvet: "Velvet",
    spandex: "Spandex",
    rayon: "Rayon",
    kevlar: "Kevlar",
    linen: "Linen",
    nylon: "Nylon",
    memoryfoam: "Memory Foam",
    crossstitch: "cross stitch",
    crewl: "crewl",
    needlepoint: "needlepoint",
    patch: "patch",
  },

  photographicmediums: {
    stopmotion: "stopmotion",
    photoshoot: "photoshoot",
    gopro: "gopro",
    trailcam: "trailcam",
    dashcam: "dashcam",
  },

  digitalmediums: {
    digitalArt: "digitalArt",
    pixel2: "pixel Art",
    anime: "anime",
    texture: "texture",
    fractal: "fractal",
    algo: "Algorithmic",
    datamosh: "Data Moshing",
    dynamic: "Dynamic Painting",
    n3dmodel: "3D Model",
    logo: "logo",
    icon: "icon",
    digitalphotography: "Digital Photography",
    vector: "Vector Art",
    tilemap: "tilemap",
    mspaint: "Microsoft Paint",
    raster: "Raster Art",
    geometric: "geometric",
    photoshop: "photoshop",
    isometric: "isometric",
    depthmap: "Depth Map",
    animation: "animation",
    wireframe: "Wireframe",
    lowpoly: "Low-Poly",
    bitmap: "Bitmap",
    meme: "Meme",
    nft: "NFT",
    ascii: "ASCII",
    clipart: "Clipart",
    procedural: "Procedural",
    stockphoto: "Stock Photo",
  },
};

export const PHYSICALMEDIUMS_DESC = {
  drawingtypes: {
    illustration: "illustration",
    drawing: "Drawing",
    doodle: "Doodle",
    handdrawn: "Hand-Drawn",
    childrensdrawing: "Childrens Drawing",
    masterpiece: "Masterpiece",
    dotart: "Dot Art",
    pointillism: "Pointillism",
    stipple: "Stipple",
    lineart: "Line Art",
    crosshatch: "Crosshatch",
    figuredrawing: "Figure drawing",
    storybookillustration: "Storybook Illustration",
    illustratedbooklet: "Illustrated Booklet",
    assemblydrawing: "Assembly Drawing",
    visualnovel: "Visual Novel",
    graphicnovel: "Graphic Novel",
    cartographic: "Cartographic",
    illumanu: "Illuminated Manuscript",
    anatomical: "Anatomical Drawing",
  },
  pencilmediums: {
    charcoal: "charcoal",
    graphitePencil: "graphite Pencil",
    colorPencil: "color Pencil",
  },
  penmediums: {
    ballpointpen: "Ballpoint Pen",
    fountainpen: "Fountain Pen",
    gelpen: "Gel Pen",
    dryerasemarker: "Dry-Erase Marker",
    weterasemarker: "Wet-Erase Marker",
    whiteboard: "Whiteboard",
    inkPen: "Ink and Pen",
    calligraphy: "calligraphy",
    inkpainting: "inkpainting",
    marker: "marker",
  },

  crayonchalkmediums: {
    chalk: "Chalk Art",
    conte: "conte",
    pastel: "Pastel  Art",
    crayon: "crayon",
  },

  paintmediums: {
    painting: "Painting",
    hardedgepainting: "Hard Edge Painting",
    detailedpainting: "Detailed Painting",
    speedpainting: "Speedpainting",
    fauxpainting: "Faux Painting",
    colorfieldpainting: "Color Field Painting",
    stilllife: "Still-Life",
    scrollpainting: "Scroll Painting",
    fineart: "Fine Art",
    modernart: "Modern Art",
    brushwork: "Brushwork",
    chinesepainting: "Chinese Painting",
    tibetanpainting: "Tibetan Painting",
    japanesepainting: "Japanese Painting",
    koreanpainting: "Korean Painting",
    papermarbling: "Paper-Marbling",
    hydrodipping: "Hydro-Dipping",
    hydrodipped: "Hydrodipped",
    artwork: "Artwork",
    mural: "Mural",
    streetart: "Street Art",
    caveart: "Cave Art",
    rockart: "Rock Art",
    sandpainting: "Sandpainting",
    easteregg: "Easter Egg",
    eggdecorating: "Egg Decorating",
    oilPainting: "oil Painting",
    glassPaint: "glass Paint",
    watercolor: "Watercolor Art",
    tempera: "Tempera Art",
    goache: "Goache Art",
    sprayPaint: "sprayPaint",
    airbrush: "airbrush",
  },
  textmediums: {
    text: "Text",
    typeface: "Typeface",
    font: "Font",
    letters: "Letters",
    writtenletters: "Written Letters",
    writtenlettersteapot: "Written Letters 'Teapot'",
    writtenwords: "Written Words",
    writtenwordsteapot: "Written Words 'Teapot'",
    words: "Words",
    wordsteapot: "Words 'Teapot'",
    lexemes: "Lexemes",
    lexemesteapot: "Lexemes 'Teapot'",
    graphmes: "Graphemes",
    says: "Says",
    saysteapot: "Says Teapot",
    caption: "Caption",
    captionteapot: "Caption 'Teapot'",
  },

  printedmediums: {
    businesscard: "Buisness Card",
    booklet: "Booklet",
    popupbook: "Pop-up Book",
    instructionmanual: "Instruction Manual",
    ikeaguide: "IKEA Guide",
    legoinstructionguide: "Lego Instruction Manual",
    poster: "Poster",
    movieposter: "Movie Poster",
    concertposter: "Concert Poster",
    photocollage: "Photocollage",
    fotocollage: "Fotocollage",
    risograph: "Risograph",
    viscosityprint: "Viscosity Print",
    transferprint: "Transfer Printing",
    flexography: "Flexography",
    baghprint: "Bagh Print",
    bagruprint: "Bagru Print",
    drypoint: "Drypoint",
    metalcut: "Metalcut",
    blueprint: "Blueprint",
    sticker: "Sticker",
    diecutsticker: "Die-cut sticker",
    watermark: "Watermark",
    barcode: "Barcode",
    qrcode: "QR Code",
    pokemon: "Pokemon",
    pokemoncard: "Pokemon Card",
    pokmon: "Pokémon",
    pokmoncard: "Pokémon Card",
    blueprint2: "blueprint",
    concept: "Concept Art",
    collage: "collage",
    block: "Block Printing",
    prop: "Propaganda Poster",
    sears: "Sears Catalog",
    prod: "Product Photo",
    elecPhoto: "Election Photo",
    elecPoster: "Election Poster",
    screen: "Screen Painting",
    mono: "Mono Printing",
    litho: "Lithography",
    scroll: "scroll",
    stamp: "stamp",
    scientificdiagram: "Scientific Diagram",
    magazine: "magazine",
    ad: "Advertisement",
    postage: "postage",
    woodblock: "Wood Block Print",
    newspaper: "Newspaper",
  },
  physicalmediums: {
    origami: "Origami",
    rigidorigami: "Rigid Origami",
    kirigami: "Kirigami",
    moneygami: "Moneygami",
    wetfolding: "Wet-Folding",
    irisfolding: "Iris-Folding",
    chinesepaperfolding: "Chinese Paper Art",
    sonobe: "Sonobe",
    mosaic: "Mosaic",
    micromosaic: "Micromosaic",
    glassmosaic: "Glass Mosaic",
    photographicmosaic: "Photographic Mosaic",
    impressionistmosaic: "Impressionist Mosaic",
    pietradura: "Pietra Dura",
    encaustictile: "Encaustic Tile",
    frame: "Frame",
    framed: "Framed",
    woodenframe: "Wooden Frame",
    woodenframed: "Wooden Framed",
    banner: "Banner",
    signage: "Signage",

    carving: "Carving",
    pyrography: "Pyrography",
    modeling: "Modeling",
    model: "Model",
    whittling: "Whittling",
    woodcarving: "Wood-Carving",
    woodturning: "Woodturning",
    chipcarving: "Chip-Carving",
    chipwork: "Chip-Work",
    bentwood: "Bentwood",
    intarsia: "Intarsia",
    marquetry: "Marquetry",
    woodmarquetry: "Wood Marquetry",
    strawmarquetry: "Straw Marquetry",
    scrimshaw: "Scrimshaw",
    sgraffito: "Sgraffito",
    hardstonecarving: "Hardstone Carving",
    leathercrafting: "Leather Crafting",
    bejeweled: "Bejeweled",
    engravedgem: "Engraved Gem",
    lapidary: "Lapidary",
    icecarving: "Ice-Carving",
    intaglio: "Intaglio",
    carvedlacquer: "Carved Lacquer",
    papercutting: "Papercutting ",
    papermodel: "Paper Model ",
    papermache: "Paper-Mache",
    stringart: "String-Art",
    fretwork: "Fretwork",
    card: "Card",
    mezzotint: "Mezzotint",
    aquatint: "Aquatint",
    linocut: "Linocut",
    balloonmodelling: "Balloon Modelling ",
    balloontwisting: "Balloon Twisting ",
    oshibana: "Oshibana",
    circuit: "Circuit",
    circuitry: "Circuitry",
    lithophane: "Lithophane",
    figurine: "Figurine",

    overglaze: "Overglaze",
    inglaze: "Inglaze",
    saltglazepottery: "Salt Glaze Pottery",
    tinglazedpottery: "Tin-Glazed Pottery",
    cameoglass: "Cameo Glass",
    enameledglass: "Enameled Glass",
    paleolithicpottery: "Paleolithic Pottery",
    neolithicpottery: "Neolithic Pottery",
    earthenware: "Earthenware",
    stoneware: "Stoneware",
    slipware: "Slipware",
    chintzware: "Chintzware",
    agateware: "Agateware",
    lustreware: "Lustreware",
    bonecarving: "Bone Carving",
    ornament: "Ornament",
    lightart: "Light Art",
    lightpainting: "Light Painting",
    light_painting: "Lightpainting",
    projectionmapping: "Projection Mapping",
    artsandcrafts: "Arts and Crafts",
    resin: "Resin",
    enamelpin: "Enamel Pin",
    beadwork: "Beadwork",
    beadsandstring: "Beads and String",
    beadsandyarn: "Beads and Yarn",
    stickerbomb: "Sticker Bomb",
    coffeestain: "Coffee Stain",
    smokeart: "Smoke Art",
    hedgetrimming: "Hedge Trimming",
    sitespecificart: "Site-Specific art",
    publicart: "Public Art",
    ironwork: "Ironwork",
    carpentry: "Carpentry",
    jigsaw: "Jigsaw",
    puzzle: "Puzzle",
    maze: "Maze",
    toy: "Toy",
    diorama: "Diorama",
    shoe: "Shoe",
    shoes: "Shoes",
    hat: "Hat",
    hatmaking: "Hatmaking",

    balloon: "Balloon",
    gildedframe: "Gilded Frame",
    gildedframed: "Gilded Framed",
    glassetching: "Glass Etching",
    glaze: "Glaze",
    mixedmedia: "Mixed Media",
    negativespace: "Negative Space",
    outlined: "Outlined",
    stencil: "Stencil",

    base: "",
    sketch: "sketch",
    acrylic: "acrylic",
    latex: "latex",
    glitter: "glitter",
    latte2: "Latte Art",

    storyboard: "storyboard",

    line: "Line Art",

    foundobj: "Found Objects",
    etching: "etching",

    installation: "Installation Art",

    tattoo: "tattoo",
    applique: "applique",
    enameled: "enameled",
    jewelry: "jewelry",
    azulejo: "azulejo",

    goldleaf: "goldleaf",
    lacquer: "lacquer",

    isotype: "Isotype",
    reliefcarving: "Relief Carving",
    religiousart: "Religious Art",
  },

  fabricmediums: {
    quilt: "quilt",
    lace: "lace",
    embroidery: "embroidery",
    macrame: "macrame",
    knitted: "knitted",
    rug: "rug",
    weave: "weave",
    cashmere: "Cashmere",
    cotton: "Cotton",
    denim: "Denim",
    felted: "felted",
    pincushion: "Pincushion",
    crochet: "crochet",
    lurex: "Lurex",
    pillow: "Pillow",
    carpet: "Carpet",
    cushion: "Cushion",
    blanket: "Blanket",
    twine: "Twine",
    velvet: "Velvet",
    spandex: "Spandex",
    rayon: "Rayon",
    kevlar: "Kevlar",
    linen: "Linen",
    nylon: "Nylon",
    memoryfoam: "Memory Foam",
    crossstitch: "cross stitch",
    crewl: "crewl",
    needlepoint: "needlepoint",
    patch: "patch",
  },

  photographicmediums: {
    stopmotion: "stopmotion",
    photoshoot: "photoshoot",
    gopro: "gopro",
    trailcam: "trailcam",
    dashcam: "dashcam",
  },

  digitalmediums: {
    digitalArt: "digitalArt",
    pixel2: "pixel Art",
    anime: "anime",
    texture: "texture",
    fractal: "fractal",
    algo: "Algorithmic",
    datamosh: "Data Moshing",
    dynamic: "Dynamic Painting",
    n3dmodel: "3D Model",
    logo: "logo",
    icon: "icon",
    digitalphotography: "Digital Photography",
    vector: "Vector Art",
    tilemap: "tilemap",
    mspaint: "Microsoft Paint",
    raster: "Raster Art",
    geometric: "geometric",
    photoshop: "photoshop",
    isometric: "isometric",
    depthmap: "Depth Map",
    animation: "animation",
    wireframe: "Wireframe",
    lowpoly: "Low-Poly",
    bitmap: "Bitmap",
    meme: "Meme",
    nft: "NFT",
    ascii: "ASCII",
    clipart: "Clipart",
    procedural: "Procedural",
    stockphoto: "Stock Photo",
  },
};

export const MATERIALS = {
  metals: {
    bronze: "Bronze",
    rust: "Rust",
    rosegold: "Rose Gold",
    damascussteel: "Damascus Steel",
    chrome: "Chrome",
    anodizedtitanium: "Anodized Titanium",
    brushedaluminum: "Brushed Aluminum",
    metal: "Metal",
    pewter: "Pewter",
  },
  gemsStones: {
    sand: "Sand",
    sulfur: "Sulfur",
    agate: "Agate",
    amethyst: "Amethyst",
    gravel: "Gravel",
    jade: "Jade",
    gemstone: "Gemstone",
    graphene: "Graphene",
    citrine: "Citrine",
    diamond: "Diamond",
    emerald: "Emerald",
    jasper: "Jasper",
    sapphire: "Sapphire",
    sceptredquartz: "Sceptred Quartz",
    rosequartz: "Rose Quartz",
    rutilatedquartz: "Rutilated Quartz",
    selenite: "Selenite",
    smokyquartz: "Smoky Quartz",
    obsidian: "Obsidian",
    onyx: "Onyx",
    opal: "Opal",
    pearl: "Pearl",
    quartz: "Quartz",
    ruby: "Ruby",
    topaz: "Topaz",
    flourite: "Flourite",
    milkyquartz: "Milky Quartz",
    lapis: "Lapis Lazuli",
    coal: "Coal",
    cobblestone: "Cobblestone",
    concrete: "Concrete",
    basalt: "Basalt",
    stone: "Stone",
    marble: "Marble",
  },
  woods: {
    plywood: "Plywood",
    cork: "Cork",
    wood: "Wood",
  },
  rubber: {
    rubber: "Rubber",
    latex: "Latex",
    balloon: "Balloon",
  },
  waterIce: {
    snowflake: "Snowflake",
    snow: "Snow",
    dryice: "Dry Ice",
    blueice: "Blue Ice",
    glacier: "Glacier",
    ice: "Ice",
    water: "Water",
    sea: "Sea",
    waterfall: "Waterfall",
    lake: "Lake",
    ocean: "Ocean",
  },
  liquids: {
    turpentine: "Turpentine",
    motoroil: "Motor Oil",
    seafoam: "Sea Foam",
    emulsion: "Emulsion",
    mineraloil: "Mineral Oil",
    lava: "Lava",
    liquid: "Liquid",
    ferrofluid: "Ferrofluid",
    gasoline: "Gasoline",
    moltenrock: "Molten Rock",
    magma: "Magma",
  },
  gelSponge: {
    gel: "Gel",
    silicagel: "Silica Gel",
    ballisticsgel: "Ballistics Gel",
    jellyfish: "Jellyfish",
    softgel: "Soft Gel",
    sponge: "Sponge",
    aerogel: "Aerogel",
    spongebob: "Spongebob",
  },
  wax: {
    paraffinwax: "Paraffin Wax",
    waxpaper: "Waxpaper",
    wax: "Wax",
    shellac: "Shellac",
    carnubawax: "Carnuba Wax",
    candeliliawax: "Candelilia Wax",
  },
  gas: {
    smoke: "Smoke",
    vapor: "Vapor",
    clouds: "Clouds",
    fog: "Fog",
    gas: "Gas",
    aerosol: "Aerosol",
  },
  organic: {
    lipid: "Lipid",
    hair: "Hair",
    zebra: "Zebra",
    feathers: "Feathers",
    fur: "Fur",
    fuzz: "Fuzz",
    bone: "Bone",
    dustbunny: "Dustbunny",
    beard: "beard",
    amber: "Amber",
    tiger: "Tiger",
    mustache: "Mustache",
    flowers: "Flowers",
    fruit: "Fruit",
    vegetation: "Vegetation",
    ivory: "Ivory",
    cells: "Cells",
  },
  energy: {
    lightning: "Lightning",
    inferno: "Inferno",
    burn: "Burn",
    plasma: "Plasma",
    fire: "Fire",
    firework: "Firework",
    electric: "Electric",
    explosion: "Explosion",
  },
  food: {
    soysauce: "Soysauce",
    tallow: "Tallow",
    wagyu: "Wagyu",
    jelly: "Jelly",
    gelatin: "Gelatin",
    steak: "Steak",
    vegetableoil: "Vegetable Oil",
    whippedcream: "Whipped Cream",
    icecream: "Ice Cream",
    macaroni: "Macaroni",
    oliveoil: "Olive Oil",
    butter: "Butter",
    candy: "Candy",
    agaragar: "Agar Agar",
    weddingcake: "Wedding Cake",
    maplesyrup: "Maple Syrup",
    mayonaise: "Mayonaise",
    syrup: "Syrup",
    cream: "Cream",
    hyperrealisticcake: "Hyperrealistic Cake",
    cakedecoration: "Cake Decoration",
    churros: "Churros",
    cake: "Cake",
    sourcream: "Sour Cream",
    pretzel: "Pretzel",
    sauce: "Sauce",
    musterd: "Mustard",
    pastasauce: "Pasta Sauce",
    bread: "Bread",
    ketchup: "Ketchup",
    bakedbeans: "Baked Beans",
    beans: "Beans",
    caramel: "Caramel",
    cinnamon: "Cinnamon",
    cheese: "Cheese",
    taffy: "Taffy",
    lolipop: "Lolipop",
    sprinkles: "Sprinkles",
    edibleink: "Edible Ink",
    egg: "Egg",
    chocolate: "Chocolate",
    shortcrust: "Shortcrust Pastery",
    puffpastery: "Puff Pastery",
    flakypastery: "Flaky Pastery",
    royalicing: "Royal Icing",
    fondanticing: "Fondant Icing",
    nonpareils: "Nonpareils",
    honeycomb: "Honeycomb",
    eclair: "Eclair",
    cremebrule: "Cremebrule",
    tea: "Tea",
    toothpaste: "Toothpaste",
    plant: "Plant",
    soda: "Soda",
    fruittart: "Fruit Tart",
    moleculargastronomy: "Molecular Gastronomy",
    canoli: "Canoli",
    coffee: "Coffee",
    deepfried: "Deep Fried",
    gum: "Gum",
  },
  plantFungi: {
    vines: "Vines",
    pinecones: "Pinecones",
    treebark: "Treebark",
    leaves: "Leaves",
    branches: "Branches",
    grass: "Grass",
    bamboo: "Bamboo",
    acorns: "Acorns",
    cactus: "Cactus",
    fungi: "Fungi",
    haybale: "Hay-bale",
    hemp: "Hemp",
    moss: "Moss",
    straw: "Straw-bale",
    thatch: "Thatch",
    clathrusruber: "Clathrus Ruber",
    amanitamuscaria: "Amanitamus Caria",
    entolomahochstetteri: "Entoloma Hochstetteri",
    hay: "Hay",
    mold: "Mold",
    mushrooms: "Mushrooms",
    mycelium: "Mycelium",
    laticedstinkhorn: "Latticed Stinkhorn",
  },
  instruments: {
    accordian: "Accordian",
    bagpipes: "Bagpipes",
    guitar: "Guitar",
    harp: "Harp",
    piano: "Piano",
    saxophone: "Saxophone",
    seashell: "Seashell",
    trumpet: "Trumpet",
    violin: "Violin",
  },
  glue: {
    tape: "Tape",
    packingtape: "Packing Tape",
    ducttape: "Duct Tape",
    maskingtape: "Masking Tape",
    kaptontape: "Kapton Tape",
    postertack: "Poster Tack",
  },
  plasticFoams: {
    polymer: "Polymer",
    teflon: "Teflon",
    rubber: "Rubber",
    rubberband: "Rubber Band",
    silicone: "Silicone",
    foam: "Foam",
    polyethylene: "Polyethylene",
    plastic: "Plastic",
    polyvinyl: "Polyvinyl",
    polyurethane: "Polyurethane",
    plasticwrap: "Plastic Wrap",
    lego: "lego",
    styrofoam: "styrofoam",
    ballisticsfoam: "Ballistics Foam",
  },
  materials: {
    //v3
    cage: "Cage",
    bracelet: "Bracelet",
    cheesegrater: "Cheese Grater",
    hurricane: "Hurricane",
    toilet: "Toilet",
    slinky: "Slinky",
    flubber: "Flubber",
    putty: "Putty",
    slime: "Slime",
    orbeez: "Orbeez",
    powder: "Powder",
    oobleck: "Oobleck",
    trash: "Trash",
    wires: "Wire",
    googlyeyes: "Googly Eyes",
    Inlay: "Inlay",
    soap: "Soap",
    diodes: "Diodes",
    cables: "Cables",
    breadboard: "Breadboard",
    transistor: "Transistor",
    circuits: "Circuits",
    circuitboard: "Circuit Boards",
    lipstick: "Lip Stick",
    //v2
    mirror: "Mirror",
    seaglass: "Seaglass",
    glass: "Glass",
    stainedGlass: "Stained Glass",
    carbonfiber: "Carbon Fiber",
    boneChina: "Bone China",
    porcelain: "Porcelain",
    pottery: "Pottery",
    paper: "Paper",
    yarn: "Yarn",
    tile: "Tile",
    origami: "Origami",
  },
};

export const MATERIALS_DESC = {
  metals: {
    bronze: "Bronze",
    rust: "Rust",
    rosegold: "Rose Gold",
    damascussteel: "Damascus Steel",
    chrome: "Chrome",
    anodizedtitanium: "Anodized Titanium",
    brushedaluminum: "Brushed Aluminum",
    metal: "Metal",
    pewter: "Pewter",
  },
  gemsStones: {
    sand: "Sand",
    sulfur: "Sulfur",
    agate: "Agate",
    amethyst: "Amethyst",
    gravel: "Gravel",
    jade: "Jade",
    gemstone: "Gemstone",
    graphene: "Graphene",
    citrine: "Citrine",
    diamond: "Diamond",
    emerald: "Emerald",
    jasper: "Jasper",
    sapphire: "Sapphire",
    sceptredquartz: "Sceptred Quartz",
    rosequartz: "Rose Quartz",
    rutilatedquartz: "Rutilated Quartz",
    selenite: "Selenite",
    smokyquartz: "Smoky Quartz",
    obsidian: "Obsidian",
    onyx: "Onyx",
    opal: "Opal",
    pearl: "Pearl",
    quartz: "Quartz",
    ruby: "Ruby",
    topaz: "Topaz",
    flourite: "Flourite",
    milkyquartz: "Milky Quartz",
    lapis: "Lapis Lazuli",
    coal: "Coal",
    cobblestone: "Cobblestone",
    concrete: "Concrete",
    basalt: "Basalt",
    stone: "Stone",
    marble: "Marble",
  },
  woods: {
    plywood: "Plywood",
    cork: "Cork",
    wood: "Wood",
  },
  rubber: {
    rubber: "Rubber",
    latex: "Latex",
    balloon: "Balloon",
  },
  waterIce: {
    snowflake: "Snowflake",
    snow: "Snow",
    dryice: "Dry Ice",
    blueice: "Blue Ice",
    glacier: "Glacier",
    ice: "Ice",
    water: "Water",
    sea: "Sea",
    waterfall: "Waterfall",
    lake: "Lake",
    ocean: "Ocean",
  },
  liquids: {
    turpentine: "Turpentine",
    motoroil: "Motor Oil",
    seafoam: "Sea Foam",
    emulsion: "Emulsion",
    mineraloil: "Mineral Oil",
    lava: "Lava",
    liquid: "Liquid",
    ferrofluid: "Ferrofluid",
    gasoline: "Gasoline",
    moltenrock: "Molten Rock",
    magma: "Magma",
  },
  gelSponge: {
    gel: "Gel",
    silicagel: "Silica Gel",
    ballisticsgel: "Ballistics Gel",
    jellyfish: "Jellyfish",
    softgel: "Soft Gel",
    sponge: "Sponge",
    aerogel: "Aerogel",
    spongebob: "Spongebob",
  },
  wax: {
    paraffinwax: "Paraffin Wax",
    waxpaper: "Waxpaper",
    wax: "Wax",
    shellac: "Shellac",
    carnubawax: "Carnuba Wax",
    candeliliawax: "Candelilia Wax",
  },
  gas: {
    smoke: "Smoke",
    vapor: "Vapor",
    clouds: "Clouds",
    fog: "Fog",
    gas: "Gas",
    aerosol: "Aerosol",
  },
  organic: {
    lipid: "Lipid",
    hair: "Hair",
    zebra: "Zebra",
    feathers: "Feathers",
    fur: "Fur",
    fuzz: "Fuzz",
    bone: "Bone",
    dustbunny: "Dustbunny",
    beard: "beard",
    amber: "Amber",
    tiger: "Tiger",
    mustache: "Mustache",
    flowers: "Flowers",
    fruit: "Fruit",
    vegetation: "Vegetation",
    ivory: "Ivory",
    cells: "Cells",
  },
  energy: {
    lightning: "Lightning",
    inferno: "Inferno",
    burn: "Burn",
    plasma: "Plasma",
    fire: "Fire",
    firework: "Firework",
    electric: "Electric",
    explosion: "Explosion",
  },
  food: {
    soysauce: "Soysauce",
    tallow: "Tallow",
    wagyu: "Wagyu",
    jelly: "Jelly",
    gelatin: "Gelatin",
    steak: "Steak",
    vegetableoil: "Vegetable Oil",
    whippedcream: "Whipped Cream",
    icecream: "Ice Cream",
    macaroni: "Macaroni",
    oliveoil: "Olive Oil",
    butter: "Butter",
    candy: "Candy",
    agaragar: "Agar Agar",
    weddingcake: "Wedding Cake",
    maplesyrup: "Maple Syrup",
    mayonaise: "Mayonaise",
    syrup: "Syrup",
    cream: "Cream",
    hyperrealisticcake: "Hyperrealistic Cake",
    cakedecoration: "Cake Decoration",
    churros: "Churros",
    cake: "Cake",
    sourcream: "Sour Cream",
    pretzel: "Pretzel",
    sauce: "Sauce",
    musterd: "Mustard",
    pastasauce: "Pasta Sauce",
    bread: "Bread",
    ketchup: "Ketchup",
    bakedbeans: "Baked Beans",
    beans: "Beans",
    caramel: "Caramel",
    cinnamon: "Cinnamon",
    cheese: "Cheese",
    taffy: "Taffy",
    lolipop: "Lolipop",
    sprinkles: "Sprinkles",
    edibleink: "Edible Ink",
    egg: "Egg",
    chocolate: "Chocolate",
    shortcrust: "Shortcrust Pastery",
    puffpastery: "Puff Pastery",
    flakypastery: "Flaky Pastery",
    royalicing: "Royal Icing",
    fondanticing: "Fondant Icing",
    nonpareils: "Nonpareils",
    honeycomb: "Honeycomb",
    eclair: "Eclair",
    cremebrule: "Cremebrule",
    tea: "Tea",
    toothpaste: "Toothpaste",
    plant: "Plant",
    soda: "Soda",
    fruittart: "Fruit Tart",
    moleculargastronomy: "Molecular Gastronomy",
    canoli: "Canoli",
    coffee: "Coffee",
    deepfried: "Deep Fried",
    gum: "Gum",
  },
  plantFungi: {
    vines: "Vines",
    pinecones: "Pinecones",
    treebark: "Treebark",
    leaves: "Leaves",
    branches: "Branches",
    grass: "Grass",
    bamboo: "Bamboo",
    acorns: "Acorns",
    cactus: "Cactus",
    fungi: "Fungi",
    haybale: "Hay-bale",
    hemp: "Hemp",
    moss: "Moss",
    straw: "Straw-bale",
    thatch: "Thatch",
    clathrusruber: "Clathrus Ruber",
    amanitamuscaria: "Amanitamus Caria",
    entolomahochstetteri: "Entoloma Hochstetteri",
    hay: "Hay",
    mold: "Mold",
    mushrooms: "Mushrooms",
    mycelium: "Mycelium",
    laticedstinkhorn: "Latticed Stinkhorn",
  },
  instruments: {
    accordian: "Accordian",
    bagpipes: "Bagpipes",
    guitar: "Guitar",
    harp: "Harp",
    piano: "Piano",
    saxophone: "Saxophone",
    seashell: "Seashell",
    trumpet: "Trumpet",
    violin: "Violin",
  },
  glue: {
    tape: "Tape",
    packingtape: "Packing Tape",
    ducttape: "Duct Tape",
    maskingtape: "Masking Tape",
    kaptontape: "Kapton Tape",
    postertack: "Poster Tack",
  },
  plasticFoams: {
    polymer: "Polymer",
    teflon: "Teflon",
    rubber: "Rubber",
    rubberband: "Rubber Band",
    silicone: "Silicone",
    foam: "Foam",
    polyethylene: "Polyethylene",
    plastic: "Plastic",
    polyvinyl: "Polyvinyl",
    polyurethane: "Polyurethane",
    plasticwrap: "Plastic Wrap",
    lego: "lego",
    styrofoam: "styrofoam",
    ballisticsfoam: "Ballistics Foam",
  },
  materials: {
    //v3
    cage: "Cage",
    bracelet: "Bracelet",
    cheesegrater: "Cheese Grater",
    hurricane: "Hurricane",
    toilet: "Toilet",
    slinky: "Slinky",
    flubber: "Flubber",
    putty: "Putty",
    slime: "Slime",
    orbeez: "Orbeez",
    powder: "Powder",
    oobleck: "Oobleck",
    trash: "Trash",
    wires: "Wire",
    googlyeyes: "Googly Eyes",
    Inlay: "Inlay",
    soap: "Soap",
    diodes: "Diodes",
    cables: "Cables",
    breadboard: "Breadboard",
    transistor: "Transistor",
    circuits: "Circuits",
    circuitboard: "Circuit Boards",
    lipstick: "Lip Stick",
    //v2
    mirror: "Mirror",
    seaglass: "Seaglass",
    glass: "Glass",
    stainedGlass: "Stained Glass",
    carbonfiber: "Carbon Fiber",
    boneChina: "Bone China",
    porcelain: "Porcelain",
    pottery: "Pottery",
    paper: "Paper",
    yarn: "Yarn",
    tile: "Tile",
    origami: "Origami",
  },
};

export const STYLES = {
  renderers: {
    pbr: "Physicality-based render",
    mentalray: "MentalRay",
    opengl: "OpenGL",
    directx: "DirectX",
    luxcore: "Luxcore",
    infinid: "Infini-D",
    zbrush: "Z-Brush",
    blender: "Blender",
    vray: "V-Ray",
    cryengine: "CryEngine",
    optix: "Optix",
    raylectron: "Raylectron",
    cinema4d: "Cinema4D",
    houdini: "Houdini",
    cycles: "Cycles",
    eevee: "Eevee",
    octane: "Octane",
    unreal: "Unreal",
    unity: "Unity",
  },
  photosites: {
    trendingpixiv: "Trending On Pixiv",
    pixiv: "Pixiv",
    trendingartstation: "Trending On Artstation",
    artstation: "Artstation",
    cgsociety: "CGsociety",
    trendingcgsociety: "Trending On CGsociety",
    unsplash: "Unsplash",
    trendingunsplash: "Trending On Unsplash",
    deviantart: "Deviantart",
    trendingdeviantart: "Trending On Deviantart",
    flickr: "Flickr",
    trendingflickr: "Trending On Flickr",
    quixel: "Quixel",
    trendingquixel: "Trending On Quixel",
    googlemaps: "Google Maps",
  },
  abstraction: {
    abstract: "Abstract",
    americanrealism: "American Realism",
    classicalrealism: "Classical Realism",
    dreamlike: "Dreamlike",
    ethereal: "Ethereal",
    fantasyrealism: "Fantasy Realism",
    hyperrealistic: "Hyperrealistic",
    impossible: "Impossible",
    lucid: "Lucid",
    lyricalabstraction: "Lyrical Abstraction",
    newrealism: "New Realism",
    otherworldly: "Otherworldly",
    realism: "Realism",
    realistic: "Realistic",
    socialistrealism: "Socialist Realism",
    surreal: "Surreal",
  },
  timeframes: {
    n2070s: "2070s",
    n2060s: "2060s",
    n2050s: "2050s",
    n2040s: "2040s",
    n2030s: "2030s",
    n2020s: "2020s",
    n2010s: "2010s",
    n2000s: "2000s",
    n1990s: "1990s",
    n1980s: "1980s",
    n1970s: "1970s",
    n1960s: "1960s",
    n1950s: "1950s",
    n1940s: "1940s",
    n1930s: "1930s",
    n1920s: "1920s",
    n1910s: "1910s",
    n1900s: "1900s",
    n1850s: "1850s",
    n1800s: "1800s",
    n1750s: "1750s",
    n1700s: "1700s",
    n1600s: "1600s",
    n1500s: "1500s",
    n1400s: "1400s",
    n1300s: "1300s",
    n1200s: "1200s",
    n1100s: "1100s",
    n1000s: "1000s",
  },
  complexity: {
    flatshading: "Flat Shading",
    ukiyoeflat: "Ukiyo-E Flat",
    flatdesign: "Flat Design",
    flat: "Flat",
    intricatemaximalist: "Intricate Maximalist",
    minimalist: "Minimalist",
    greeble: "Greeble",
    incoherent: "Incoherent",
    surfacedetail: "Surface Detail",
    intricate: "Intricate",
    chaotic: "Chaotic",
    confusing: "Confusing",
    basic: "Basic",
    detailed: "Detailed",
    hyperdetailed: "Hyper-Detailed",
    simple: "Simple",
    complex: "Complex",
  },
  punkstyles: {
    steampunk: "Steampunk",
    cyberpunk: "Cyberpunk",
    solarpunk: "Solarpunk",
    steelpunk: "Steelpunk",
    bronzepunk: "Bronzepunk",
    dieselpunk: "Dieselpunk",
    piedieselpunk: "Piecraftian dieselpunk",
    ottodieselpunk: "Ottensian dieselpunk",
    decopunk: "Decopunk",
    atompunk: "Atompunk",
    biopunk: "Biopunk",
    cuberpunk: "Cuberpunk",
    postcyberpunk: "Postcyberpunk",
    cybernoir: "Cybernoir",
    clockpunk: "Clockpunk",
    formicapunk: "Formicapunk",
  },

  wavestyles: {
    synthwave: "Synthwave",
    vaporwave: "Vaporwave",
    retrowave: "Retrowave",
    futurefunk: "Futurefunk",
    outrun: "Outrun",
  },
};

export const STYLES_DESC = {
  renderers: {
    pbr: "A rendering technique that simulates the way light interacts with real-world materials, creating highly detailed and realistic visuals. Often used in games, films and architectural visualization to create photorealistic environments and objects.",
    mentalray:
      "A powerful, physically based renderer that allows for the creation of highly detailed and realistic images and animations. It has been used in many films and architectural visualization projects to create stunning visual effects.",
    opengl:
      "A widely-used, cross-platform graphics API that enables developers to create 2D and 3D graphics for a variety of applications. It has a long history of being used in video games and other interactive applications, and is still widely supported today.",
    directx:
      "A collection of APIs developed by Microsoft for creating and managing multimedia and gaming applications on Windows and Xbox platforms. It is widely used in the game industry, and has become the standard for developing games on the Windows platform.",
    luxcore:
      "LuxCore: An open-source, physically-based renderer that aims to provide a real-world workflow for creating photorealistic renders. It is known for its simple and intuitive user interface, and its ability to create highly detailed and realistic images.",
    infinid:
      "A 3D animation and modeling software that was widely used during the late 90s and early 2000s, known for its powerful modeling tools and its ability to create detailed animations. It was commonly used in the film and television industry for creating visual effects and animation.",
    zbrush:
      "A digital sculpting and painting software that is widely used in the game and film industries to create highly detailed 3D models. It allows artists to sculpt and paint highly detailed models in a way that is similar to traditional sculpting and painting.",
    blender:
      "An open-source, cross-platform 3D content creation software that is widely used in the animation, film, and game industries. It offers a wide range of features including modeling, animation, texturing, and compositing, and is known for its powerful and flexible workflow.",
    vray: "A highly advanced, physically-based renderer that is widely used in the architectural, industrial, and media & entertainment industries. It provides a wide range of features for creating highly detailed, realistic images and animations, and is known for its ability to handle large and complex scenes.",
    cryengine:
      "A game engine that is known for its advanced features, such as its powerful physics engine, real-time rendering capabilities and its ability to create large, open-world environments. It is widely used in the game industry for creating immersive and realistic games.",
    optix:
      "A high-performance, real-time rendering engine developed by NVIDIA. It is known for its ability to efficiently render large, complex scenes and its support for advanced features such as global illumination and deep learning-based denoising.",
    raylectron:
      "A plugin for SketchUp that allows users to create photorealistic renders of their SketchUp models. It is known for its simple and intuitive workflow, and its ability to produce high-quality renders in a short amount of time.",
    cinema4d:
      "A 3D animation, modeling and rendering software that is widely used in the film, television and motion graphics industry. It is known for its powerful modeling, animation, and rendering capabilities, as well as its intuitive and user-friendly interface.",
    houdini:
      "An animation software that is widely used in the film, television and game industry. It is known for its powerful procedural workflows and its ability to handle large and complex scenes, as well as its ability to create realistic simulations of physical phenomena such as fluid dynamics and particle effects.",
    cycles:
      "A rendering engine that is built into the Blender 3D software. It is a path-tracing renderer which simulates the way light behaves in the real world, creating highly detailed and realistic images. It is known for its ability to handle complex materials, lighting and motion blur, and it's capability to work with CPU and GPU.",
    eevee:
      "A real-time rendering engine built into Blender, that is optimized for real-time visualization and fast-paced workflow, allowing for interactive viewport playback and real-time lighting and shading. It is a physically based renderer and it's known for its ability to create photorealistic results in real-time.",
    octane:
      "A standalone GPU renderer that uses the NVIDIA CUDA technology to create highly detailed, photorealistic images and animations. It is known for its ability to handle large, complex scenes and its support for advanced features such as global illumination, motion blur and deep learning-based denoising.",
    unreal:
      "A game engine developed by Epic Games that is widely used in the game industry for creating immersive, high-fidelity games. It is known for its powerful real-time rendering capabilities, physics engine and its support for a wide range of platforms.",
    unity:
      "A cross-platform game engine that is widely used in the game industry for creating 2D, 3D, AR, and VR games and experiences. It is known for its powerful rendering capabilities, asset management tools and its support for a wide range of platforms, including mobile, desktop and console.",
  },
  photosites: {
    trendingpixiv:
      '"Trending On Pixiv" is a website that showcases popular artwork and illustrations shared on the Pixiv platform. It is a great way to discover new artists and see what styles and trends are currently popular among the community.',
    pixiv:
      "Pixiv is a website that allows users to share and discover artwork, illustrations, and comics. It is a popular platform for artists to share their work and get feedback, and it has a wide variety of styles and genres represented.",
    trendingartstation:
      '"Trending On Artstation" is a website that features popular artwork and illustrations shared on the Artstation platform. It is a great way to discover new artists and see what styles and trends are currently popular among the community.',
    artstation:
      "Artstation is a website that allows users to share and discover artwork, illustrations, and comics. It is a popular platform for artists to share their work and get feedback, and it has a wide variety of styles and genres represented.",
    cgsociety:
      '"CGsociety" is a website that is dedicated to computer graphics, digital art and animation. It is a platform where artists and professionals can share their work, collaborate, and learn from each other, it is also a community of over a million digital artists.',
    trendingcgsociety:
      '"Trending On CGsociety" is a website that showcases popular digital art and animation shared on the CGsociety platform. It is a great way to discover new artists and see what styles and trends are currently popular among the community.',
    unsplash:
      '"Unsplash" is a website that provides a library of high-resolution images that can be used for free for any purpose. It is a great resource for designers, photographers, and anyone looking for beautiful, high-quality images to use in their projects.',
    trendingunsplash:
      '"Trending On Unsplash" is a website that features popular images shared on the Unsplash platform. It is a great way to discover new photographers and see what styles and trends are currently popular among the community.',
    deviantart:
      '"Deviantart" is a website that allows users to share and discover digital art, traditional art, photography, and other forms of creativity. It is a platform for artists of all skill levels to share their work and get feedback, and it has a wide variety of styles and genres represented.',
    trendingdeviantart:
      '"Trending On Deviantart" is a website that showcases popular artwork and photographs shared on the Deviantart platform. It is a great way to discover new artists and see what styles and trends are currently popular among the community.',
    flickr:
      '"Flickr" is a website that is a platform for photography, it allows users to share, organize, and discover their photos. It is a community of photographers from around the world, and it has a wide variety of styles and genres represented.',
    trendingflickr:
      '"Trending On Flickr" is a website that features popular photographs shared on the Flickr platform. It is a great way to discover new photographers and see what styles and trends are currently popular among the community.',
    quixel:
      '"Quixel" is a website and software company that provides tools and services for creating and texturing 3D assets. It offers a range of products and services that help 3D artists to quickly and easily create high-quality 3D models, textures and materials.',
    trendingquixel:
      '"Trending On Quixel" is a website that showcases popular 3D models and textures shared on the Quixel platform. It is a great way to discover new artists and see what styles and trends are currently popular among the community.',
    googlemaps:
      '"Google Maps" is a web mapping service developed by Google. It offers satellite imagery, street maps, panoramic views, real-time traffic conditions, and route planning for traveling by foot, car, bicycle, or public transportation. It allows users to search for addresses, points of interest, and businesses and provides information on local businesses, including customer reviews and ratings.',
  },
  abstraction: {
    abstract:
      "A kaleidoscope of vibrant colors and shapes, swirling in a mesmerizing dance that defies the constraints of reality. A canvas for the mind, where imagination and creativity reign supreme.",
    americanrealism:
      "A gritty and raw depiction of everyday life, where the harsh realities of the world are laid bare for all to see. A mirror held up to society, reflecting the beauty and ugliness of humanity.",
    classicalrealism:
      "A masterful portrayal of the world in all its splendor, where every detail is captured with the precision and skill of a master artist. A timeless work of art that stands the test of time.",
    dreamlike:
      "A surreal and ethereal landscape, where the boundaries between reality and fantasy blur and merge. A dreamscape that captures the essence of the subconscious mind, revealing hidden truths and desires.",
    ethereal:
      "A realm of pure beauty and wonder, where the laws of physics and reality are but mere suggestions. A place where the impossible becomes possible, and the imagination is given free reign.",
    fantasyrealism:
      "A world where the fantastical and the realistic coexist in perfect harmony, where dragons fly alongside airplanes and magic and technology blend seamlessly. A place where the lines between fantasy and reality are blurred.",
    hyperrealistic:
      "A mirror image of reality, where every detail is captured in such stunning detail that it's hard to tell the difference between what is real and what is not. A world where the line between fantasy and reality disappears.",
    impossible:
      "A world where anything and everything is possible, where the laws of physics and reality are nothing more than suggestions. A place where the impossible becomes possible and the imagination is given free reign.",
    lucid:
      "A clear and crisp reality, where every detail is captured in sharp focus, and the mind is given the freedom to explore and discover. A world where the impossible becomes possible and the imagination is given free reign.",
    lyricalabstraction: "A dance of colors and shapes, swirling in a mesmerizing rhythm that defies the constraints of reality. A canvas for the mind, where imagination and creativity reign supreme.",
    newrealism:
      "A new take on the world, where the boundaries between reality and fantasy blur and merge. A dreamscape that captures the essence of the subconscious mind, revealing hidden truths and desires.",
    otherworldly:
      "A realm beyond our understanding, where the laws of physics and reality are but mere suggestions. A place where the impossible becomes possible, and the imagination is given free reign.",
    realism: "A true and accurate portrayal of the world, where every detail is captured with precision and authenticity. A mirror held up to society, reflecting the beauty and ugliness of humanity.",
    realistic:
      "A world that closely mimics our own, where the laws of physics and reality are strictly followed and every detail is captured in stunning detail. A place where the line between fantasy and reality disappears.",
    socialistrealism:
      "A form of realism that emphasizes the role of the working class and the struggle for a socialist society. A reflection of the world, where the harsh realities of the world are laid bare for all to see.",
    surreal:
      "A world that defies the constraints of reality, where the boundaries between reality and fantasy blur and merge. A dreamscape that captures the essence of the subconscious mind, revealing hidden truths and desires.",
  },
  timeframes: {
    n2070s: "The 2070s hasn't happened yet.",
    n2060s: "The 2060s hasn't happened yet.",
    n2050s: "The 2050s hasn't happened yet.",
    n2040s: "The 2040s hasn't happened yet.",
    n2030s: "The 2030s hasn't happened yet.",
    n2020s:
      "The 2020s is the current decade, it is defined by the photographic style that is being shaped by the ongoing digital revolution and the increasing use of smartphones and social media, resulting in an explosion of visual content and a democratization of photography. The photographs of this era are defined by their immediacy, and their ability to capture a moment in history.",
    n2010s:
      "The 2010s brought a new era of photographic style, with a focus on vibrant colors, sharp contrasts and digital manipulation that brought a fresh, modern feel to the art form. The photographs of this era were defined by a dynamic energy and a sense of movement, capturing the world in a way that was both fresh and exciting.",
    n2000s:
      "The photographic style of the 2000s was characterized by a minimalist aesthetic, with a focus on simplicity and clean lines. The photographs of this era were defined by their crisp, precise composition and a sense of stillness that created an almost meditative quality.",
    n1990s:
      "The 1990s brought a renewed focus on the documentary style of photography, with an emphasis on capturing real-life moments and emotions. The photographs of this era were defined by their raw, honest feel, capturing the world as it truly was with a sense of realism and authenticity.",
    n1980s:
      "The 1980s saw the rise of a new photographic style that was defined by its bold, experimental nature. The photographs of this era were defined by their use of vibrant colors, bold patterns, and a sense of playfulness that was both daring and exciting. They were a reflection of the fast-paced, dynamic world of the 1980s.",
    n1970s:
      "The 1970s brought a new era of photographic style, characterized by a focus on natural light and a sense of spontaneity. The photographs of this era were defined by their raw, unpolished feel and a sense of capturing the world in a moment of pure authenticity.",
    n1960s:
      "The photographic style of the 1960s was characterized by a focus on capturing the energy and excitement of the time, with an emphasis on capturing the movements of the counterculture. The photographs of this era were defined by their dynamic energy and a sense of capturing a moment in history.",
    n1950s:
      "The 1950s brought a renewed focus on the art of portrait photography, with an emphasis on capturing the essence of the subject. The photographs of this era were defined by their use of natural light and a sense of intimacy, capturing the subject's true nature and character.",
    n1940s:
      "The 1940s saw the rise of a new photographic style that was defined by its focus on capturing the reality of war and its aftermath. The photographs of this era were defined by their raw, honest feel and their ability to capture the true horror and devastation of war. They were a reflection of the world's darkest moments.",
    n1930s:
      "The 1930s brought a new era of photographic style, characterized by a focus on capturing the reality of everyday life. The photographs of this era were defined by their raw, honest feel and a sense of capturing the world in a moment of pure authenticity.",
    n1920s:
      "The photographic style of the 1920s was characterized by a focus on capturing the energy and excitement of the time, with an emphasis on capturing the movements of the counterculture. The photographs of this era were defined by their dynamic energy and a sense of capturing a moment in history.",
    n1910s:
      "Photography wasn't fully developed during the 1910s, however, the photography that existed during this period was defined by its focus on capturing the reality of everyday life. The photographs of this era were defined by their raw, honest feel and a sense of capturing the world in a moment of pure authenticity.",
    n1900s:
      "Photography wasn't fully developed during the 1900s, however, the photography that existed during this period was defined by its focus on capturing the reality of everyday life. The photographs of this era were defined by their raw, honest feel and a sense of capturing the world in a moment of pure authenticity.",
    n1850s:
      "Photography wasn't fully developed during the 1850s, however, the photography that existed during this period was defined by its focus on capturing the reality of everyday life. The photographs of this era were defined by their raw, honest feel and a sense of capturing the world in a moment of pure authenticity.",
    n1800s:
      "Photography wasn't fully developed during the 1800s, however, the photography that existed during this period was defined by its focus on capturing the reality of everyday life. The photographs of this era were defined by their raw, honest feel and a sense of capturing the world in a moment of pure authenticity.",
    n1750s: "Photography wasn't invented during the 1750s.",
    n1700s: "Photography wasn't invented during the 1700s.",
    n1600s: "Photography wasn't invented during the 1600s.",
    n1500s: "Photography wasn't invented during the 1500s.",
    n1400s: "Photography wasn't invented during the 1400s.",
    n1300s: "Photography wasn't invented during the 1300s.",
    n1200s: "Photography wasn't invented during the 1200s.",
    n1100s: "Photography wasn't invented during the 1100s.",
    n1000s: "Photography wasn't invented during the 1000s.",
  },
  complexity: {
    flatshading:
      'Flat Shading" is a technique where the colors and shadows are applied in a flat, 2-dimensional way, giving a simple and graphic look to the image. The best known usecase of this style is in comic books and graphic novels.',
    ukiyoeflat:
      'Ukiyo-E Flat" is a style of painting and printing that originated in Japan during the Edo period, known for its bold colors, flat shapes, and simple composition. The best known usecase of this style is in traditional Japanese woodblock prints.',
    flatdesign:
      'Flat Design" is a visual design approach that emphasizes minimalism, simplicity, and functionality. It uses flat shapes, bold colors, and clean typography to create a modern, user-friendly look. The best known usecase of this style is in modern web and mobile interface design.',
    flat: 'Flat" is a visual design approach that lacks depth, dimensionality, and texture, giving a simple and graphic look to the image. The best known usecase of this style is in minimalistic graphic design and modern art.',
    intricatemaximalist:
      'Intricate Maximalist" is a style that is characterized by its use of multiple, intricate details and a wide range of textures and colors, creating a visually rich and complex image. The best known usecase of this style is in hyper-realistic digital art and 3D animation.',
    minimalist:
      'Minimalist" is a style that emphasizes simplicity and minimalism, characterized by a pared-down aesthetic with few elements, neutral colors, and simple forms. The best known usecase of this style is in modern architecture and design.',
    greeble:
      'Greeble" is a style of 3D modeling that involves adding small, intricate details to a surface, creating a sense of depth and complexity. The best known usecase of this style is in science fiction and fantasy film and video game design.',
    incoherent:
      'Incoherent" is a style that is characterized by a lack of coherence or consistency, often involving elements that are randomly placed or disjointed. The best known usecase of this style is in experimental art and avant-garde design.',
    surfacedetail:
      'Surface Detail" is a style that emphasizes the intricate details of a surface, often creating a sense of realism and depth. The best known usecase of this style is in photorealistic digital art and 3D animation.',
      intricate: "Intricate\" is a style that is characterized by its use of multiple, detailed and complex elements, creating a visually rich and intricate image. The best known usecase of this style is in traditional art, such as calligraphy, tapestries, and carvings.",
      chaotic: "Chaotic\" is a style that is characterized by a lack of organization, symmetry, or structure, often involving random or disjointed elements. The best known usecase of this style is in abstract art and experimental design.",
      confusing: "Confusing\" is a style that is characterized by a lack of clarity or understanding, often involving elements that are difficult to interpret or make sense of. The best known usecase of this style is in conceptual art and avant-garde design.",
      basic: "Basic\" is a style that emphasizes simplicity, minimalism, and functionality, often using basic shapes, colors, and forms to create a clean and clear visual. The best known usecase of this style is in modern web and mobile interface design, and in simple infographics.",
      detailed: "Detailed\" is a style that emphasizes the intricate details and features of an image or object, creating a sense of realism and depth. The best known usecase of this style is in photorealistic digital art, and traditional art forms such as painting and sculpture.",
      hyperdetailed: "Hyper-Detailed\" is a style that goes beyond detailed and adds even more intricate details and features to an image or object, often creating a sense of overwhelming complexity. The best known usecase of this style is in highly realistic digital animation and 3D modeling.",
      simple: "Simple\" is a style that emphasizes minimalism, functionality and easy to understand, characterized by a pared-down aesthetic with few elements, neutral colors, and basic forms. The best known usecase of this style is in modern architecture and design, and simple infographics.",
      complex: "Complex\" is a style that is characterized by multiple, detailed and intricate elements, often creating a sense of depth and complexity. The best known usecase of this style is in hyper-realistic digital art, traditional art forms such as calligraphy, tapestries, and carvings.",
  },
  punkstyles: {
    steampunk: "A world of brass gears and steam-powered machines, where Victorian aesthetics meet futuristic technology. Best known in works such as 'The League of Extraordinary Gentlemen' and 'The Difference Engine'.",
cyberpunk: "A gritty, neon-lit future where technology and humanity have fused and corrupted. Best known in works such as 'Neuromancer' and 'Blade Runner'.",
solarpunk: "A utopia of sustainable technology and community-driven progress, where the power of the sun fuels a brighter future. Best known in works such as 'The Water Knife' and 'The Solarpunk Manifesto'.",
steelpunk: "A fusion of steampunk and cyberpunk, where industrial revolution and advanced technology coexist in a gritty, dystopian world. Best known in works such as 'The Iron Duke' and 'The Steel Remains'.",
bronzepunk: "A world of ancient technologies, where bronze and other metals are used in place of iron, and magic and gods exist alongside technology. Best known in works such as 'Percy Jackson and the Lightning Thief' and 'American Gods'.",
dieselpunk: "A world of machinery and technology that is reminiscent of the 1920s to 1950s. Best known in works such as 'The Sky Captain and the World of Tomorrow' and 'Iron Sky'.",
piedieselpunk: "A world where dieselpunk technology and culture is combined with elements of the fantasy world of Minecraft. Best known in works such as 'The Piedieselpunk Chronicles' and 'The Piecraftian Empire'.",
ottodieselpunk: "A world where dieselpunk technology is combined with elements of the fantasy world of the Ottensian Empire. Best known in works such as 'The Ottodieselpunk Chronicles' and 'The Ottensian Empire'.",
decopunk: "A blend of Art Deco and Retro-futuristic aesthetics, with a focus on luxury, excess and opulence. Best known in works such as 'The Great Gatsby' and 'The Artist'.",
atompunk: "A futuristic world set in the 1950s, where the threat of atomic war and the dawn of the Cold War shape society and technology. Best known in works such as 'Dr. Strangelove' and 'The Man in the High Castle'.",
biopunk: "A world where biotechnology and genetic engineering have advanced to the point of creating new forms of life and blurring the lines between human and machine. Best known in works such as 'The Windup Girl' and 'The Island'.",
cuberpunk: "A genre of science fiction that explores the use of cubes and cube-like shapes as a recurring motif in technology and architecture. Best known in works such as 'Cube' and 'Hyperion Cantos'.",
postcyberpunk: "A subgenre of science fiction that explores the aftermath of the cyberpunk era, where technology and society have evolved and the consequences of past actions are felt. Best known in works such as 'Snow Crash' and 'The Diamond Age'.",
cybernoir: "A blend of cyberpunk and film noir, where gritty, neon-lit cities are plagued by crime and corruption and the characters are often morally ambiguous. Best known in works such as 'Neuromancer' and 'Blade Runner'.",
clockpunk: "A genre of science fiction that explores the use of clockwork technology and mechanical engineering in a pre-industrial or early industrial setting. Best known in works such as 'The Anubis Gates' and 'The Prestige'.",
formicapunk: "A genre of science fiction that explores the use of ants and ant colonies as a recurring motif in technology and society. Best known in works such as 'Ender's Game' and 'The Swarm'."
  },

  wavestyles: {
    synthwave: "A genre of electronic music that evokes the nostalgia of 1980s pop culture, characterized by heavy use of synthesizers and retro futuristic visuals. Best known in works such as \"The Midnight\" and \"Kavinsky\".",
vaporwave: "A genre of electronic music that emerged in the 2010s, characterized by its heavy use of samples from 1980s and 1990s pop music and its associated visual art style. Best known in works such as \"Floral Shoppe\" and \"Eccojams Vol. 1\".",
retrowave: "A genre of electronic music that combines elements of 1980s pop culture, synthwave, and new wave. Best known in works such as \"The Midnight\" and \"FM-84\".",
futurefunk: "A genre of electronic music that combines elements of funk, disco, and futuristic imagery. Best known in works such as \"Futurecop!\" and \"Lazerhawk\".",
outrun: "A subgenre of electronic music, also known as Retro Electro, characterized by its 1980s-inspired sound, heavy use of synthesizers and nostalgic visuals. Best known in works such as \"Miami Nights 1984\" and \"Power Glove\"."
  },
};

export const CAMERA = {
  resolution: {
    n4k: "4k",
    n8k: "8k",
    n16k: "16k",
    megapixel: "Megapixel",
    n2megapixel: "2 Megapixels",
    n10megapixel: "10 Megapixels",
    n20megapixel: "20 Megapixels",
    n22megapixel: "22 Megapixels",
  },


  perspectives: {
    lowangle: "Low Angle",
    highangle: "High Angle",
    closeup: "Close Up",
    mediumshot: "Medium Shot",
    longshot: "Long Shot",
    overtheshoulder: "Over the Shoulder",
    ecloseup: "Extreme closeup",
    elongshot: "Extreme longshot",
    birdseye: "Bird's Eye",
    tiltangle: "Tilt Angle",
    dutchangle: "Dutch Angle",
    establishingshot: "Establishing Shot",
    dynamicperspective: "Dynamic Perspective",
    macro: "Macro View",
    magnification: "Magnification",
    telephoto: "Telephoto",
    overlookingaerial: "Overlooking Aerial",
  },
  lens: {
    n15mm: "15mm",
    n20mm: "20mm",
    n25mm: "25mm",
    n30mm: "30mm",
    n35mm: "35mm",
    n40mm: "40mm",
    n45mm: "45mm",
    n50mm: "50mm",
    n60mm: "60mm",
    n70mm: "70mm",
    n80mm: "80mm",
  },

  scenes: {
    photography: "Photography",
    filmic: "Filmic",
    cinematic: "Cinematic",
    dramatic: "Dramatic",
    glamorshot: "Glamor Shot",
    awardwinningphotography: "Award Winning Photography",
    portrait: "Portrait",
    paparazziphotography: "Paparazzi Photography",
    highspeedphotograph: "High-Speed Photograph",
    timelapse: "Time-Lapse",
    motioncapture: "Motion Capture",
    colorgrading: "Color Grading",
    bokeh: "Bokeh",
    photograin: "Photo Grain",
    satelliteimagery: "Satellite Imagery",
    underwaterphotography: "Underwater Photography",
    wildlifephotography: "Wildlife Photography",
    nationalgeographicphotography: "National Geographic Photography",
    editorialphotography: "Editorial Photography",
    associatedpressphoto: "Associated Press Photo",
    photojournalism: "Photojournalism",
    actionscene: "Action Scene",
    warphotography: "War Photography",
  },
  filmtypes: {
    camcordereffect: "Camcorder Effect",
    dslr: "DSLR",
    nightvision: "Night Vision",
    foodphotography: "Food Photography",
    dronephotography: "Drone Photography",
    hyperspectralimaging: "Hyperspectral Imaging",
    multispectralimaging: "Multispectral Imaging",
    schlieren: "Schlieren",
    polaroid: "Polaroid",
    ektachrome: "Ektachrome",
    fujifilmsuperia: "Fujifilm Superia",
    instax: "Instax",
    kodakektar: "Kodak Ektar",
    kodakgold200: "Kodak Gold 200",
    kodakportra: "Kodak Portra",
    nikond750: "Nikon D750",
    provia: "Provia",
    velvia: "Velvia",
    lomo: "Lomo",
    pinholephotography: "Pinhole Photography",
    cinemascope: "CinemaScope",
    tri400tx: "Tri-X 400 TX",
    illfordhp5: "Ilford HP5",
    photogram: "Photogram",
    vistavision: "VistaVision",
    technirama: "Technirama",
    techniscope: "Techniscope",
    panavision: "Panavision",
    super35: "Super-35",
    superpanavision70: "Super-Panavision-70",
    cinerama: "Cinerama",
    kinopanorama: "Kinopanorama",
    cinemiracle: "Cinemiracle",
  },
  cameratypescompanies: {
    cinemiracle: "Cinemiracle",
    cammedium: "Medium Format Camera",
    camlarge: "Large Format Camera",
    camfullframe: "Full-Frame Format Camera",
    cammediumNikon: "Medium Format Nikon",
    camlargeNikon: "Large Format Nikon",
    camfullframeNikon: "Full-Frame Format Nikon",
    cammediumSony: "Medium Format Sony",
    camlargeSony: "Large Format Sony",
    camfullframeSony: "Full-Frame Format Sony",
    cammediumFujifilm: "Medium Format Fujifilm",
    camlargeFujifilm: "Large Format Fujifilm",
    camfullframeFujifilm: "Full-Frame Format Fujifilm",
    cammediumCanon: "Medium Format Canon",
    camlargeCanon: "Large Format Canon",
    camfullframeCanon: "Full-Frame Format Canon",
    cammediumOlympus: "Medium Format Olympus",
    camlargeOlympus: "Large Format Olympus",
    camfullframeOlympus: "Full-Frame Format Olympus",
    cammediumPanasonic: "Medium Format Panasonic",
    camlargePanasonic: "Large Format Panasonic",
    camfullframePanasonic: "Full-Frame Format Panasonic",
    cammediumPentax: "Medium Format Pentax",
    camlargePentax: "Large Format Pentax",
    camfullframePentax: "Full-Frame Format Pentax",
    cammediumLeica: "Medium Format Leica",
    camlargeLeica: "Large Format Leica",
    camfullframeLeica: "Full-Frame Format Leica",
    cammediumHasselblad: "Medium Format Hasselblad",
    camlargeHasselblad: "Large Format Hasselblad",
    camfullframeHasselblad: "Full-Frame Format Hasselblad",
    cammediumKodak: "Medium Format Kodak",
    camlargeKodak: "Large Format Kodak",
    camfullframeKodak: "Full-Frame Format Kodak",
  },
  camerasettings: {
    exposure: "Exposure",
    shortexposure: "Short Exposure",
    longexposure: "Long Exposure",
    doubleexposure: "Double-Exposure",
    shutterspeed11000: "Shutter Speed 1/1000",
    shutterspeed12: "Shutter Speed 1/2",
    f2_8: "F/2.8",
    f22: "F/22",
    gamma: "Gamma",
    whitebalance: "White Balance",
  },
  othercamera: {
    lensflare: "Lens Flare",
    vignette: "Vignette",
    splittoning: "Split Toning",
  },
};

export const CAMERA_DESC = {
  resolution: {
    n4k: "4k",
    n8k: "8k",
    n16k: "16k",
    megapixel: "Megapixel",
    n2megapixel: "2 Megapixels",
    n10megapixel: "10 Megapixels",
    n20megapixel: "20 Megapixels",
    n22megapixel: "22 Megapixels",
  },


  perspectives: {
    lowangle: "Low Angle",
    highangle: "High Angle",
    closeup: "Close Up",
    mediumshot: "Medium Shot",
    longshot: "Long Shot",
    overtheshoulder: "Over the Shoulder",
    ecloseup: "Extreme closeup",
    elongshot: "Extreme longshot",
    birdseye: "Bird's Eye",
    tiltangle: "Tilt Angle",
    dutchangle: "Dutch Angle",
    establishingshot: "Establishing Shot",
    dynamicperspective: "Dynamic Perspective",
    macro: "Macro View",
    magnification: "Magnification",
    telephoto: "Telephoto",
    overlookingaerial: "Overlooking Aerial",
  },
  lens: {
    n15mm: "15mm",
    n20mm: "20mm",
    n25mm: "25mm",
    n30mm: "30mm",
    n35mm: "35mm",
    n40mm: "40mm",
    n45mm: "45mm",
    n50mm: "50mm",
    n60mm: "60mm",
    n70mm: "70mm",
    n80mm: "80mm",
  },

  scenes: {
    photography: "Photography",
    filmic: "Filmic",
    cinematic: "Cinematic",
    dramatic: "Dramatic",
    glamorshot: "Glamor Shot",
    awardwinningphotography: "Award Winning Photography",
    portrait: "Portrait",
    paparazziphotography: "Paparazzi Photography",
    highspeedphotograph: "High-Speed Photograph",
    timelapse: "Time-Lapse",
    motioncapture: "Motion Capture",
    colorgrading: "Color Grading",
    bokeh: "Bokeh",
    photograin: "Photo Grain",
    satelliteimagery: "Satellite Imagery",
    underwaterphotography: "Underwater Photography",
    wildlifephotography: "Wildlife Photography",
    nationalgeographicphotography: "National Geographic Photography",
    editorialphotography: "Editorial Photography",
    associatedpressphoto: "Associated Press Photo",
    photojournalism: "Photojournalism",
    actionscene: "Action Scene",
    warphotography: "War Photography",
  },
  filmtypes: {
    camcordereffect: "Camcorder Effect",
    dslr: "DSLR",
    nightvision: "Night Vision",
    foodphotography: "Food Photography",
    dronephotography: "Drone Photography",
    hyperspectralimaging: "Hyperspectral Imaging",
    multispectralimaging: "Multispectral Imaging",
    schlieren: "Schlieren",
    polaroid: "Polaroid",
    ektachrome: "Ektachrome",
    fujifilmsuperia: "Fujifilm Superia",
    instax: "Instax",
    kodakektar: "Kodak Ektar",
    kodakgold200: "Kodak Gold 200",
    kodakportra: "Kodak Portra",
    nikond750: "Nikon D750",
    provia: "Provia",
    velvia: "Velvia",
    lomo: "Lomo",
    pinholephotography: "Pinhole Photography",
    cinemascope: "CinemaScope",
    tri400tx: "Tri-X 400 TX",
    illfordhp5: "Ilford HP5",
    photogram: "Photogram",
    vistavision: "VistaVision",
    technirama: "Technirama",
    techniscope: "Techniscope",
    panavision: "Panavision",
    super35: "Super-35",
    superpanavision70: "Super-Panavision-70",
    cinerama: "Cinerama",
    kinopanorama: "Kinopanorama",
    cinemiracle: "Cinemiracle",
  },
  cameratypescompanies: {
    cinemiracle: "Cinemiracle",
    cammedium: "Medium Format Camera",
    camlarge: "Large Format Camera",
    camfullframe: "Full-Frame Format Camera",
    cammediumNikon: "Medium Format Nikon",
    camlargeNikon: "Large Format Nikon",
    camfullframeNikon: "Full-Frame Format Nikon",
    cammediumSony: "Medium Format Sony",
    camlargeSony: "Large Format Sony",
    camfullframeSony: "Full-Frame Format Sony",
    cammediumFujifilm: "Medium Format Fujifilm",
    camlargeFujifilm: "Large Format Fujifilm",
    camfullframeFujifilm: "Full-Frame Format Fujifilm",
    cammediumCanon: "Medium Format Canon",
    camlargeCanon: "Large Format Canon",
    camfullframeCanon: "Full-Frame Format Canon",
    cammediumOlympus: "Medium Format Olympus",
    camlargeOlympus: "Large Format Olympus",
    camfullframeOlympus: "Full-Frame Format Olympus",
    cammediumPanasonic: "Medium Format Panasonic",
    camlargePanasonic: "Large Format Panasonic",
    camfullframePanasonic: "Full-Frame Format Panasonic",
    cammediumPentax: "Medium Format Pentax",
    camlargePentax: "Large Format Pentax",
    camfullframePentax: "Full-Frame Format Pentax",
    cammediumLeica: "Medium Format Leica",
    camlargeLeica: "Large Format Leica",
    camfullframeLeica: "Full-Frame Format Leica",
    cammediumHasselblad: "Medium Format Hasselblad",
    camlargeHasselblad: "Large Format Hasselblad",
    camfullframeHasselblad: "Full-Frame Format Hasselblad",
    cammediumKodak: "Medium Format Kodak",
    camlargeKodak: "Large Format Kodak",
    camfullframeKodak: "Full-Frame Format Kodak",
  },
  camerasettings: {
    exposure: "Exposure",
    shortexposure: "Short Exposure",
    longexposure: "Long Exposure",
    doubleexposure: "Double-Exposure",
    shutterspeed11000: "Shutter Speed 1/1000",
    shutterspeed12: "Shutter Speed 1/2",
    f2_8: "F/2.8",
    f22: "F/22",
    gamma: "Gamma",
    whitebalance: "White Balance",
  },
  othercamera: {
    lensflare: "Lens Flare",
    vignette: "Vignette",
    splittoning: "Split Toning",
  },
};

export const POSTPROCESSING = {
  postprocessing: {
    aliasing: "Aliasing",
    occlusion: "Occlusion",
    exposure: "Exposure",
    bloom: "Bloom",
    chromatic: "Chromatic Abberation",
    fog: "Fog",
    dof: "Depth of Field",
    grain: "Grain",
    distortion: "Distortion",
    mblur: "Motion Blur",
    panini: "Panini",
    vignette: "Vignette",
    ray: "Ray tracing",
    rayocc: "Ray tracing with occlusion",
    shaders: "Shaders",
    postprocess: "Post processing effects",
    cel: "Cel shading",
  },

  reflections: {
    refray: "Reflection ray tracing",
    reflumen: "Reflection lumen mapping",
    refscreen: "Reflection screen space mapping",
  },

  misc: {
    hdr: "High dynamic range",
    cinematic: "Cinematic",
  },
};

export const POSTPROCESSING_DESC = {
  postprocessing: {
    aliasing: "Aliasing",
    occlusion: "Occlusion",
    exposure: "Exposure",
    bloom: "Bloom",
    chromatic: "Chromatic Abberation",
    fog: "Fog",
    dof: "Depth of Field",
    grain: "Grain",
    distortion: "Distortion",
    mblur: "Motion Blur",
    panini: "Panini",
    vignette: "Vignette",
    ray: "Ray tracing",
    rayocc: "Ray tracing with occlusion",
    shaders: "Shaders",
    postprocess: "Post processing effects",
    cel: "Cel shading",
  },

  reflections: {
    refray: "Reflection ray tracing",
    reflumen: "Reflection lumen mapping",
    refscreen: "Reflection screen space mapping",
  },

  misc: {
    hdr: "High dynamic range",
    cinematic: "Cinematic",
  },
};

export const LDD = {
  lighting: {
    diyalamp: "Diya lamp",
    lantern: "Lantern",
    christmaslight: "Christmas light",
    nightlight: "Nightlight",
    opticalfiber: "Opticalfiber",
    electroluminescentwire: "Electroluminescentwire",
    ultraviolet: "Ultraviolet",
    infrared: "Infrared",
    laser: "Laser",
    xray: "Xray",
    argadlamp: "Argad lamp",
    halfrearlighting: "Half rear lighting",
    floodlight: "Floodlight",
    marquee: "Marquee",
    strobelight: "Strobe light",
    bright: "Bright",
    crepuscularrays: "Crepuscular rays",
    raysofshimmeringlight: "Rays of shimmering light",
    incandescent: "Incandescent",
    fluorescent: "Fluorescent",
    plasmaglobe: "Plasmaglobe",
    teslacoil: "Teslacoil",
    electricarc: "Electricarc",
    crackletube: "Crackletube",
    edisonbulb: "Edison bulb",
    vacuumtube: "Vacuum tube",
    nixietube: "Nixie tube",
    halogen: "Halogen",
    neon: "Neon",
    xenon: "Xenon",
    krypton: "Krypton",
    dawn: "Dawn",
    dusk: "Dusk",
    midnight: "Midnight",
    noon: "Noon",
    goldenhour: "Goldenhour",
  },
  dimensionality: {
    n2d: "2d",
    n2dim: "2-Dimension",
    n25d: "2.5d",
    n25dim: "2.5-Dimension",
    n3d: "3d",
    n3dim: "3-Dimension",
    n4d: "4d",
    n4dim: "4-Dimension",
    n5d: "5d",
    n5dim: "5-Dimension",
    alldim: "All Dimension",
    beyonddim: "Beyond Dimension",
    everdim: "Ever Dimension",
    excessivelydim: "Excessively Dimension",
    extradim: "Extra Dimension",
    hyperdim: "Hyper Dimension",
    multidim: "Multi Dimension",
    omnidim: "Omni Dimension",
    overdim: "Over Dimension",
    subdim: "Sub Dimension",
    underdim: "Under Dimension",
  },
};

export const LDD_DESC = {
  lighting: {
    diyalamp: "Diya lamp",
    lantern: "Lantern",
    christmaslight: "Christmas light",
    nightlight: "Nightlight",
    opticalfiber: "Opticalfiber",
    electroluminescentwire: "Electroluminescentwire",
    ultraviolet: "Ultraviolet",
    infrared: "Infrared",
    laser: "Laser",
    xray: "Xray",
    argadlamp: "Argad lamp",
    halfrearlighting: "Half rear lighting",
    floodlight: "Floodlight",
    marquee: "Marquee",
    strobelight: "Strobe light",
    bright: "Bright",
    crepuscularrays: "Crepuscular rays",
    raysofshimmeringlight: "Rays of shimmering light",
    incandescent: "Incandescent",
    fluorescent: "Fluorescent",
    plasmaglobe: "Plasmaglobe",
    teslacoil: "Teslacoil",
    electricarc: "Electricarc",
    crackletube: "Crackletube",
    edisonbulb: "Edison bulb",
    vacuumtube: "Vacuum tube",
    nixietube: "Nixie tube",
    halogen: "Halogen",
    neon: "Neon",
    xenon: "Xenon",
    krypton: "Krypton",
    dawn: "Dawn",
    dusk: "Dusk",
    midnight: "Midnight",
    noon: "Noon",
    goldenhour: "Goldenhour",
  },
  dimensionality: {
    n2d: "2d",
    n2dim: "2-Dimension",
    n25d: "2.5d",
    n25dim: "2.5-Dimension",
    n3d: "3d",
    n3dim: "3-Dimension",
    n4d: "4d",
    n4dim: "4-Dimension",
    n5d: "5d",
    n5dim: "5-Dimension",
    alldim: "All Dimension",
    beyonddim: "Beyond Dimension",
    everdim: "Ever Dimension",
    excessivelydim: "Excessively Dimension",
    extradim: "Extra Dimension",
    hyperdim: "Hyper Dimension",
    multidim: "Multi Dimension",
    omnidim: "Omni Dimension",
    overdim: "Over Dimension",
    subdim: "Sub Dimension",
    underdim: "Under Dimension",
  },
};

export const ARTISTS = {
  Academism: {
    alexandrecabanel: "Alexandre Cabanel",
  },

  ArtsandCrafts: {
    carllarsson: "Carl Larsson",
    williammorris: "William Morris",
    tomthomson: "Tom Thomson",
    harryclarke: "Harry Clarke",
  },

  ArtNouveau: {
    alphonsomucha: "Alphonso Mucha",
    ernsthaeckel: "Ernst Haeckel",
    waltercrane: "Walter Crane",
    margaretmacdonaldmackintosh: "Margaret Macdonald Mackintosh",
    louiscomforttiffany: "Louis Comfort Tiffany",
    lawrenharris: "Lawren Harris",
    kaynielsen: "Kay Nielsen",
    kaethebutcher: "Kaethe Butcher",
    ivanbilibin: "Ivan Bilibin",
    henridetoulouselautrec: "Henri de Toulouse-Lautrec",
    gustavklimt: "Gustav Klimt",
    gerhardmunthe: "Gerhard Munthe",
  },

  Baroque: {
    annibalecarracci: "Annibale Carracci",
    anthonyvandyck: "Anthony van Dyck",
    artemisiagentileschi: "Artemisia Gentileschi",
    caravaggio: "Caravaggio",
    claudelorrain: "Claude Lorrain",
    diegovelazquez: "Diego Velázquez",
    williamhogarth: "William Hogarth",
    robertoferri: "Roberto Ferri",
    rembrandtvanrijin: "Rembrandt van Rijn",
    pieterclaesz: "Pieter Claesz",
    peterpaulrubens: "Peter Paul Rubens",
    ottomarseusvanschrieck: "Otto Marseus van Schrieck",
    lecaravaggesque: "Le caravaggesque",
    kehindewiley: "Kehinde Wiley",
    johannesvermeer: "Johannes Vermeer",
    janvangoyen: "Jan van Goyen",
    jacobvanruisdael: "Jacob van Ruisdael",
    giovannibattistagaulli: "Giovanni Battista Gaulli",
  },

  Bauhaus: {
    bauhaus: "Bauhaus",
  },
  BayArea: {
    annadittmann: "Anna Dittmann",
  },
  Contemporary: {
    oddnerdrum: "Odd Nerdrum",
    matcollishaw: "Mat Collishaw",
    kentmonkman: "Kent Monkman",
    jeffkoons: "Jeff Koons",
    jeanmichelbasquiat: "Jean-Michel Basquiat",
    hrgiger: "H. R. Giger",
    gerhardrichter: "Gerhard Richter",
  },
  Environmentalism: {
    anseladams: "Ansel Adams",
  },
  Expressionism: {
    affadi: "Affadi",
    alexejvonjawlensky: "Alexej von Jawlensky",
    alfredkubin: "Alfred Kubin",
    aliceneel: "Alice Neel",
    arshilegorky: "Arshile Gorky",
    beeple: "Beeple",
    bernardbuffet: "Bernard Buffet",
    chaimsoutine: "Chaim Soutine",
    cunoamiet: "Cuno Amiet",
    edemshwiller: "Ed Emshwiller",
    egonschiele: "Egon Schiele",
    elainedekooning: "Elain de Kooning",
    francisbacon: "Francis Bacon",
    erichheckel: "Erich Heckel",
    ernstludwigkirchner: "Erich Ludwig Kirchner",
    franzmarc: "Franz Marc",
    willemkooning: "Willem Kooning",
    wassilykandinsky: "Wassily Kandinsky",
    paulklee: "Paul Klee",
    ottodix: "Otto Dix",
    oskarkokoschka: "Oskar Kokoschka",
    maxbeckmann: "Max Beckmann",
    markrothko: "Mark Rothko",
    marcomazzoni: "Marco Mazzoni",
    mariannevonwerefkin: "Marianne von Werefkin",
    lyonelfeininger: "Lyonel Feininger",
    leonkossoff: "Leon Kossoff",
    karlschmidtrottluff: "Karl Schmidt-Rottluff",
    kathekollwitz: "Käthe Kollwitz",
    jamesensor: "James Ensor",
    irmastern: "Irma Stern",
    haroldelliott: "Harold Elliott",
    gustavevandewoestijne: "Gustave Van de Woestijne",
    georgesrouault: "Georges Rouault",
    fritsvandenberghe: "Frits Van den Berghe",
    gabriellemünter: "Gabriele Münter",
  },
  Futurism: {
    davidburliuk: "David Burliuk",
    josephstella: "Joseph Stella",
  },
  Gothic: {
    albrechtdurer: "Albrecht Dürer",
  },
  HeiseiEstheticism: {
    takatoyamamoto: "Takato Yamamoto",
    shiki: "Shiki",
  },
  Impressionist: {
    impressionist: "Impressionist",
    camillecorot: "Camille Corot",
    camillepissarro: "Camille Pissarro",
    childehassam: "Childe Hassam",
    claudemonet: "Claude Monet",
    vilhelmhammershoi: "Vilhelm Hammershoi",
    phildruillet: "Philippe Druillet",
    paulamodersohnbecker: "Paula Modersohn-Becker",
    paulcezanne: "Paul Cézanne",
    malcolmliepke: "Malcolm Liepke",
    loviscorinth: "Lovis Corinth",
    leonidafremov: "Leonid Afremov",
    johnsingersargent: "John Singer Sargent",
    isaaclevitan: "Isaac Levitan",
    henrimatisse: "Henri Matisse",
    harrietbacker: "Harriet Backer",
    fredericklordleighton: "Frederick Lord Leighton",
  },
  InstallationArt: {
    chiharushiota: "Chiharu Shiota",
    danflavin: "Dan Flavin",
    jamesturrell: "James Turrell",
  },
  Landscape: {
    edmell: "Ed Mell",
    neilwelliver: "Neil Welliver",
    johnperceval: "John Perceval",
    johnatkinsongrimshaw: "John Atkinson Grimshaw",
    guidoborellidacaluso: "Guido Borelli da Caluso",
  },
  Lowbrow: {
    esaoandrews: "Esao Andrews",
    ryoheihase: "Ryohei Hase",
    robertwilliams: "Robert Williams",
    markryden: "Mark Ryden",
  },
  Luminism: {
    albertbierstadt: "Albert Bierstadt",
    martinjohnsonheade: "Martin Johnson Heade",
    johnfredrickkensett: "John Frederick Kensett",
    joaquinsorolla: "Joaquín Sorolla",
  },
  Naturalism: {
    mariasibyllamerian: "Maria Sibylla Merian",
    johnjamesaudubon: "John James Audubon",
  },

  Mannerism: {
    elgreco: "El Greco",
    giuseppearcimboldo: "Giuseppe Arcimboldo",
  },

  Modernism: {
    agneslawrence: "Agnes Lawrence",
    amedeomodigliani: "Amedeo Modigliani",
    arthurdove: "Arthur Dove",
    beauforddelaney: "Beauford Delaney",
    candidoportinari: "Candido Portinari",
    frankauerbach: "Frank Auerbach",
    emilnolde: "Emil Nolde",
    yvesklein: "Yves Klein",
    yaacovagam: "Yaacov Agam",
    williamsburroughs: "William S Burroughs",
    victorvasarely: "Victor Vasarely",
    stuartdavis: "Stuart Davis",
    soniadelaunay: "Sonia Delaunay",
    ryanhewett: "Ryan Hewett",
    rufinotamayo: "Rufino Tamayo",
    robertomatta: "Roberto Matta",
    robertmotherwell: "Robert Motherwell",
    pietmondrian: "Piet Mondrian",
    pierreaugusterenoir: "Pierre-Auguste Renoir",
    paulgauguin: "Paul Gauguin",
    philipguston: "Philip Guston",
    patrickheron: "Patrick Heron",
    pablopicasso: "Pablo Picasso",
    normanrockwell: "Norman Rockwell",
    miltonavery: "Milton Avery",
    nataliagoncharova: "Natalia Goncharova",
    mikhailvrubel: "Mikhail Vrubel",
    maxweber: "Max Weber",
    marsdenhartley: "Marsden Hartley",
    lyubovpopova: "Lyubov Popova",
    mcescher: "M.C. Escher",
    lucianfreud: "Lucian Freud",
    laurelburch: "Laurel Burch",
    kazimirmalevich: "Kazimir Malevich",
    karlblossfeldt: "Karl Blossfeldt",
    josephcornell: "Joseph Cornell",
    johnharris: "John Harris",
    johnhoyland: "John Hoyland",
    joanmiro: "Joan Miró",
    jacksonpollock: "Jackson Pollock",
    jamesabbottmcneillwhistler: "James Abbott McNeill Whistler",
    hundertwasser: "Hundertwasser",
    howardhodgkin: "Howard Hodgkin",
    hannahhoch: "Hannah Hoch",
    georgiaokeeffe: "Georgia O'Keeffe",
    georgegrosz: "George Grosz",
    friedensreichregentagdunkelbunthundertwas: "Friedensreich Regentag Dunkelbunt Hundertwasser",
  },
  Orientalism: {
    // warwickgoble: "Warwick Goble",
    richarddadd: "Richard Dadd",
  },

  Photorealism: {
    cindysherman: "Cindy Sherman",
    jeremygeddes: "Jeremy Geddes",
    gottfriedhelnwein: "Gottfried Helnwein",
  },

  PostImpressionist: {
    vangogh: "Vincent van Gogh",
    bonnardpierre: "Pierre Bonnard",
    emilebernard: "Émile Bernard",
    tivadarcsontvarykosztka: "Tivadar Csontváry Kosztka",
    jeanmetzinger: "Jean Metzinger",
    henrirousseau: "Henri Rousseau",
    henriedmondcross: "Henri-Edmond Cross",
    georgesseurat: "Georges Seurat",
  },
  PopArt: {
    andyworhol: "Andy Warhol",
    albertovargas: "Alberto Vargas",
    davidhockney: "David Hockney",
    tomokazumatsuyama: "Tomokazu Matsuyama",
    takashimurakami: "Takashi Murakami",
    roylichtenstein: "Roy Lichtenstein",
    robertrauschenberg: "Robert Rauschenberg",
    petermax: "Peter Max",
    mabgraves: "Mab Graves",
    lisafrank: "Lisa Frank",
    kellymckernan: "Kelly McKernan",
    //keithharing: "Keith Haring",
    karolbak: "Karol Bak",
    jimfitzpatrick: "Jim Fitzpatrick",
    hiroshinagai: "Hiroshi Nagai",
  },
  Postmodern: {
    alexgrey: "Alex Grey",
    amandasage: "Amanda Sage",
  },
  Psycadelic: {
    victormoscoso: "Victor Moscoso",
    moebius: "Moebius",
    jeanpierrevasarely: "Jean-Pierre Vasarely",
    fredtomaselli: "Fred Tomaselli",
  },
  Realist: {
    adolphmenzel: "Adolph Menzel",
    alexeisavrasov: "Alexei Savrasov",
    andrewwyeth: "Andrew Wyeth",
    arkhipkuindzhi: "Arkhip Kuindzhi",
    clivemadgwick: "Clive Madgwick",
    danielridgwayknight: "Daniel Ridgway Knight",
    donatogiancola: "Donato Giancola",
    winslowhomer: "Winslow Homer",
    williamadolphebouguereau: "William-Adolphe Bouguereau",
    thomaskinkade: "Thomas Kinkade",
    tibornagy: "Tibor Nagy",
    sirjamesguthrie: "Sir James Guthrie",
    robertbechtle: "Robert Bechtle",
    robgonsalves: "Rob Gonsalves",
    paulgustavfischer: "Paul Gustav Fischer",
    julesbastienlepage: "Jules Bastien-Lepage",
    johnstephens: "John Stephens",
    jeremylipking: "Jeremy Lipking",
    jeffreytlarson: "Jeffrey T. Larson",
    jaroslawjasnikowski: "Jaroslaw Jasnikowski",
    ivanshishkin: "Ivan Shishkin",
    ivanalbright: "Ivan Albright",
    ilyarepin: "Ilya Repin",
    honoredaumier: "Honoré Daumier",
    henryossawatanner: "Henry Ossawa Tanner",
    hilmaafklint: "Hilma af Klint",
    henriharpignies: "Henri Harpignies",
    gustavecourbet: "Gustave Courbet",
    georgeluks: "George Luks",
  },
  ReligiousArt: {
    jamescchristensen: "James C. Christensen",
    hansbaldung: "Hans Baldung",
  },
  Renaissance: {
    filippiolippi: "Filippo Lippi",
    titian: "Titian",
    sandrobotticelli: "Sandro Botticelli",
    pieterbruegeltheelder: "Pieter Bruegel the Elder",
    raphael: "Raphael",
    michaelangelo: "Michaelangelo",
    matthiasgrunewald: "Matthias Grünewald",
    leonarddavinci: "Leonardo da Vinci",
    hubertrobert: "Hubert Robert",
    hieronymusbosch: "Hieronymus Bosch",
  },
  Rococo: {
    jeanhonorefragonard: "Jean-Honoré Fragonard",
  },
  Romantisism: {
    bobross: "Bob Ross",
    danielgerhartz: "Daniel Gerhartz",
    franciscogoya: "Francisco Goya",
    eugenedelacroix: "Eugene Delacroix",
    williamblake: "William Blake",
    thomasgainsborough: "Thomas Gainsborough",
    raphaelite: "Raphaelite",
    johnmartin: "John Martin",
    johnconstable: "John Constable",
    johanchristiandahl: "Johan Christian Dahl",
    jmwturner: "J.M.W. Turner",
    ivanaivazovsky: "Ivan Aivazovsky",
    henryfuseli: "Henry Fuseli",
    gustavedore: "Gustave Doré",
    franzxaverwinterhalter: "Franz Xaver Winterhalter",
  },
  ScienceFiction: {
    frankfrazetta: "Frank Frazetta",
    bastienlecouffedeharme: "Bastien Lecouffe Deharme",
    barclayshaw: "Barclay Shaw",
    bobeggleton: "Bob Eggleton",
    borisvallejo: "Boris Vallejo",
    brothershildebrandt: "Brothers Hildebrandt",
    brucepennington: "Bruce Pennington",
    chesleybonestell: "Chesley Bonestell",
    chrisfoss: "Chris Foss",
    chrismoore: "Chris Moore",
    deanellis: "Dean Ellis",
    donmaitz: "Don Maitz",
    waynebarlowe: "Wayne Barlowe",
    virgilfinlay: "Virgil Finlay",
    timhildebrandt: "Tim Hildebrandt",
    timwhite: "Tim White",
    terryoakes: "Terry Oakes",
    sydmead: "Syd Mead",
    simonstalenhag: "Simon Stalenhag",
    ronwalotsky: "Ron Walotsky",
    robertmccall: "Robert McCall",
    peterelson: "Peter Elson",
    patrickwoodroffe: "Patrick Woodroffe",
    kilianeng: "Kilian Eng",
    kellyfreas: "Kelly Freas",
    josangonzalez: "Josan Gonzalez",
    johnberkey: "John Berkey",
    johnblanche: "John Blanche",
    jimburns: "Jim Burns",
    jeffreycatherinejones: "Jeffrey Catherine Jones",
    jackgaughan: "Jack Gaughan",
    jakubrozalski: "Jakub Rozalski",
    greghildebrandt: "Greg Hildebrandt",
  },
  SocialRealism: {
    williamgropper: "William Gropper",
  },
  StreetArt: {
    banksy: "Banksy",
    shepardfairey: "Shepard Fairey",
  },
  Surrealist: {
    surrealist: "Surrealist",
    salvadordali: "Salvador Dali",
    andremasson: "André Masson",
    bridgetbatetichenor: "Bridget Batetičhenor",
    camillepierrepambubodo: "Camille Pierrepambubodo",
    chrismars: "Chris Mars",
    clovistrouille: "Clovis Trouille",
    danielmerriam: "Daniel Merriam",
    doramaar: "Dora Maar",
    dorotheatanning: "Dorothea Tanning",
    edwardweston: "Edward Weston",
    francispicabia: "Francis Picabia",
    ernstfuchs: "Ernst Fuchs",
    yvestanguy: "Yves Tanguy",
    wifredolam: "Wifredo Lam",
    victorbrauner: "Victor Brauner",
    tombagshaw: "Tom Bagshaw",
    tarookamoto: "Taro Okamoto",
    sidneynolan: "Sidney Nolan",
    shauntan: "Shaun Tan",
    rodneymatthews: "Rodney Matthews",
    raycaesar: "Ray Caesar",
    renemagritte: "René Magritte",
    remediosvaro: "Remedios Varo",
    rafalolbinski: "Rafal Olbinski",
    petergric: "Peter Gric",
    pauldelvaux: "Paul Delvaux",
    jacekyerka: "Jacek Yerka",
    naotohattori: "Naoto Hattori",
    nelezirnite: "Nele Zirnite",
    michaelwhelan: "Michael Whelan",
    meretoppenheim: "Meret Oppenheim",
    maxpechstein: "Max Pechstein",
    maxernst: "Max Ernst",
    matiklarwein: "Mati Klarwein",
    //masaakisamoto: "Masaaki Sasamoto",
    manray: "Man Ray",
    marcchagall: "Marc Chagall",
    kaysage: "Kay Sage",
    johfrabosschart: "Johfra Bosschart",
    jeanarp: "Jean Arp",
    hansbellmer: "Hans Bellmer",
    giorgiodechirico: "Giorgio de Chirico",
    fridakahlo: "Frida Kahlo",
  },
  Symbolism: {
    alyssamonks: "Alyssa Monks",
    arnoldbocklin: "Arnold Böcklin",
    evelyndemorgan: "Evelyn De Morgan",
    franzsedlacek: "Franz Sedlacek",
    viktorvasnetsov: "Viktor Vasnetsov",
    odilonredon: "Odilon Redon",
    nicholasroerich: "Nicholas Roerich",
    martirossaryan: "Martiros Saryan",
    marcellchagall: "Marcell Chagall",
    johnduncan: "John Duncan",
    jeandelville: "Jean Delville",
    gustavemoreau: "Gustave Moreau",
    gastonbussiere: "Gaston Bussière",
    georgefredericwatts: "George Frederic Watts",
  },
  HudsonRiver: {
    asherbrowndurand: "Asher Brown Durand",
    thomascole: "Thomas Cole",
    georgeinness: "George Inness",
  },
  ukiyoe: {
    katsushikahokusai: "Katsushika Hokusai",
    hiroshiyoshida: "Hiroshi Yoshida",
  },

  VisionaryArt: {
    charleseburchfield: "Charles E. Burchfield",
    howardfinster: "Howard Finster",
  },
  artistartstation: {
    antonfadeev: "Annton Fadeevi",
    alenaaenami: "Alena Aenami",
    andreasrocha: "Andreas Rocha",
    charliebowater: "Charlie Bowater",
    christopherbalaskas: "Christopher Balaskas",
    coryloftis: "Cory Loftis",
    craola: "Craola",
    fenghuazhong: "Fenghua Zhong",
    yanjuncheng: "Yanjun Cheng",
    victoradameminguez: "Victor Adame Minguez",
    tyleredlin: "Tyler Edlin",
    ruanjia: "Ruan Jia",
    rosstran: "Ross Tran",
    rhads: "RHADS",
    paullehr: "Paul Lehr",
    pascalblanche: "Pascal Blanché",
    noahbradley: "Noah Bradley",
    michallisowski: "Michal Lisowski",
    krenzcushart: "Krenz Cushart",
    jordangrimmer: "Jordan Grimmer",
    ilyakuvshinov: "Ilya Kuvshinov",
    ismailinceoglu: "Ismail Inceoglu",
    hongsoonsang: "Hong SoonSang",
    gregrutkowski: "Greg Rutkowski",
  },
  artistVideoGames: {
    akihikoyoshida: "Akihiko Yoshida",
    raphaellacoste: "Raphael Lacoste",
    larryelmore: "Larry Elmore",
    kuanghong: "Kuang Hong",
    jeffeasley: "Jeff Easley",
  },
  artistComicManga: {
    garylarson: "Gary Larson",
    garrytrudeau: "Garry Trudeau",
    jackdavis: "Jack Davis",
    jackkirby: "Jack Kirby",
    jamiehewlett: "Jamie Hewlett",
    jamesgurney: "James Gurney",
    jefflemire: "Jeff Lemire",
    jimlee: "Jim Lee",
    jimsteranko: "Jim Steranko",
    akaritoriyama: "Akari Toriyama",
    alwilliamson: "Al Williamson",
    angusmckie: "Angus McKie",
    antonpieck: "Anton Pieck",
    artgerm: "Artgerm",
    bentemplesmith: "Ben Templesmith",
    brianbolland: "Brian Bolland",
    carlbarks: "Carl Barks",
    charlesschulz: "Charles M. Schulz",
    craigdavison: "Craig Davison",
    davegibbons: "Dave Gibbons",
    davemckean: "Dave McKean",
    davedorman: "Dave Dorman",
    dustinnguyen: "Dustin Nguyen",
    frankmiller: "Frank Miller",
    fareldalrymple: "Farel Dalymple",
    enkibilal: "Enki Bilal",
    tsutomunihei: "Tsutomu Nihei",
    tomerhanuka: "Tomer Hanuka",
    toddmcfarlane: "Todd McFarlane",
    takehikoinoue: "Takehiko Inoue",
    taiyomatsumoto: "Taiyō Matsumoto",
    stevedillon: "Steve Dillon",
    steveditko: "Steve Ditko",
    simonbisley: "Simon Bisley",
    shotaroishinomori: "Shotaro Ishinomori",
    robertcrumb: "Robert Crumb",
    //robliefeld: "Rob Liefeld",
    raymondbriggs: "Raymond Briggs",
    quentinblake: "Quentin Blake",
    peterbagge: "Peter Bagge",
    philfoglio: "Phil Foglio",
    mikemignola: "Mike Mignola",
    michaeldeforge: "Michael Deforge",
    mauricesendak: "Maurice Sendak",
    mattgroening: "Matt Groening",
    masamuneshirow: "Masamune Shirow",
    markbrooks: "Mark Brooks",
    mwkaluta: "M.W. Kaluta",
    leijimatsumoto: "Leiji Matsumoto",
    kentaromiura: "Kentaro Miura",
    kimjunggi: "Kim Jung Gi",
    kensugimori: "Ken Sugimori",
    junjiito: "Junji Ito",
    johnromitajr: "John Romita Jr",
    jeffreysmith: "Jeffrey Smith",
    jeangiraud: "Jean Giraud",
    hiromuarakawa: "Hiromu Arakawa",
    hirohikoaraki: "Hirohiko Araki",
    halfoster: "Hal Foster",
    gonagai: "Go Nagai",
    glennfabry: "Glenn Fabry",
    geofdarrow: "Geof Darrow",
  },
  artistIllustrator: {
    gediminaspranckevicius: "Gediminas Pranckevicius",
    geraldbrom: "Gerald Brom",
    //heinrichlefler: "Heinrich Lefler",
    heinrichkley: "Heinrich Kley",
    ianmcque: "Ian McQue",
    ianmiller: "Ian Miller",
    igormorski: "Igor Morski",
    jjgrandville: "J. J. Grandville",
    jcleyendecker: "J.C. Leyendecker",
    jamesjean: "James Jean",
    jackbutleryeats: "Jack Butler Yeats",
    jasminebecketgriffith: "Jasmine Becket-Griffith",
    jasonedmiston: "Jason Edmiston",
    jeffreycatherinejones: "Jeffrey Catherine Jones",
    jesperejsing: "Jesper Ejsing",
    johnbauer: "John Bauer",
    johnkennmortensen: "John Kenn Mortensen",
    johnhowe: "John Howe",
    johnphilipfalter: "John Philip Falter",
    kajafoglio: "Kaja Foglio",
    justingerard: "Justin Gerard",
    kategreenaway: "Kate Greenaway",
    laurielipton: "Laurie Lipton",
    lauriegreasley: "Laurie Greasley",
    leemadgwick: "Lee Madgwick",
    luisroyo: "Luis Royo",
    louiswain: "Louis Wain",
    marcsimonetti: "Marc Simonetti",
    mikewinkelmann: "Mike Winkelmann",
    maxfieldparrish: "Maxfield Parrish",
    //mihohirano: "Miho Hirano",
    paulrand: "Paul Rand",
    noriyoshiohrai: "Noriyoshi Ohrai",
    pascalcampion: "Pascal Campion",
    petermohrbacher: "Peter Mohrbacher",
    randolphcaldecott: "Randolph Caldecott",
    rebeccaguay: "Rebecca Guay",
    ralphmcquarrie: "Ralph McQuarrie",
    raymondswanland: "Raymond Swanland",
    richarddoyle: "Richard Doyle",
    russmills: "Russ Mills",
    richardcorben: "Richard Corben",
    richardscarry: "Richard Scarry",
    rogerdean: "Roger Dean",
    sambosma: "Sam Bosma",
    rockwellkent: "Rockwell Kent",
    sidneypriorhall: "Sidney Prior Hall",
    arthurrackham: "Arthur Rackham",
    annestokes: "Anne Stokes",
    alanlee: "Alan Lee",
    aleksibriclot: "Aleksi Briclot",
    alexanderjansson: "Alexander Jansson",
    artspiegelman: "Art Spiegelman",
    asafhanuka: "Asaf Hanuka",
    ashleywood: "Ashley Wood",
    antonotto: "Anton Otto",
    apolloniasaintclair: "Apollonia Saintclair",
    beatrixpotter: "Beatrix Potter",
    berniewrightson: "Bernie Wrightson",
    briandespain: "Brian Despain",
    briankesinger: "Brian Kesinger",
    carnegriffiths: "Carne Griffiths",
    charlesblackman: "Charles Blackman",
    clydecaldwell: "Clyde Caldwell",
    cobywhitmore: "Coby Whitmore",
    colesphillips: "Coles Phillips",
    conradroset: "Conrad Roset",
    danmumford: "Dan Mumford",
    davidbmattingly: "David B. Mattingly",
    dorothylathrop: "Dorothy Lathrop",
    earlnorem: "Earl Norem",
    drsuess: "Dr. Seuss",
    edbinkley: "Ed Binkley",
    frankschoonover: "Frank Schoonover",
    franklinbooth: "Franklin Booth",
    eyvinearle: "Eyvin Earle",
    elsabeskow: "Elsa Beskow",
    ericlacombe: "Eric Lacombe ",
    yuumei: "Yuumei",
    yojishinkawa: "Yoji Shinkawa",
    yoshitakaamano: "Yoshitaka Amano",
    williamstout: "William Stout",
    viktorngai: "Viktor Ngai",
    tonyditerlizzi: "Tony DiTerlizzi",
    tomlovell: "Tom Lovell",
    timdoyle: "Tim Doyle",
    tatsurokiuchi: "Tatsuro Kiuchi",
    tednasmith: "Ted Nasmith",
    stephanielaw: "Stephanie Law",
    stephengammell: "Stephen Gammell",
    stanleydonwood: "Stanley Donwood",
    steveargyle: "Steve Argyle",
    sergiotoppi: "Sergio Toppi",
    samguay: "Sam Guay",
    miltonglaser: "Milton Glaser",
  },
  nartistFilmDirector: {
    donbluth: "Don Bluth",
    dougchiang: "Doug Chiang",
    zacksnyder: "Zack Snyder",
    timburton: "Tim Burton",
    shinjiaramaki: "Shinji Aramaki",
    satoshikon: "Satoshi Kon",
    ridleyscott: "Ridley Scott",
  },
  nartistMusician: {
    frankzappa: "Frank Zappa",
    stormthorgerson: "Storm Thorgerson",
  },
  nartistEtcher: {
    williamhenryhunt: "William Henry Hunt",
    canaletto: "Canaletto",
    josephducreux: "Joseph Ducreux",
  },
  nartistArchitect: {
    zahahadid: "Zaha Hadid",
    bjarkeingels: "Bjarke Ingels",
    lucschuiten: "Luc Schuiten",
    franklloydwright: "Frank Lloyd Wright",
    hughferriss: "Hugh Ferriss",
    //giovannibattistapiranesi: "Giovanni Battista Piranesi",
  },
  nartistAnimator: {
    ubiwerks: "Ub Iwerks",
    texavery: "Tex Avery",
    maryblair: "Mary Blair",
    makotoshinkai: "Makoto Shinkai",
  },
  nartistPhotography: {
    annegeddes: "Anne Geddes",
    claudecahun: "Claude Cahun",
    dianearbus: "Diane Arbus",
    elliotterwitt: "Elliott Erwitt",
    stefangesell: "Stefan Gesell",
    sallymann: "Sally Mann",
    nobuyoshiaraki: "Nobuyoshi Araki",
    nickknight: "Nick Knight",
    liamwong: "Liam Wong",
    hughkretschmer: "Hugh Kretschmer",
    hendrikkerstens: "Hendrik Kerstens",
    //helmutnewton: "Helmut Newton",
    gregorycrewdson: "Gregory Crewdson",
  },
  nartistSculpter: {
    ellenjewett: "Ellen Jewett",
    albertogiacometti: "Alberto Giacomettin",
    alexandermilnecalder: "Alexander Milne Calder",
    fernandobotero: "Fernando Botero",
    emilmelmoth: "Emil Melmoth",
    zdzislawbeksinski: "Zdzislaw Beksinski",
    santiagocaruso: "Santiago Caruso",
    rudolfhausner: "Rudolf Hausner",
    okudasmiguel: "Okuda San Miguel",
    mattisuuronen: "Matti Suuronen",
    josephinewall: "Josephine Wall",
    jeremymann: "Jeremy Mann",
    jasonlimon: "Jason Limon",
    hopegangloff: "Hope Gangloff",
    gustavvigeland: "Gustav Vigeland",
    davechihuly: "Dave Chihuly",
  },
  nartistWriter: {
    annemccaffrey: "Anne McCaffrey",
    hplovecraft: "H.P. Lovecraft",
  },
};

export const ARTISTS_DESC = {
  Academism: {
    alexandrecabanel: "Alexandre Cabanel",
  },

  ArtsandCrafts: {
    carllarsson: "Carl Larsson",
    williammorris: "William Morris",
    tomthomson: "Tom Thomson",
    harryclarke: "Harry Clarke",
  },

  ArtNouveau: {
    alphonsomucha: "Alphonso Mucha",
    ernsthaeckel: "Ernst Haeckel",
    waltercrane: "Walter Crane",
    margaretmacdonaldmackintosh: "Margaret Macdonald Mackintosh",
    louiscomforttiffany: "Louis Comfort Tiffany",
    lawrenharris: "Lawren Harris",
    kaynielsen: "Kay Nielsen",
    kaethebutcher: "Kaethe Butcher",
    ivanbilibin: "Ivan Bilibin",
    henridetoulouselautrec: "Henri de Toulouse-Lautrec",
    gustavklimt: "Gustav Klimt",
    gerhardmunthe: "Gerhard Munthe",
  },

  Baroque: {
    annibalecarracci: "Annibale Carracci",
    anthonyvandyck: "Anthony van Dyck",
    artemisiagentileschi: "Artemisia Gentileschi",
    caravaggio: "Caravaggio",
    claudelorrain: "Claude Lorrain",
    diegovelazquez: "Diego Velázquez",
    williamhogarth: "William Hogarth",
    robertoferri: "Roberto Ferri",
    rembrandtvanrijin: "Rembrandt van Rijn",
    pieterclaesz: "Pieter Claesz",
    peterpaulrubens: "Peter Paul Rubens",
    ottomarseusvanschrieck: "Otto Marseus van Schrieck",
    lecaravaggesque: "Le caravaggesque",
    kehindewiley: "Kehinde Wiley",
    johannesvermeer: "Johannes Vermeer",
    janvangoyen: "Jan van Goyen",
    jacobvanruisdael: "Jacob van Ruisdael",
    giovannibattistagaulli: "Giovanni Battista Gaulli",
  },

  Bauhaus: {
    bauhaus: "Bauhaus",
  },
  BayArea: {
    annadittmann: "Anna Dittmann",
  },
  Contemporary: {
    oddnerdrum: "Odd Nerdrum",
    matcollishaw: "Mat Collishaw",
    kentmonkman: "Kent Monkman",
    jeffkoons: "Jeff Koons",
    jeanmichelbasquiat: "Jean-Michel Basquiat",
    hrgiger: "H. R. Giger",
    gerhardrichter: "Gerhard Richter",
  },
  Environmentalism: {
    anseladams: "Ansel Adams",
  },
  Expressionism: {
    affadi: "Affadi",
    alexejvonjawlensky: "Alexej von Jawlensky",
    alfredkubin: "Alfred Kubin",
    aliceneel: "Alice Neel",
    arshilegorky: "Arshile Gorky",
    beeple: "Beeple",
    bernardbuffet: "Bernard Buffet",
    chaimsoutine: "Chaim Soutine",
    cunoamiet: "Cuno Amiet",
    edemshwiller: "Ed Emshwiller",
    egonschiele: "Egon Schiele",
    elainedekooning: "Elain de Kooning",
    francisbacon: "Francis Bacon",
    erichheckel: "Erich Heckel",
    ernstludwigkirchner: "Erich Ludwig Kirchner",
    franzmarc: "Franz Marc",
    willemkooning: "Willem Kooning",
    wassilykandinsky: "Wassily Kandinsky",
    paulklee: "Paul Klee",
    ottodix: "Otto Dix",
    oskarkokoschka: "Oskar Kokoschka",
    maxbeckmann: "Max Beckmann",
    markrothko: "Mark Rothko",
    marcomazzoni: "Marco Mazzoni",
    mariannevonwerefkin: "Marianne von Werefkin",
    lyonelfeininger: "Lyonel Feininger",
    leonkossoff: "Leon Kossoff",
    karlschmidtrottluff: "Karl Schmidt-Rottluff",
    kathekollwitz: "Käthe Kollwitz",
    jamesensor: "James Ensor",
    irmastern: "Irma Stern",
    haroldelliott: "Harold Elliott",
    gustavevandewoestijne: "Gustave Van de Woestijne",
    georgesrouault: "Georges Rouault",
    fritsvandenberghe: "Frits Van den Berghe",
    gabriellemünter: "Gabriele Münter",
  },
  Futurism: {
    davidburliuk: "David Burliuk",
    josephstella: "Joseph Stella",
  },
  Gothic: {
    albrechtdurer: "Albrecht Dürer",
  },
  HeiseiEstheticism: {
    takatoyamamoto: "Takato Yamamoto",
    shiki: "Shiki",
  },
  Impressionist: {
    impressionist: "Impressionist",
    camillecorot: "Camille Corot",
    camillepissarro: "Camille Pissarro",
    childehassam: "Childe Hassam",
    claudemonet: "Claude Monet",
    vilhelmhammershoi: "Vilhelm Hammershoi",
    phildruillet: "Philippe Druillet",
    paulamodersohnbecker: "Paula Modersohn-Becker",
    paulcezanne: "Paul Cézanne",
    malcolmliepke: "Malcolm Liepke",
    loviscorinth: "Lovis Corinth",
    leonidafremov: "Leonid Afremov",
    johnsingersargent: "John Singer Sargent",
    isaaclevitan: "Isaac Levitan",
    henrimatisse: "Henri Matisse",
    harrietbacker: "Harriet Backer",
    fredericklordleighton: "Frederick Lord Leighton",
  },
  InstallationArt: {
    chiharushiota: "Chiharu Shiota",
    danflavin: "Dan Flavin",
    jamesturrell: "James Turrell",
  },
  Landscape: {
    edmell: "Ed Mell",
    neilwelliver: "Neil Welliver",
    johnperceval: "John Perceval",
    johnatkinsongrimshaw: "John Atkinson Grimshaw",
    guidoborellidacaluso: "Guido Borelli da Caluso",
  },
  Lowbrow: {
    esaoandrews: "Esao Andrews",
    ryoheihase: "Ryohei Hase",
    robertwilliams: "Robert Williams",
    markryden: "Mark Ryden",
  },
  Luminism: {
    albertbierstadt: "Albert Bierstadt",
    martinjohnsonheade: "Martin Johnson Heade",
    johnfredrickkensett: "John Frederick Kensett",
    joaquinsorolla: "Joaquín Sorolla",
  },
  Naturalism: {
    mariasibyllamerian: "Maria Sibylla Merian",
    johnjamesaudubon: "John James Audubon",
  },

  Mannerism: {
    elgreco: "El Greco",
    giuseppearcimboldo: "Giuseppe Arcimboldo",
  },

  Modernism: {
    agneslawrence: "Agnes Lawrence",
    amedeomodigliani: "Amedeo Modigliani",
    arthurdove: "Arthur Dove",
    beauforddelaney: "Beauford Delaney",
    candidoportinari: "Candido Portinari",
    frankauerbach: "Frank Auerbach",
    emilnolde: "Emil Nolde",
    yvesklein: "Yves Klein",
    yaacovagam: "Yaacov Agam",
    williamsburroughs: "William S Burroughs",
    victorvasarely: "Victor Vasarely",
    stuartdavis: "Stuart Davis",
    soniadelaunay: "Sonia Delaunay",
    ryanhewett: "Ryan Hewett",
    rufinotamayo: "Rufino Tamayo",
    robertomatta: "Roberto Matta",
    robertmotherwell: "Robert Motherwell",
    pietmondrian: "Piet Mondrian",
    pierreaugusterenoir: "Pierre-Auguste Renoir",
    paulgauguin: "Paul Gauguin",
    philipguston: "Philip Guston",
    patrickheron: "Patrick Heron",
    pablopicasso: "Pablo Picasso",
    normanrockwell: "Norman Rockwell",
    miltonavery: "Milton Avery",
    nataliagoncharova: "Natalia Goncharova",
    mikhailvrubel: "Mikhail Vrubel",
    maxweber: "Max Weber",
    marsdenhartley: "Marsden Hartley",
    lyubovpopova: "Lyubov Popova",
    mcescher: "M.C. Escher",
    lucianfreud: "Lucian Freud",
    laurelburch: "Laurel Burch",
    kazimirmalevich: "Kazimir Malevich",
    karlblossfeldt: "Karl Blossfeldt",
    josephcornell: "Joseph Cornell",
    johnharris: "John Harris",
    johnhoyland: "John Hoyland",
    joanmiro: "Joan Miró",
    jacksonpollock: "Jackson Pollock",
    jamesabbottmcneillwhistler: "James Abbott McNeill Whistler",
    hundertwasser: "Hundertwasser",
    howardhodgkin: "Howard Hodgkin",
    hannahhoch: "Hannah Hoch",
    georgiaokeeffe: "Georgia O'Keeffe",
    georgegrosz: "George Grosz",
    friedensreichregentagdunkelbunthundertwas: "Friedensreich Regentag Dunkelbunt Hundertwasser",
  },
  Orientalism: {
    // warwickgoble: "Warwick Goble",
    richarddadd: "Richard Dadd",
  },

  Photorealism: {
    cindysherman: "Cindy Sherman",
    jeremygeddes: "Jeremy Geddes",
    gottfriedhelnwein: "Gottfried Helnwein",
  },

  PostImpressionist: {
    vangogh: "Vincent van Gogh",
    bonnardpierre: "Pierre Bonnard",
    emilebernard: "Émile Bernard",
    tivadarcsontvarykosztka: "Tivadar Csontváry Kosztka",
    jeanmetzinger: "Jean Metzinger",
    henrirousseau: "Henri Rousseau",
    henriedmondcross: "Henri-Edmond Cross",
    georgesseurat: "Georges Seurat",
  },
  PopArt: {
    andyworhol: "Andy Warhol",
    albertovargas: "Alberto Vargas",
    davidhockney: "David Hockney",
    tomokazumatsuyama: "Tomokazu Matsuyama",
    takashimurakami: "Takashi Murakami",
    roylichtenstein: "Roy Lichtenstein",
    robertrauschenberg: "Robert Rauschenberg",
    petermax: "Peter Max",
    mabgraves: "Mab Graves",
    lisafrank: "Lisa Frank",
    kellymckernan: "Kelly McKernan",
    //keithharing: "Keith Haring",
    karolbak: "Karol Bak",
    jimfitzpatrick: "Jim Fitzpatrick",
    hiroshinagai: "Hiroshi Nagai",
  },
  Postmodern: {
    alexgrey: "Alex Grey",
    amandasage: "Amanda Sage",
  },
  Psycadelic: {
    victormoscoso: "Victor Moscoso",
    moebius: "Moebius",
    jeanpierrevasarely: "Jean-Pierre Vasarely",
    fredtomaselli: "Fred Tomaselli",
  },
  Realist: {
    adolphmenzel: "Adolph Menzel",
    alexeisavrasov: "Alexei Savrasov",
    andrewwyeth: "Andrew Wyeth",
    arkhipkuindzhi: "Arkhip Kuindzhi",
    clivemadgwick: "Clive Madgwick",
    danielridgwayknight: "Daniel Ridgway Knight",
    donatogiancola: "Donato Giancola",
    winslowhomer: "Winslow Homer",
    williamadolphebouguereau: "William-Adolphe Bouguereau",
    thomaskinkade: "Thomas Kinkade",
    tibornagy: "Tibor Nagy",
    sirjamesguthrie: "Sir James Guthrie",
    robertbechtle: "Robert Bechtle",
    robgonsalves: "Rob Gonsalves",
    paulgustavfischer: "Paul Gustav Fischer",
    julesbastienlepage: "Jules Bastien-Lepage",
    johnstephens: "John Stephens",
    jeremylipking: "Jeremy Lipking",
    jeffreytlarson: "Jeffrey T. Larson",
    jaroslawjasnikowski: "Jaroslaw Jasnikowski",
    ivanshishkin: "Ivan Shishkin",
    ivanalbright: "Ivan Albright",
    ilyarepin: "Ilya Repin",
    honoredaumier: "Honoré Daumier",
    henryossawatanner: "Henry Ossawa Tanner",
    hilmaafklint: "Hilma af Klint",
    henriharpignies: "Henri Harpignies",
    gustavecourbet: "Gustave Courbet",
    georgeluks: "George Luks",
  },
  ReligiousArt: {
    jamescchristensen: "James C. Christensen",
    hansbaldung: "Hans Baldung",
  },
  Renaissance: {
    filippiolippi: "Filippo Lippi",
    titian: "Titian",
    sandrobotticelli: "Sandro Botticelli",
    pieterbruegeltheelder: "Pieter Bruegel the Elder",
    raphael: "Raphael",
    michaelangelo: "Michaelangelo",
    matthiasgrunewald: "Matthias Grünewald",
    leonarddavinci: "Leonardo da Vinci",
    hubertrobert: "Hubert Robert",
    hieronymusbosch: "Hieronymus Bosch",
  },
  Rococo: {
    jeanhonorefragonard: "Jean-Honoré Fragonard",
  },
  Romantisism: {
    bobross: "Bob Ross",
    danielgerhartz: "Daniel Gerhartz",
    franciscogoya: "Francisco Goya",
    eugenedelacroix: "Eugene Delacroix",
    williamblake: "William Blake",
    thomasgainsborough: "Thomas Gainsborough",
    raphaelite: "Raphaelite",
    johnmartin: "John Martin",
    johnconstable: "John Constable",
    johanchristiandahl: "Johan Christian Dahl",
    jmwturner: "J.M.W. Turner",
    ivanaivazovsky: "Ivan Aivazovsky",
    henryfuseli: "Henry Fuseli",
    gustavedore: "Gustave Doré",
    franzxaverwinterhalter: "Franz Xaver Winterhalter",
  },
  ScienceFiction: {
    frankfrazetta: "Frank Frazetta",
    bastienlecouffedeharme: "Bastien Lecouffe Deharme",
    barclayshaw: "Barclay Shaw",
    bobeggleton: "Bob Eggleton",
    borisvallejo: "Boris Vallejo",
    brothershildebrandt: "Brothers Hildebrandt",
    brucepennington: "Bruce Pennington",
    chesleybonestell: "Chesley Bonestell",
    chrisfoss: "Chris Foss",
    chrismoore: "Chris Moore",
    deanellis: "Dean Ellis",
    donmaitz: "Don Maitz",
    waynebarlowe: "Wayne Barlowe",
    virgilfinlay: "Virgil Finlay",
    timhildebrandt: "Tim Hildebrandt",
    timwhite: "Tim White",
    terryoakes: "Terry Oakes",
    sydmead: "Syd Mead",
    simonstalenhag: "Simon Stalenhag",
    ronwalotsky: "Ron Walotsky",
    robertmccall: "Robert McCall",
    peterelson: "Peter Elson",
    patrickwoodroffe: "Patrick Woodroffe",
    kilianeng: "Kilian Eng",
    kellyfreas: "Kelly Freas",
    josangonzalez: "Josan Gonzalez",
    johnberkey: "John Berkey",
    johnblanche: "John Blanche",
    jimburns: "Jim Burns",
    jeffreycatherinejones: "Jeffrey Catherine Jones",
    jackgaughan: "Jack Gaughan",
    jakubrozalski: "Jakub Rozalski",
    greghildebrandt: "Greg Hildebrandt",
  },
  SocialRealism: {
    williamgropper: "William Gropper",
  },
  StreetArt: {
    banksy: "Banksy",
    shepardfairey: "Shepard Fairey",
  },
  Surrealist: {
    surrealist: "Surrealist",
    salvadordali: "Salvador Dali",
    andremasson: "André Masson",
    bridgetbatetichenor: "Bridget Batetičhenor",
    camillepierrepambubodo: "Camille Pierrepambubodo",
    chrismars: "Chris Mars",
    clovistrouille: "Clovis Trouille",
    danielmerriam: "Daniel Merriam",
    doramaar: "Dora Maar",
    dorotheatanning: "Dorothea Tanning",
    edwardweston: "Edward Weston",
    francispicabia: "Francis Picabia",
    ernstfuchs: "Ernst Fuchs",
    yvestanguy: "Yves Tanguy",
    wifredolam: "Wifredo Lam",
    victorbrauner: "Victor Brauner",
    tombagshaw: "Tom Bagshaw",
    tarookamoto: "Taro Okamoto",
    sidneynolan: "Sidney Nolan",
    shauntan: "Shaun Tan",
    rodneymatthews: "Rodney Matthews",
    raycaesar: "Ray Caesar",
    renemagritte: "René Magritte",
    remediosvaro: "Remedios Varo",
    rafalolbinski: "Rafal Olbinski",
    petergric: "Peter Gric",
    pauldelvaux: "Paul Delvaux",
    jacekyerka: "Jacek Yerka",
    naotohattori: "Naoto Hattori",
    nelezirnite: "Nele Zirnite",
    michaelwhelan: "Michael Whelan",
    meretoppenheim: "Meret Oppenheim",
    maxpechstein: "Max Pechstein",
    maxernst: "Max Ernst",
    matiklarwein: "Mati Klarwein",
    //masaakisamoto: "Masaaki Sasamoto",
    manray: "Man Ray",
    marcchagall: "Marc Chagall",
    kaysage: "Kay Sage",
    johfrabosschart: "Johfra Bosschart",
    jeanarp: "Jean Arp",
    hansbellmer: "Hans Bellmer",
    giorgiodechirico: "Giorgio de Chirico",
    fridakahlo: "Frida Kahlo",
  },
  Symbolism: {
    alyssamonks: "Alyssa Monks",
    arnoldbocklin: "Arnold Böcklin",
    evelyndemorgan: "Evelyn De Morgan",
    franzsedlacek: "Franz Sedlacek",
    viktorvasnetsov: "Viktor Vasnetsov",
    odilonredon: "Odilon Redon",
    nicholasroerich: "Nicholas Roerich",
    martirossaryan: "Martiros Saryan",
    marcellchagall: "Marcell Chagall",
    johnduncan: "John Duncan",
    jeandelville: "Jean Delville",
    gustavemoreau: "Gustave Moreau",
    gastonbussiere: "Gaston Bussière",
    georgefredericwatts: "George Frederic Watts",
  },
  HudsonRiver: {
    asherbrowndurand: "Asher Brown Durand",
    thomascole: "Thomas Cole",
    georgeinness: "George Inness",
  },
  ukiyoe: {
    katsushikahokusai: "Katsushika Hokusai",
    hiroshiyoshida: "Hiroshi Yoshida",
  },

  VisionaryArt: {
    charleseburchfield: "Charles E. Burchfield",
    howardfinster: "Howard Finster",
  },
  artistartstation: {
    antonfadeev: "Annton Fadeevi",
    alenaaenami: "Alena Aenami",
    andreasrocha: "Andreas Rocha",
    charliebowater: "Charlie Bowater",
    christopherbalaskas: "Christopher Balaskas",
    coryloftis: "Cory Loftis",
    craola: "Craola",
    fenghuazhong: "Fenghua Zhong",
    yanjuncheng: "Yanjun Cheng",
    victoradameminguez: "Victor Adame Minguez",
    tyleredlin: "Tyler Edlin",
    ruanjia: "Ruan Jia",
    rosstran: "Ross Tran",
    rhads: "RHADS",
    paullehr: "Paul Lehr",
    pascalblanche: "Pascal Blanché",
    noahbradley: "Noah Bradley",
    michallisowski: "Michal Lisowski",
    krenzcushart: "Krenz Cushart",
    jordangrimmer: "Jordan Grimmer",
    ilyakuvshinov: "Ilya Kuvshinov",
    ismailinceoglu: "Ismail Inceoglu",
    hongsoonsang: "Hong SoonSang",
    gregrutkowski: "Greg Rutkowski",
  },
  artistVideoGames: {
    akihikoyoshida: "Akihiko Yoshida",
    raphaellacoste: "Raphael Lacoste",
    larryelmore: "Larry Elmore",
    kuanghong: "Kuang Hong",
    jeffeasley: "Jeff Easley",
  },
  artistComicManga: {
    garylarson: "Gary Larson",
    garrytrudeau: "Garry Trudeau",
    jackdavis: "Jack Davis",
    jackkirby: "Jack Kirby",
    jamiehewlett: "Jamie Hewlett",
    jamesgurney: "James Gurney",
    jefflemire: "Jeff Lemire",
    jimlee: "Jim Lee",
    jimsteranko: "Jim Steranko",
    akaritoriyama: "Akari Toriyama",
    alwilliamson: "Al Williamson",
    angusmckie: "Angus McKie",
    antonpieck: "Anton Pieck",
    artgerm: "Artgerm",
    bentemplesmith: "Ben Templesmith",
    brianbolland: "Brian Bolland",
    carlbarks: "Carl Barks",
    charlesschulz: "Charles M. Schulz",
    craigdavison: "Craig Davison",
    davegibbons: "Dave Gibbons",
    davemckean: "Dave McKean",
    davedorman: "Dave Dorman",
    dustinnguyen: "Dustin Nguyen",
    frankmiller: "Frank Miller",
    fareldalrymple: "Farel Dalymple",
    enkibilal: "Enki Bilal",
    tsutomunihei: "Tsutomu Nihei",
    tomerhanuka: "Tomer Hanuka",
    toddmcfarlane: "Todd McFarlane",
    takehikoinoue: "Takehiko Inoue",
    taiyomatsumoto: "Taiyō Matsumoto",
    stevedillon: "Steve Dillon",
    steveditko: "Steve Ditko",
    simonbisley: "Simon Bisley",
    shotaroishinomori: "Shotaro Ishinomori",
    robertcrumb: "Robert Crumb",
    //robliefeld: "Rob Liefeld",
    raymondbriggs: "Raymond Briggs",
    quentinblake: "Quentin Blake",
    peterbagge: "Peter Bagge",
    philfoglio: "Phil Foglio",
    mikemignola: "Mike Mignola",
    michaeldeforge: "Michael Deforge",
    mauricesendak: "Maurice Sendak",
    mattgroening: "Matt Groening",
    masamuneshirow: "Masamune Shirow",
    markbrooks: "Mark Brooks",
    mwkaluta: "M.W. Kaluta",
    leijimatsumoto: "Leiji Matsumoto",
    kentaromiura: "Kentaro Miura",
    kimjunggi: "Kim Jung Gi",
    kensugimori: "Ken Sugimori",
    junjiito: "Junji Ito",
    johnromitajr: "John Romita Jr",
    jeffreysmith: "Jeffrey Smith",
    jeangiraud: "Jean Giraud",
    hiromuarakawa: "Hiromu Arakawa",
    hirohikoaraki: "Hirohiko Araki",
    halfoster: "Hal Foster",
    gonagai: "Go Nagai",
    glennfabry: "Glenn Fabry",
    geofdarrow: "Geof Darrow",
  },
  artistIllustrator: {
    gediminaspranckevicius: "Gediminas Pranckevicius",
    geraldbrom: "Gerald Brom",
    //heinrichlefler: "Heinrich Lefler",
    heinrichkley: "Heinrich Kley",
    ianmcque: "Ian McQue",
    ianmiller: "Ian Miller",
    igormorski: "Igor Morski",
    jjgrandville: "J. J. Grandville",
    jcleyendecker: "J.C. Leyendecker",
    jamesjean: "James Jean",
    jackbutleryeats: "Jack Butler Yeats",
    jasminebecketgriffith: "Jasmine Becket-Griffith",
    jasonedmiston: "Jason Edmiston",
    jeffreycatherinejones: "Jeffrey Catherine Jones",
    jesperejsing: "Jesper Ejsing",
    johnbauer: "John Bauer",
    johnkennmortensen: "John Kenn Mortensen",
    johnhowe: "John Howe",
    johnphilipfalter: "John Philip Falter",
    kajafoglio: "Kaja Foglio",
    justingerard: "Justin Gerard",
    kategreenaway: "Kate Greenaway",
    laurielipton: "Laurie Lipton",
    lauriegreasley: "Laurie Greasley",
    leemadgwick: "Lee Madgwick",
    luisroyo: "Luis Royo",
    louiswain: "Louis Wain",
    marcsimonetti: "Marc Simonetti",
    mikewinkelmann: "Mike Winkelmann",
    maxfieldparrish: "Maxfield Parrish",
    //mihohirano: "Miho Hirano",
    paulrand: "Paul Rand",
    noriyoshiohrai: "Noriyoshi Ohrai",
    pascalcampion: "Pascal Campion",
    petermohrbacher: "Peter Mohrbacher",
    randolphcaldecott: "Randolph Caldecott",
    rebeccaguay: "Rebecca Guay",
    ralphmcquarrie: "Ralph McQuarrie",
    raymondswanland: "Raymond Swanland",
    richarddoyle: "Richard Doyle",
    russmills: "Russ Mills",
    richardcorben: "Richard Corben",
    richardscarry: "Richard Scarry",
    rogerdean: "Roger Dean",
    sambosma: "Sam Bosma",
    rockwellkent: "Rockwell Kent",
    sidneypriorhall: "Sidney Prior Hall",
    arthurrackham: "Arthur Rackham",
    annestokes: "Anne Stokes",
    alanlee: "Alan Lee",
    aleksibriclot: "Aleksi Briclot",
    alexanderjansson: "Alexander Jansson",
    artspiegelman: "Art Spiegelman",
    asafhanuka: "Asaf Hanuka",
    ashleywood: "Ashley Wood",
    antonotto: "Anton Otto",
    apolloniasaintclair: "Apollonia Saintclair",
    beatrixpotter: "Beatrix Potter",
    berniewrightson: "Bernie Wrightson",
    briandespain: "Brian Despain",
    briankesinger: "Brian Kesinger",
    carnegriffiths: "Carne Griffiths",
    charlesblackman: "Charles Blackman",
    clydecaldwell: "Clyde Caldwell",
    cobywhitmore: "Coby Whitmore",
    colesphillips: "Coles Phillips",
    conradroset: "Conrad Roset",
    danmumford: "Dan Mumford",
    davidbmattingly: "David B. Mattingly",
    dorothylathrop: "Dorothy Lathrop",
    earlnorem: "Earl Norem",
    drsuess: "Dr. Seuss",
    edbinkley: "Ed Binkley",
    frankschoonover: "Frank Schoonover",
    franklinbooth: "Franklin Booth",
    eyvinearle: "Eyvin Earle",
    elsabeskow: "Elsa Beskow",
    ericlacombe: "Eric Lacombe ",
    yuumei: "Yuumei",
    yojishinkawa: "Yoji Shinkawa",
    yoshitakaamano: "Yoshitaka Amano",
    williamstout: "William Stout",
    viktorngai: "Viktor Ngai",
    tonyditerlizzi: "Tony DiTerlizzi",
    tomlovell: "Tom Lovell",
    timdoyle: "Tim Doyle",
    tatsurokiuchi: "Tatsuro Kiuchi",
    tednasmith: "Ted Nasmith",
    stephanielaw: "Stephanie Law",
    stephengammell: "Stephen Gammell",
    stanleydonwood: "Stanley Donwood",
    steveargyle: "Steve Argyle",
    sergiotoppi: "Sergio Toppi",
    samguay: "Sam Guay",
    miltonglaser: "Milton Glaser",
  },
  nartistFilmDirector: {
    donbluth: "Don Bluth",
    dougchiang: "Doug Chiang",
    zacksnyder: "Zack Snyder",
    timburton: "Tim Burton",
    shinjiaramaki: "Shinji Aramaki",
    satoshikon: "Satoshi Kon",
    ridleyscott: "Ridley Scott",
  },
  nartistMusician: {
    frankzappa: "Frank Zappa",
    stormthorgerson: "Storm Thorgerson",
  },
  nartistEtcher: {
    williamhenryhunt: "William Henry Hunt",
    canaletto: "Canaletto",
    josephducreux: "Joseph Ducreux",
  },
  nartistArchitect: {
    zahahadid: "Zaha Hadid",
    bjarkeingels: "Bjarke Ingels",
    lucschuiten: "Luc Schuiten",
    franklloydwright: "Frank Lloyd Wright",
    hughferriss: "Hugh Ferriss",
    //giovannibattistapiranesi: "Giovanni Battista Piranesi",
  },
  nartistAnimator: {
    ubiwerks: "Ub Iwerks",
    texavery: "Tex Avery",
    maryblair: "Mary Blair",
    makotoshinkai: "Makoto Shinkai",
  },
  nartistPhotography: {
    annegeddes: "Anne Geddes",
    claudecahun: "Claude Cahun",
    dianearbus: "Diane Arbus",
    elliotterwitt: "Elliott Erwitt",
    stefangesell: "Stefan Gesell",
    sallymann: "Sally Mann",
    nobuyoshiaraki: "Nobuyoshi Araki",
    nickknight: "Nick Knight",
    liamwong: "Liam Wong",
    hughkretschmer: "Hugh Kretschmer",
    hendrikkerstens: "Hendrik Kerstens",
    //helmutnewton: "Helmut Newton",
    gregorycrewdson: "Gregory Crewdson",
  },
  nartistSculpter: {
    ellenjewett: "Ellen Jewett",
    albertogiacometti: "Alberto Giacomettin",
    alexandermilnecalder: "Alexander Milne Calder",
    fernandobotero: "Fernando Botero",
    emilmelmoth: "Emil Melmoth",
    zdzislawbeksinski: "Zdzislaw Beksinski",
    santiagocaruso: "Santiago Caruso",
    rudolfhausner: "Rudolf Hausner",
    okudasmiguel: "Okuda San Miguel",
    mattisuuronen: "Matti Suuronen",
    josephinewall: "Josephine Wall",
    jeremymann: "Jeremy Mann",
    jasonlimon: "Jason Limon",
    hopegangloff: "Hope Gangloff",
    gustavvigeland: "Gustav Vigeland",
    davechihuly: "Dave Chihuly",
  },
  nartistWriter: {
    annemccaffrey: "Anne McCaffrey",
    hplovecraft: "H.P. Lovecraft",
  },
};

export const COLORS_DESC = {
  colors: {
    aliceblue: "A delicate shade of blue as light and airy as a springtime sky.",
    amaranth: "A rich, deep hue of burgundy, evocative of the velvety petals of a deep red rose.",
    amber: "A warm, glowing color, like the sun-kissed bark of a tree in autumn.",
    amethyst: "A royal shade of purple, with a hint of the mysterious and magical like a precious gemstone.",
    apricot: " A soft and subtle blush, like the delicate blush of a peach on a summer morning.",
    aquamarine: " A refreshing and clear shade of blue-green, like the sparkling waters of a tropical paradise.",
    azure: "A brilliant and deep shade of blue, like the endless skies on a clear summer day.",
    babyblue: "A soft and soothing pale blue, like the calm waters of a gentle stream.",
    beige: " A neutral and subdued shade, reminiscent of the soft sand of a deserted beach.",
    black: "A powerful and mysterious color, as dark and mysterious as the night sky.",
    blue: " A classic and timeless hue, as serene and calming as a clear lake.",
    blush: "A delicate and soft pink color, like the gentle flush of a rose petal.",
    bronze: "A warm and rich metallic color, like the polished surface of an ancient statue.",
    brown: "A deep and earthy shade, evocative of the rich soil of a forest floor.",
    burgundy: "A rich and regal shade of red-purple, like the depths of a luxurious bottle of wine.",
    byzantium: "A rich and dark shade of purple, reminiscent of the lavish and opulent imperial courts of ancient Byzantine.",
    carmine: "A deep and vibrant shade of red, like the fiery petals of a blooming hibiscus flower.",
    cerise: "A bright and intense shade of pink, like the juicy and ripe cherry on a sunny summer day.",
    cerulean: "A bright and clear shade of blue, like the sparkling and infinite waters of a tropical ocean.",
    champagne: "A soft and delicate shade of gold, with a hint of subtle bubbles like a chilled glass of champagne.",
    cobaltblue: "A deep and rich shade of blue, like the deep waters of a precious stone.",
    coffee: "A dark and rich color, evocative of a freshly brewed cup of rich, warm coffee.",
    coolblue: "A refreshing and relaxing shade of blue, as cool and calming as a fresh breeze on a hot summer day.",
    copper: "A warm and inviting color, like the bright glow of a copper penny in sunlight.",
    coral: "A lively and vibrant shade of orange-pink, like the coral reefs in a tropical ocean.",
    crimson: "A deep and rich shade of red, like a warm and inviting fire on a cold winter night.",
    cyan: "A brilliant and refreshing shade of green-blue, like the clear and sparkling waters of a mountain lake.",
    desertsand: "A sandy and earthy color, like the hot and arid dunes of a desert landscape.",
    darkorange: "A rich and warm shade of orange, evocative of the glow of a setting sun on a autumn evening.",
    darkyellow: "A deep and rich shade of yellow, like the golden glow of an old lamp in a dark room.",
    darkgreen: "A rich and deep shade of green, evocative of a dense forest on a moonless night.",
    darkred: "A rich and deep shade of red, like the dark, ripe fruits of autumn.",
    darkblue: "A deep and rich shade of blue, like the starry skies on a clear, moonless night.",
    darkpurple: "A rich and mysterious shade of purple, like the dark shadows of a secret garden at night.",
    darkbrown: "A deep and rich shade of brown, like the warm and inviting darkness of a cozy wooden cabin.",
    darkgray: "A deep and subdued shade of gray, like the cool and somber clouds of a stormy sky.",
    darkpink: "A deep and rich shade of pink, like the warm and inviting color of a rose in the dim light of dusk.",
    emerald: "A deep and rich shade of green, like the vibrant and sparkling of an emerald gemstone.",
    erin: "A soft and delicate shade of green, like the gentle and soothing of a lush and verdant meadow.",
    gold: "A warm and inviting color, like the bright and shining of a gold coin in the sun.",
    gray: " A neutral and subdued color, like the cool and misty shades of a cloudy winter day.",
    green: "A verdant, lush shade of green, like the freshly sprouted leaves on a tree in springtime.",
    greyscale: "A range of shades that vary from the lightest, almost white, to the darkest charcoal, like the subtle variations of a stormy sky.",
    harlequin: "A bold, multicolored pattern, like the vibrant and playful jester's garb.",
    indigo: "A deep, rich blue, like the darkest depths of the ocean on a moonless night.",
    ivory: "A creamy, warm white color, like the soft and smooth surface of a polished elephant tusk.",
    jade: "A striking shade of green, like the brilliant and polished surface of a precious stone.",
    khaki: "A muted, sandy color, like the dusty desert landscape.",
    lavender: "A delicate and ethereal shade of purple, like the fragile and fragrant petals of a lavender field in bloom.",
    lemon: "A bright and cheerful hue, like the sun-kissed yellow of a juicy citrus fruit.",
    lilac: "A pale and ethereal lavender, reminiscent of a field of wildflowers on a misty morning.",
    lime: "A bright and zesty green, like the first sip of a cool lime margarita on a hot summer day.",
    magenta: "A bold and striking shade of pink, like the vibrant petals of a hot pink rose.",
    maroon: "A rich and elegant burgundy, reminiscent of a glass of aged red wine.",
    mauve: "A soft and delicate shade of purple, like the subtle lavender hues of a sunset sky.",
    multicolor: "A riot of vibrant hues, like a rainbow of colors dancing in the sun.",
    multicolored: "A spectrum of shades and tones, like a kaleidoscope of colors shifting and changing.",
    ochre: "A rich and earthy brown-yellow, reminiscent of the warm tones of a desert landscape.",
    olive: "A deep and nuanced green, like the dark and glossy leaves of an olive tree.",
    orange: "A vibrant and lively hue, like the fiery rays of the sun setting over the horizon.",
    orchid: "A delicate and ethereal shade of lavender, reminiscent of the fragile petals of a wildflower.",
    peach: "A rosy, warm color that evokes memories of sweet summer fruit and lazy afternoons.",
    pear: "A soft and gentle green, like the tender leaves of a newly-sprouted tree.",
    periwinkle: "A serene and soothing blue-violet, like the sky on a misty morning.",
    persianblue: "A deep and rich shade of blue, like the waters of a far-off exotic ocean.",
    pink: "A playful and feminine hue, like the soft petals of a freshly-bloomed rose.",
    plum: "A mysterious and alluring shade of deep purple, like the dark depths of a forbidden forest.",
    puce: "An unusual and unique color that evokes a sense of decadence and luxury, like the plush velvet of a grand throne room.",
    purple: "A regal and majestic color, evocative of the splendor of a royal palace.",
    rainbow: "A kaleidoscope of colors, like a spectrum of light dancing across the sky after a summer rainstorm.",
    raspberry: "A succulent shade of red, bursting with the tangy sweetness of freshly picked berries.",
    red: "A bold and vibrant color, like the fiery passion of a rose in full bloom.",
    rose: "A delicate and romantic color, like the soft pink petals of a rose in the early morning.",
    ruby: "A brilliant, regal hue, like the sparkling depths of a precious ruby, full of fire and passion.",
    salmon: "A warm and inviting color, like the soft pink flesh of a freshly caught fish.",
    sangria: "A rich and exotic color, like the deep red of a glass of wine infused with fruity flavors.",
    sapphire: "A captivating and elegant color, like the deep blue of a rare and precious gemstone.",
    scarlet: "A striking and powerful color, like the burning red of a fierce flame.",
    sepia: "A nostalgic and dreamy color, like the faded tones of an old photograph.",
    silver: "A glistening, polished silver color like a mirror reflecting the moonlight on a starry night.",
    skin: "A soft, smooth and delicate hue, like the natural color of a newborn baby's skin.",
    slategray: "A somber and serious shade of gray, reminiscent of the textured surface of a smooth slate rock.",
    tan: "A sandy beige color, akin to the sun-drenched sands of a desert oasis.",
    taupe: "A subdued and sophisticated tone, like the color of a fine suede glove worn on a misty day.",
    teal: "A deep, rich blue-green color like the serene waters of a tropical lagoon.",
    transparent: "A clear and lucid color, as pure and unassuming as a glass of water.",
    turquoise: " A vibrant and refreshing color like the Caribbean Sea, that evokes the feeling of a tropical paradise.",
    ultramarine: "A dark and rich shade of blue, like the depth of a midnight sky, mysterious and alluring.",
    violet: "A soft and delicate color, like a field of wildflowers in the spring, that whispers of wonder and magic.",
    viridian: "A fresh and lively green, like the lush growth of a forest canopy, that evokes feelings of renewal and vitality.",
    warmred: "A passionate and fiery color, like the embers of a campfire, that evokes feelings of warmth and energy.",
    white: "A pristine and pure color, like the first snowfall of winter, that evokes feelings of innocence and simplicity.",
    yellow: "A cheerful and vibrant color, like the sun shining on a summer day, that evokes feelings of happiness and positivity.",
    bluered: "An intriguing and complex color, like the changing hues of a sunset, that evokes feelings of duality and depth.",
    blueyellow: "A vibrant mix of cool blue and sunny yellow, like a tropical ocean with a bright sky.",
    redblue: "A striking combination of bold red and rich blue, as if a fiery sunset met the vast ocean.",
    redyellow: "A bold contrast of fiery red and cheerful yellow, akin to a blaze of autumn leaves.",
    yellowbluered: "A dynamic blend of sunny yellow, calming blue, and passionate red, like a fireworks show illuminating the night sky.",
    yellowredblue: "A bold, striking combination of colors, like a bright and vibrant sunset.",
    blueredyellow: "A harmonious blend of shades, reminiscent of the different hues of a peacock's tail feathers.",
    blueyellowred: "A playful and dynamic mix of colors, like a child's watercolor painting come to life.",
    redblueyellow: "A striking and unexpected combination of hues, like a vibrant abstract painting.",
    redyellowblue: "A captivating and unique blend of colors, like a rare tropical bird in full plumage.",
    paleorange: "A soft and gentle hue, like the rays of a setting sun on a summer evening.",
    paleyellow: "A delicate and dainty shade, like the first flowers of spring in a meadow.",
    palegreen: "A tender and tranquil tone, like the first leaves of spring on a tree.",
    palered: "A faint and fragile color, like the blush on a baby's cheek.",
    paleblue: "A serene and soothing color, like a pale blue sky at dawn.",
    palepurple: "A delicate and ethereal shade, reminiscent of a misty lavender field at sunrise.",
    palebrown: "A light and subdued hue, like the sandy beach at low tide.",
    palegray: "A cool and neutral tone, like the soft mist of a winter morning.",
    palepink: "A gentle and gentle color, like the first blush of spring flowers on a sunny day.",
  },
  colorpalletes: {
    palemulticolor: "A harmonious blend of pastel shades, like a dreamy sunset sky over the ocean.",
    aladdincolorpalette: "An exotic and vibrant mix of colors, like the richly adorned fabrics of a Middle Eastern bazaar.",
    armycolorpalette: "A bold and powerful combination of shades, evocative of the rugged and determined spirit of a soldier.",
    batmancolorpalette: "A dark and mysterious blend of shades, like the shadowy streets of Gotham City at night.",
    beachcolorpalette: "A soothing blend of sandy tans, aquamarine blues, and sun-kissed corals, reminiscent of a lazy day spent at the beach.",
    christmascolorpale: "A vibrant combination of deep reds, glistening greens, and sparkling golds, evocative of the warmth and joy of the holiday season.",
    cyberpunkcolorpale: "A bold and striking palette of neon greens, electric blues, and metallic silver, reminiscent of the high-tech, futuristic world of cyberpunk.",
    egyptcolorpalette: "A rich and exotic blend of deep blues, sandy golds, and rich reds, evocative of the ancient and mysterious land of Egypt.",
    halloweencolorpale: "A spooky and eerie combination of dark blacks, deep purples, and ghostly whites, evocative of the haunting and mysterious atmosphere of Halloween.",
    jokercolorpalette: "A chaotic and unsettling mix of fiery greens, deep purples and blood reds, reminiscent of the twisted mind of the infamous Joker.",
    junglecolorpalette: "A lush and vibrant mix of emerald greens, deep jungle greens, and tropical oranges and yellows, reminiscent of the dense and diverse landscape of the jungle.",
    oceancolorpalette: "A serene and tranquil blend of deep blues, crisp whites, and sandy beiges, evocative of the vast and powerful ocean.",
    simpsonscolorpalet: "A playful and colorful mix of bright yellows, bold blues, and vibrant oranges and reds, reminiscent of the cartoon world of the Simpsons.",
    ww2colorpalette: "A somber and muted blend of dull greens, grays, and browns, evocative of the harsh and gritty reality of World War II.",
    blackwhite: "A stark contrast of the purest black against the brightest white, like a yin and yang symbol.",
    darkmulticolor: "A symphony of deep hues, like a night sky bursting with stars in every color of the rainbow.",
    warmcolorpalette: "A harmonious blend of fiery oranges, reds, and yellows, reminiscent of a sunset on a tropical island.",
    coolcolorpalette: "A serene array of blues, greens, and purples, reminiscent of the calm waters of a mountain lake.",
    invertedcolors: "A mirror image of colors, where light becomes dark and dark becomes light, like a photograph flipped upside down.",
    colorful: "A vibrant explosion of hues, like a wildflower garden in full bloom.",
    rainbow: "A majestic arch of colors, like a bridge spanning the sky from one end of the horizon to the other.",
    spectralcolors: "A spectrum of colors, like the rainbow of light that emerges from a prism.",
    chroma: "A high saturation of colors, like a tropical parrot's feathers in the sunlight.",
    dichromatism: "A limited range of colors, like the monochromatic world of black and white.",
    tetrachromacy: "A phenomenon of having the ability to see a spectrum of colors beyond the typical human range, as if viewing the world through a kaleidoscope of hues.",
    saturated: "A color that is rich and intense, like a drop of pure dye in a glass of water.",
    neon: "A bright and vivid color that seems to pulse with energy, like a neon sign on a city street at night.",
    electriccolors: "A color that is bold and striking, like a bolt of lightning in the dark sky. Electric colors are bright, vibrant and dynamic.",
    complimentarycolors: "A pair of colors that sit opposite of each other on the color wheel and enhance the vibrancy of each other, like a yellow and purple combination.",
    splitcomplementarycolors: "A combination of three colors that are next to each other on the color wheel and one color that is opposite to them, like yellow, purple and blue.",
    supplementarycolors: "A pair of colors that are opposite of each other on the color wheel, like orange and blue.",
    analogouscolors: "A combination of colors that are next to each other on the color wheel, like shades of green, yellow and orange.",
    triadiccolors: "A combination of three colors equidistant from each other on the color wheel, creating a harmonious balance and visual interest.",
    tetradiccolors: "A combination of four colors, typically two pairs of complementary colors, creating a rich and complex visual effect.",
    polychromaticcolors: "A combination of multiple colors, creating a vibrant and dynamic visual experience.",
    tonalcolors: "A range of variations of a single color, creating a subtle and cohesive visual effect.",
    lightmode: "A design or interface that uses light background and light-colored text, making it easy to read and navigate.",
    darkmode: "A design or interface that uses dark background and dark-colored text, making it easy on the eyes and reducing glare.",
    lightcolors: "A range of pale, pastel, or bright colors that tend to reflect light and create a sense of openness and airiness.",
    tonesofblack: "A range of shades of black, from deep, rich blacks to light, grayed blacks, that can be used to create depth and contrast in a design.",
    tonesofblackinbackground: "A deep, dark abyss, like the night sky peppered with stars, mysterious and alluring.",
    lightbluebackground: "A serene and tranquil canvas, like the gentle ripples of a clear blue lake.",
    lightblueforeground: "A bright and fresh hue, like the early morning sky on a clear day.",
    greenbackground: "A lush and verdant landscape, like the rolling hills of a vibrant green forest.",
    greenforeground: "A vibrant and lively green, like a field of freshly sprouted grass glistening in the sun.",
    whitebackground: "A crisp and pure canvas, like a blanket of freshly fallen snow on a winter day.",
    whiteforeground: "A pristine and radiant shade, like a beam of pure light shining on a clear day.",
    highcontrast: "A striking and bold combination, like a fiery sunset against a deep blue sky.",
    lowcontrast: "A subtle and subdued pairing, like a misty morning with a pale grey sky and a soft green landscape.",
    technicolor: "A vibrant and dynamic spectrum of colors, like a kaleidoscope of hues bursting forth on the screen.",
    kinemacolor: "A rich and cinematic palette, evocative of the golden age of Hollywood and the artistry of film.",
    kodachrome: "A nostalgic and nostalgic array of colors, like the memories captured in an old family photo album.",
    cinecolor: "A subtle and nuanced set of hues, capturing the artful nuances of the film-making process.",
    agfacolor: "A rich, warm and natural palette, like the colors of nature captured in a photograph.",
  },
  shapes: {
    angle: "A bend in the path, a subtle yet powerful deviation in direction, a change in trajectory.",
    balbis: 'A shape that resembles a stretched out letter "S" with a loop at each end, its curves mesmerizing, its symmetry captivating.',
    concavepolygon: "A polygon with at least one interior angle greater than 180 degrees, its edges bent inward like a cave, its corners recessed and mysterious.",
    constructiblepolygon: "A polygon that can be constructed using a straightedge and compass, its lines precise and accurate, its angles exact and perfect.",
    convexpolygon: "A polygon where all the interior angles are less than 180 degrees, its edges bulging outward, its corners bold and confident.",
    equiangularpolygon: "A polygon where all the interior angles are congruent, its angles perfectly uniform, its symmetry elegant and harmonious.",
    equilateralpolygon: "A polygon where all the sides have the same length, its symmetry flawless, its angles perfectly equal, a shape of beauty and balance.",
    penrosetile: "A shape that defies the rules of traditional geometry, its pattern seemingly never-ending, its complexity intriguing and mysterious.",
    polyform: "A shape that can be formed by connecting multiple smaller shapes together, its variety and diversity, its ability to adapt and change.",
    regularpolygon: "A polygon where all the sides have the same length and all the angles have the same measure, its symmetry impeccable, its proportions perfect.",
    simplepolygon: "A polygon that does not self-intersect, its lines unbroken and seamless, its edges smooth and uninterrupted.",
    tangentialpolygon: "A shape that gracefully touches another, like dancers in a waltz, their boundaries intertwined in a harmonious embrace.",
    henagon: "A polygon with only one side, a shape that stands alone, a symbol of individuality and uniqueness.",
    digon: "A simple and unassuming shape, with just two straight lines, a minimalistic representation of the basic building blocks of geometry.",
    triangle:
      "A shape with three angles, three corners and three sides, a simple yet versatile shape that represents stability, balance and harmony, it's a basic building block of geometry, a fundamental shape that appears in countless forms in the natural world.",
    acutetriangle: "A sharp and pointed triangle, its angles piercing the sky like the fangs of a predator.",
    equalateraltriangle: "A symmetrical and balanced shape, each angle and side equal, representing stability and harmony.",
    heptagonaltriangle: "A shape that embodies complexity, seven sides and three angles, a fractal of geometry, a representation of the infinite.",
    isoscelestriangle: "A triangle with two equal sides, a shape of balance and proportion, an embodiment of symmetry and harmony",
    goldentriangle: "A shape that embodies the divine proportion, a representation of beauty and perfection, a sacred geometry that inspires awe and wonder.",
    obtusetriangle: "A triangle with one obtuse angle, a shape that suggests awkwardness and imbalance, a representation of imperfection and instability.",
    rationaltriangle: "A triangle with all sides and angles that can be expressed as rational numbers, a shape that embodies logic and reason, a representation of order and predictability.",
    righttriangle: "A triangle with a 90-degree angle, a shape that evokes strength and stability, its lines as straight as an arrow.",
    n306090triangle: "A triangle with angles of 30, 60 and 90 degrees, a shape of harmony and balance, its lines forming an elegant geometric dance.",
    isoscelesrighttriangle: "A triangle with two congruent legs and a 90-degree angle, a shape that symbolizes symmetry and proportion, its lines mirroring each other perfectly.",
    keplertriangle:
      "A right triangle in which the hypotenuse is also the side of a regular polygon, a shape that embodies the beauty of mathematical harmony and precision, its lines forming perfect geometric shapes.",
    scalenetriangle: "A triangle with no congruent sides, a shape that embodies individuality and unique characteristics, its lines forming an unpredictable and intriguing pattern.",
    quadrilateral: "A shape with four sides and four angles, a shape that represents structure and stability, its lines forming a solid foundation.",
    parallelogram: "A quadrilateral with parallel opposite sides, a shape that evokes balance and symmetry, its lines forming a mirror image of itself.",
    lozenge: "A diamond-shaped figure, a shape that exudes elegance and refinement, its lines forming a graceful and harmonious pattern.",
    rhomboid: "A diamond-shaped figure, its angles bold and striking, a shape that exudes strength and stability.",
    rectangle: " A geometric masterpiece, its angles perfectly aligned, a shape that embodies simplicity and elegance.",
    square: "A shape that is regal and proud, its angles bold and unyielding, a shape that exudes power and authority.",
    tangentialquadrilateral: "Four sides that touch at a single point, a shape that is both dynamic and intriguing, a geometry that defies definition.",
    trapezoid: "A shape that is sleek and sophisticated, its angles blending seamlessly into one another, a shape that embodies balance and harmony.",
    isoscelestrapezoid: "A shape that is balanced and symmetrical, its two sides congruent and parallel, a geometry that exudes harmony and stability.",
    pentagon: "A shape that is bold and dynamic, its angles sharp and striking, a geometry that embodies power and strength.",
    hexagon: "A shape that is intriguing and mysterious, its angles perfectly aligned, a geometry that embodies balance and harmony.",
    lemoinehexagon: "A shape that is complex and dynamic, its angles and lines intertwining in a mesmerizing dance, a geometry that embodies the intricacies of the universe.",
    heptagon: "A shape that is elegant and refined, its angles subtle yet striking, a geometry that embodies grace and poise.",
    octagon: "An eight-sided shape, its angles strong and unyielding, a geometry that exudes power and authority.",
    nonagon: "A shape that is alluring and mysterious, its angles and lines creating a mesmerizing pattern, a geometry that embodies the complexities of the universe.",
    decagon: "A ten-sided shape, its angles bold and striking, a geometry that exudes power and strength.",
    hendecagon: "An eleven-sided shape, its angles subtle yet striking, a geometry that embodies grace and poise.",
    dodecagon: "A twelve-sided shape, its angles strong and unyielding, a geometry that exudes power and authority.",
    tridecagon: "A thirteen-sided shape, its angles intricate and dynamic, a geometry that embodies the intricacies of the universe.",
    tetradecagon: "A shape with 14 sides, each one a carefully crafted angle, creating a fortress-like structure of precision and symmetry.",
    pentadecagon: "A shape with 15 sides, each one a distinct segment, forming a star-like figure that radiates energy and vitality.",
    hexadecagon: "A shape with 16 sides, each one a piece of a puzzle, coming together to create a shape of complexity and intrigue.",
    heptadecagon: "A shape with 17 sides, each one a fragment of a larger design, a shape that evokes a sense of mystery and wonder.",
    octadecagon: "A shape with 18 sides, each one a facet of a multifaceted gem, creating a shape that sparkles with complexity and intrigue.",
    enneadecagon: " A shape with 19 sides, each one a piece of a larger pattern, creating a shape that is both intriguing and mesmerizing.",
    icosegon: "A shape with 20 sides, each one a spoke of a wheel, creating a shape that is both stable and dynamic.",
    icosikaihenagon: "A shape with 21 sides, each one a piece of a larger puzzle, creating a shape that is both complex and captivating.",
    icosikaidegon: "A shape with 22 sides, each one a piece of a larger tapestry, creating a shape that is both rich and intricate.",
    icositrigon: "A shape of twenty equilateral triangles, a kaleidoscope of angles and lines, a geometric dance of symmetry.",
    icosikaipentagon: "A shape of twenty-five interconnected pentagons, a tessellation of shapes that interlock in perfect harmony, a mosaic of geometry.",
    icosikaihexagon: "A shape of thirty interconnected hexagons, a honeycomb of angles and lines, a pattern of precision and balance.",
    icosikaiheptagon: " A shape of thirty-five interconnected heptagons, a labyrinth of lines and angles, a puzzle of geometry waiting to be solved.",
    icosikaioctagon: "A shape of forty interconnected octagons, a tapestry of angles and lines, a geometric masterpiece of symmetry and balance.",
    icosikaienneagon: "A shape of forty-five interconnected enneagons, a kaleidoscope of angles and lines, a geometric symphony of symmetry and balance.",
    triacontagon: "A shape of thirty interconnected regular polygons, a geometric wonder of angles and lines, a shape that defies imagination.",
    tetracontagon: "A shape of forty interconnected regular polygons, a geometric puzzle of angles and lines, a shape that evokes curiosity and intrigue.",
    pentacontagon: "A shape of fifty interconnected regular polygons, a geometric masterpiece of angles and lines, a shape that embodies perfection.",
    hexacontagon: "A shape of sixty interconnected regular polygons, a geometric marvel of angles and lines, a shape that inspires awe and wonder.",
    heptacontagon: "A shape with seventy edges, like a star with countless points, a geometric wonder that defies imagination.",
    octacontagon: "An eight-sided shape with an air of mystery and intrigue, its angles and edges hinting at secrets yet to be revealed.",
    enneacontagon: "A shape with ninety-nine edges, a complex and intriguing geometric puzzle that seems to defy logic.",
    dihectogon: "A two-hundred-sided shape, a dizzying array of angles and edges that creates a sense of hypnotic motion.",
    trihectogon: "A three-hundred-sided shape, like a kaleidoscope of angles and edges, a mesmerizing geometric pattern that captivates the mind.",
    tetrahectogon: "A four-hundred-sided shape, a labyrinth of angles and edges, a geometric wonder that defies comprehension.",
    pentahectogon: "A five-hundred-sided shape, a mesmerizing array of angles and edges, a shape that inspires awe and wonder.",
    hexahectogon: "A six-hundred-sided shape, an intricate and complex geometric pattern, a shape that captures the imagination.",
    heptahectogon: " A seven-hundred-sided shape, a mesmerizing geometric symphony, an array of angles and edges that creates a sense of harmony and balance.",
    octahectogon: "An eight-hundred-sided shape, a geometric wonder that defies description, a shape that inspires awe and wonder.",
    enneahectogon: "A shape with ninety-eight sides, each angle sharp and precise, a geometric masterpiece of symmetry and balance.",
    chiliagon: "A shape with one thousand sides, a mesmerizing pattern of intricate lines and angles, a shape that embodies complexity and diversity.",
    myriagon: "A shape with ten thousand sides, a seemingly endless array of points and lines, a shape that defies imagination and comprehension.",
    megagon: "A shape with one million sides, a shape so complex and detailed that it appears to be alive, a shape that embodies the beauty and wonder of mathematics.",
    starpolygon: "A shape that radiates outwards, its points reaching towards the sky like the arms of a starfish, a shape that embodies movement and energy.",
    starofdavid: "A six-pointed star shape, its lines intersecting to form a harmonious balance of triangles, a symbol of Jewish identity and heritage.",
    staroflakshmi: "A eight-pointed star shape, intricate design representing the eight aspects of Laksmi, a symbol of wealth and prosperity in Hindu mythology.",
    enneagram: "A shape with nine points, each point representing a unique aspect of the self and interconnected with the others, often used in psychology and spiritual practices.",
    decagram: "A shape with ten points, each point representing a unique aspect or element of the whole, often used in divination and other symbolic practices.",
    hendecagram: "A shape with eleven points, each point representing a unique aspect or element of the whole, often used in divination and other symbolic practices.",
    dodecagram: "A shape with twelve points, each point representing a unique aspect or element of the whole, often used in divination and other symbolic practices.",
    apeirogon: "An endless array of points, a never-ending sequence of dots, a shape that defies boundaries and limitations.",
    arbelos: "A crescent shaped curve, a sweeping arc that glides effortlessly through the air, a symbol of grace and fluidity.",
    circle: " A perfect and unending loop, a shape of harmony and balance, a symbol of eternity.",
    archimedestwincircles: "Two circles intertwined, a dance of symmetry and proportion, a representation of unity and connection.",
    bankoffcircle: "A circle that holds within it, the secrets of geometric shapes, a shape that defies traditional boundaries.",
    circulartriangle: "A triangle that embraces the fluidity of the circle, a shape that embodies the balance of form and function",
    reuleauxtriangle: "A triangle that rotates on its axis, like a top spinning on a surface, a shape that embodies the movement and dynamism of the world.",
    circumcircle: "A circle that encompasses and surrounds another shape, like a protective halo, a shape that defines the boundaries of another.",
    disc: "A flat shape, a two-dimensional representation of the circle, a shape that embodies simplicity and purity.",
    incircleandexcirclesofatriangle:
      "The circles that are inscribed and circumscribed around a triangle, like an embrace and a boundary, a shape that reflects the relationship and balance between different elements.",
    ninepointcircle: "A circle that passes through nine significant points of a triangle, a shape that holds the keys to the triangle's geometry and properties.",
    circularsegment: "A piece of a circle, like a slice of a pie, a shape that embodies the idea of partiality and incompleteness.",
    crescent: "A shape that evokes the soft glow of the moon, a gentle curve that whispers of mystery and magic.",
    lensvesicapiscis: "A shape that resembles the lens of an eye, a double-layered form that speaks of depth and perception.",
    lune: "A shape that echoes the phases of the moon, a crescent within a circle, a symbol of the cyclical nature of life.",
    quatrefoil: "A shape that suggests the four seasons, four petals that bloom with the promise of renewal, a reminder of the passage of time.",
    reuleauxpolygon: "A shape that defies definition, a complex interplay of curves and angles, a symbol of the infinite possibilities of geometry.",
    reuleauxtriangle: "A shape that bends the rules of geometry, a triangle that smoothly flows into curves, a symbol of innovation and progress.",
    salinon: "A shape that evokes the ebb and flow of the sea, a gentle curve that whispers of the secrets of the deep.",
    semicircle: "A shape that symbolizes balance, a half-moon that speaks of completion and wholeness.",
    tomahawk: " A shape that mimics the fierce weapon, a sharp and pointed object, symbol of power and strength.",
    trefoil: "A shape that suggests the Holy Trinity, three petals that bloom with the promise of spiritual enlightenment.",
    triquetra: "A shape that embodies the power of three, a complex interplay of curves and angles, a symbol of the triune nature of the universe.",
    heart: "A shape that symbolizes love, affection, and emotional connection. It is a universal symbol of the human emotional experience.",
    archimedeanspiral: "A spiral that winds its way into infinity, like a serpent coiling around a tree, a shape that embodies the mysteries of the universe.",
  },
};

export const COLORS = {
  colors: {
    aliceblue: "Alice Blue",
    amaranth: "Amaranth",
    amber: "Amber",
    amethyst: "Amethyst",
    apricot: "Apricot",
    aquamarine: "Aquamarine",
    azure: "Azure",
    babyblue: "Baby Blue",
    beige: "Beige",
    black: "Black",
    blue: "Blue",
    blush: "Blush",
    bronze: "Bronze",
    brown: "Brown",
    burgundy: "Burgundy",
    byzantium: "Byzantium",
    carmine: "Carmine",
    cerise: "Cerise",
    cerulean: "Cerulean",
    champagne: "Champagne",
    cobaltblue: "Cobalt Blue",
    coffee: "Coffee",
    coolblue: "Cool Blue",
    copper: "Copper",
    coral: "Coral",
    crimson: "Crimson",
    cyan: "Cyan",
    desertsand: "Desert Sand",
    darkorange: "Dark Orange",
    darkyellow: "Dark Yellow",
    darkgreen: "Dark Green",
    darkred: "Dark Red",
    darkblue: "Dark Blue",
    darkpurple: "Dark Purple",
    darkbrown: "Dark Brown",
    darkgray: "Dark Gray",
    darkpink: "Dark Pink",
    emerald: "Emerald",
    erin: "Erin",
    gold: "Gold",
    gray: "Gray",
    green: "Green",
    greyscale: "Greyscale",
    harlequin: "Harlequin",
    indigo: "Indigo",
    ivory: "Ivory",
    jade: "Jade",
    khaki: "Khaki",
    lavender: "Lavender",
    lemon: "Lemon",
    lilac: "Lilac",
    lime: "Lime",
    magenta: "Magenta",
    maroon: "Maroon",
    mauve: "Mauve",
    multicolor: "Multicolor",
    multicolored: "Multicolored",
    ochre: "Ochre",
    olive: "Olive",
    orange: "Orange",
    orchid: "Orchid",
    peach: "Peach",
    pear: "Pear",
    periwinkle: "Periwinkle",
    persianblue: "Persian Blue",
    pink: "Pink",
    plum: "Plum",
    puce: "Puce",
    purple: "Purple",
    rainbow: "Rainbow",
    raspberry: "Raspberry",
    red: "Red",
    rose: "Rose",
    ruby: "Ruby",
    salmon: "Salmon",
    sangria: "Sangria",
    sapphire: "Sapphire",
    scarlet: "Scarlet",
    sepia: "Sepia",
    silver: "Silver",
    skin: "Skin",
    slategray: "Slate Gray",
    tan: "Tan",
    taupe: "Taupe",
    teal: "Teal",
    transparent: "Transparent",
    turquoise: "Turquoise",
    ultramarine: "Ultramarine",
    violet: "Violet",
    viridian: "Viridian",
    warmred: "Warm Red",
    white: "White",
    yellow: "Yellow",
    bluered: "Blue Red",
    blueyellow: "Blue Yellow",
    redblue: "Red Blue",
    redyellow: "Red Yellow",
    //yellowblue: "Yellow Blue",
    //yellowred: "Yellow Red",
    yellowbluered: "Yellow Blue Red",
    yellowredblue: "Yellow Red Blue",
    blueredyellow: "Blue Red Yellow",
    blueyellowred: "Blue Yellow Red",
    redblueyellow: "Red Blue Yellow",
    redyellowblue: "Red Yellow Blue",

    paleorange: "Pale Orange",
    paleyellow: "Pale Yellow",
    palegreen: "Pale Green",
    palered: "Pale Red",
    paleblue: "Pale Blue",
    palepurple: "Pale Purple",
    palebrown: "Pale Brown",
    palegray: "Pale Gray",
    palepink: "Pale Pink",
  },
  colorpalletes: {
    palemulticolor: "Pale Multicolor",
    aladdincolorpalette: "Aladdin Color Palette",
    armycolorpalette: "Army Color Palette",
    batmancolorpalette: "Batman Color Palette",
    beachcolorpalette: "Beach Color Palette",
    christmascolorpale: "Christmas Color Palette",
    cyberpunkcolorpale: "Cyberpunk Color Palette",
    egyptcolorpalette: "Egypt color palette",
    halloweencolorpale: "Halloween Color Palette",
    jokercolorpalette: "Joker Color Palette",
    junglecolorpalette: "Jungle Color Palette",
    oceancolorpalette: "Ocean Color Palette",
    simpsonscolorpalet: "Simpsons Color Palette",
    ww2colorpalette: "WW2 Color Palette",
    blackwhite: "Black White",
    darkmulticolor: "Dark Multicolor",
    warmcolorpalette: "Warm Color Palette",
    coolcolorpalette: "Cool Color Palette",
    invertedcolors: "Inverted Colors",
    colorful: "Colorful",
    rainbow: "Rainbow",
    spectralcolors: "Spectral Color",
    chroma: "Chroma",
    dichromatism: "Dichromatism",
    tetrachromacy: "Tetrachromacy",
    saturated: "Saturated",
    neon: "Neon",
    electriccolors: "Electric Colors",
    complimentarycolors: "Complimentary Colors",
    splitcomplementarycolors: "Split Complementary Colors",
    supplementarycolors: "Supplementary Colors",
    analogouscolors: "Analogous Colors",
    triadiccolors: "Triadic Colors",
    tetradiccolors: "Tetradic Colors",
    polychromaticcolors: "Polychromatic Colors",
    tonalcolors: "Tonal Colors",
    lightmode: "Light Mode",
    darkmode: "Dark Mode",
    lightcolors: "Light Colors",
    tonesofblack: "Tones of Black",
    tonesofblackinbackground: "Tones of Black in Background",
    lightbluebackground: "Light Blue Background",
    lightblueforeground: "Light Blue Foreground",
    greenbackground: "Green Background",
    greenforeground: "Green Foreground",
    whitebackground: "White Background",
    whiteforeground: "White Foreground",
    highcontrast: "High Contrast",
    lowcontrast: "Low Contrast",
    technicolor: "Technicolor",
    kinemacolor: "Kinemacolor",
    kodachrome: "Kodachrome",
    cinecolor: "Cinecolor",
    agfacolor: "Agfacolor",
  },
  shapes: {
    angle: "Angle",
    balbis: "Balbis",
    concavepolygon: "Concave Polygon",
    constructiblepolygon: "Constructible Polygon",
    convexpolygon: "Convex Polygon",
    equiangularpolygon: "Equi-angular Polygon",
    equilateralpolygon: "Equilateral Polygon",
    penrosetile: "Penrose Tile",
    polyform: "Polyform",
    regularpolygon: "Regular Polygon",
    simplepolygon: "Simple Polygon",
    tangentialpolygon: "Tangential Polygon",
    henagon: "Henegon",
    digon: "Digon",
    triangle: "Triangle",
    acutetriangle: "Acute Triangle",
    equalateraltriangle: "Equalateral Triangle",
    heptagonaltriangle: "Heptagonal Triangle",
    isoscelestriangle: "Isoscelese Triangle",
    goldentriangle: "Golden Triangle",
    obtusetriangle: "Obtuse Triangle",
    rationaltriangle: "Rational Triangle",
    righttriangle: "Right Triangle",
    n306090triangle: "306090 Triangle",
    isoscelesrighttriangle: "Isoscelese Right Triangle",
    keplertriangle: "Kepler Triangle",
    scalenetriangle: "Scalene Triangle",
    quadrilateral: "Quadrilateral",
    parallelogram: "Parallelogram",
    lozenge: "Lozenge",
    rhomboid: "Rhomboid",
    rectangle: "Rectangle",
    square: "Square",
    tangentialquadrilateral: "Tangential Quadralateral",
    trapezoid: "Trapezoid",
    isoscelestrapezoid: "Isosceles Trapezoid",
    pentagon: "Pentagon",
    hexagon: "Hexagon",
    lemoinehexagon: "Lemoine Hexagon",
    heptagon: "Heptagon",
    octagon: "Octagon",
    nonagon: "Nonagon",
    decagon: "Decagon",
    hendecagon: "Hendecagon",
    dodecagon: "Dodecagon",
    tridecagon: "Tridecagon",
    tetradecagon: "Tetradecagon",
    pentadecagon: "Pentadecagon",
    hexadecagon: "Hexadecagon",
    heptadecagon: "Heptadecagon",
    octadecagon: "Octadecagon",
    enneadecagon: "Enneadecagon",
    icosegon: "Icosegon",
    icosikaihenagon: "Icosikaihenagon",
    icosikaidegon: "Icosikaidegon",
    icositrigon: "Icositrigon",
    icosikaipentagon: "Icosikaipentagon",
    icosikaihexagon: "Icosikaihexigon",
    icosikaiheptagon: "Icosikaiheptagon",
    icosikaioctagon: "Icosikaioctagon",
    icosikaienneagon: "Icosikaienneagon",
    triacontagon: "Triacontagon",
    tetracontagon: "Tetracontagon",
    pentacontagon: "Pentacontagon",
    hexacontagon: "Hexacontagon",
    heptacontagon: "Heptacontagon",
    octacontagon: "Octacontagon",
    enneacontagon: "Enneacontagon",
    dihectogon: "Dihectogon",
    trihectogon: "Trihectogon",
    tetrahectogon: "Tetrahectogon",
    pentahectogon: "Pentahectogon",
    hexahectogon: "Hexahectogon",
    heptahectogon: "Heptahectogon",
    octahectogon: "Octahectogon",
    enneahectogon: "Enneahectogon",
    chiliagon: "Chiliagon",
    myriagon: "Myriagon",
    megagon: "Megagon",
    starpolygon: "Star Polygon",
    starofdavid: "Star of David",
    staroflakshmi: "Star of Lakshmi",
    enneagram: "Enneagram",
    decagram: "Decagram",
    hendecagram: "Hendecagram",
    dodecagram: "Dodecagram",
    apeirogon: "Apeirogon",
    arbelos: "Arbelos",
    circle: "Circle",
    archimedestwincircles: "Archimedes' Twin Circles",
    bankoffcircle: "Bankoff Circle",
    circulartriangle: "Circular Triangle",
    reuleauxtriangle: "Reuleaux Triangle",
    circumcircle: "Circumcircle",
    disc: "Disc",
    incircleandexcirclesofatriangle: "Incircle and Excircles of a Triangle",
    ninepointcircle: "Nine-Point Circle",
    circularsegment: "Circular Segment",
    crescent: "Crescent",
    lensvesicapiscis: "Lens, Vesica Piscis",
    lune: "Lune",
    quatrefoil: "Quatrefoil",
    reuleauxpolygon: "Reuleaus Polygon",
    reuleauxtriangle: "Reuleaux Triangle",
    salinon: "Salinon",
    semicircle: "Semicircle",
    tomahawk: "Tomahawk",
    trefoil: "Trefoil",
    triquetra: "Triquetra",
    heart: "Heart",
    archimedeanspiral: "Archimedean Spiral",
  },
};

export const GROUP_DESCRIPTIONS = {
  mediumsDrawing: "Mediums - Drawing",
  mediumsPencil: "Mediums - Pencil",
  mediumsPen: "Mediums - Pen",
  mediumsCrayon: "Mediums - Crayon",
  mediumsPaint: "Mediums - Paint",
  mediumsText: "Mediums - Text",
  mediumsPrint: "Mediums - Print",
  mediumsFabric: "Mediums - Fabric",
  mediumsPhotography: "Mediums - Photography",
  mediumsDigital: "Mediums - Digital",
  physicalmediums: "Mediums - Physical",

  cameraResolution: "Camera - Resolution",
  cameraPerspective: "Camera - Perspective",
  cameraLens: "Camera - Lens",
  cameraScene: "Camera - Scene",
  cameraFilms: "Camera - Films",
  cameraCompanies: "Camera - Companies",
  camerasettings: "Camera - Settings",
  cameraOther: "Camera - Other",
  postprocessing: "Post Processing",
  postprocessingmisc: "Post Processing - Misc",
  postprocessingreflections: "Post Processing - Reflections",
  lddLighting: "LDD - Lighting",
  ldddimensionality: "LDD - Dimensionality",

  materialsMetals: "Materials - Metals",
  materialsGemstones: "Materials - Gemstones",
  materialsWood: "Materials - Wood",
  materialsPlastic: "Materials - Plastic and Foams",
  materialsRubber: "Materials - Rubber",
  materialsWax: "Materials - Wax",
  materialsWater: "Materials - Water and Ice",
  materialsLiquid: "Materials - Liquids",
  materialsGas: "Materials - Gas",
  materialsOrganic: "Materials - Organics",
  materialsEnergy: "Materials - Energy",
  materialsFood: "Materials - Food",
  materialsPlantsFungi: "Materials - Plants and Fungi",
  materialsMusical: "Materials - Musical",
  materialsMiscellaneous: "Materials - Miscellaneous",
  materialsGel: "Materials - Gel",
  materialsGlue: "Materials - Glue",

  stylesPhotosites:
    "There are many websites that specialize in photography and art, where you can find a wide variety of images and works of art. These websites can be divided into several categories such as stock photography websites, where you can find high-quality images for commercial use, photographic communities, where photographers can share and discuss their work, and art marketplaces, where you can find and purchase artworks from various artists. Some websites also offer photographic and artistic tools, such as editing software, tutorials, and resources for photographers and artists. Additionally, there are also websites that offer virtual art galleries, where you can explore and discover new art and photographers. They can also offer features such as online classes, workshops and critiques to help improve your skills. You can find different types of art and photographers on these websites, from amateur to professional, and from emerging to established artists.",
  stylesTimeframes:
    "Photography has evolved over time, and different timeframes in photography can be characterized by specific technological advancements, aesthetic trends and cultural influences. Some timeframes in photography are known for specific types of cameras, film, and techniques that were used, while others are known for the emergence of new genres or styles of photography. Some timeframes in photography are known for the work of prominent photographers and their impact on the medium. Different timeframes in photography can also be characterized by the way photography was used, such as in art, science, or journalism. Some timeframes in photography had a more documentary approach, while others focused on more experimental or artistic practices. Some timeframes in photography were marked by the rise of new technologies, such as the invention of the first camera, the creation of film, or the emergence of digital photography.",
  stylesAbstractions:
    "Abstraction in art refers to the use of simplified or non-representational forms to express emotions, ideas, or concepts. It can be achieved in different ways, such as by simplifying shapes, colors, and textures, or by manipulating forms and elements to create a new meaning. There are different forms and levels of abstraction, each one with its own characteristics and effects. Some forms of abstraction are more minimalistic and rely on simple shapes and colors, while others are more complex and layered. Some forms of abstraction are more representational, while others are more non-representational.",
  stylesRenderer:
    "Renderers are software programs that are used to generate 2D or 3D images of a scene or model by simulating the behavior of light and materials. They can be used in various fields such as animation, gaming, architectural visualization, product design, and VFX. Different renderers use different algorithms and techniques to create images, and can produce different types of output, such as photorealistic images, non-photorealistic images, or real-time images. Some renderers are more physically based, and simulate the real-world behavior of light and materials, while others are more stylized and can produce a wide range of artistic effects. They can be categorized as offline renderers, which require a significant amount of computing power and time to create an image, and real-time renderers which are used for interactive applications such as video games, virtual reality, and augmented reality. They can be integrated in 3D modeling software, or can be standalone programs.",
  stylesComplexity:
    "Complexity refers to the degree of intricacy and interdependence of the elements of a system or phenomenon. It can be found in a wide range of fields such as science, technology, engineering, mathematics, and art. Complexity can be characterized by a large number of interacting components, non-linear relationships, and a high degree of uncertainty and unpredictability. Complex systems can exhibit emergent properties, that is, properties that arise from the interactions of the system's components and cannot be predicted from the properties of the individual components. Complex systems can also be adaptive and evolve over time, making them difficult to fully understand or control. Complexity can also be found in human behavior, emotions, and cognition, and can be influenced by social, cultural, and economic factors. Understanding complexity is a challenging task, but it can also be a source of inspiration, creativity and innovation.",
  stylesPunk: "Punk styles, also known as subcultures, are a form of counterculture that emerged in the 1970s and is marked by a rebellious attitude, anti-establishment sentiment, and a DIY approach to art and fashion. They often use bold and striking visual elements, such as bright colors, studs, chains, and graffiti, to express a sense of defiance and nonconformity. These styles can be found in music, fashion, art, and literature, and are often associated with a particular subculture or movement. They can also be heavily influenced by technology, science fiction, and futurism, and often include elements of cyberpunk, which is a subgenre of science fiction that deals with advanced technology and the internet in a dystopian future. Punk styles can be used to challenge societal norms and conventions, and to express a sense of individuality and personal freedom. They often represent a reaction to mainstream culture and can be a way for people to express their identity and connect with others who share similar values and beliefs.",
  stylesWave: "Wave styles, also known as music genres, are characterized by a specific sound and aesthetic, often inspired by nostalgia and a certain era. They often incorporate electronic elements such as synthesizers, drum machines, and sequencers, and can draw inspiration from various sources such as science fiction, film, and pop culture. They often have a unique and distinct sound, characterized by a use of retro synth tones and nostalgic melodies, often inspired by the music of a certain decade. They can be marked by a certain aesthetic, such as neon lights, and a certain atmosphere, such as a dreamy or nostalgic feeling. These styles can be found in music, fashion, art, and can also have a strong visual component, such as music videos and album art. They can be associated with a particular subculture or movement, and can attract a dedicated fanbase. They often represent a way to pay homage to a certain era, and a way to connect with the past.",
  colorsSimple:
    "Simple colors, the basic building blocks of the visual spectrum, a palette of hues that range from the purest whites to the deepest blacks, they are the foundation of light and can evoke a wide range of emotions and feelings. They can be bold and striking or subtle and understated, they can create a sense of warmth or coolness, harmony or contrast, and can be used to create depth and dimension. They are the foundation of art, design, and visual communication, and they can be found everywhere, from the natural world to the man-made. They are the fundamental element of visual art, design and fashion, used to create mood, convey meaning, and evoke emotions. They are also used in design to create a sense of balance and hierarchy, to draw attention and guide the viewer's eye.",
  colorsPalletes:
    "Color palettes, a curated collection of colors that work together to create a cohesive and harmonious visual experience, they are the artist's toolbox, the designer's arsenal, and the stylist's secret weapon. They are used to evoke emotions, create a sense of mood, and convey meaning. They can be monochromatic, analogous, complementary, or split-complementary, each one with different effects and impact. They can be used to create a sense of warmth or coolness, balance or contrast, and can be used to guide the viewer's eye, leading them through the visual journey. Color palettes are the foundation of art, design, and visual communication, and can be found everywhere, from nature to the man-made world. They can be used to express a certain feeling, style, or era and can be used to create a sense of unity, continuity and consistency in any medium, from graphic design to film.",
  shapesForms:
    "Shapes and forms, the building blocks of the physical world, a symphony of lines and curves, a dance of light and shadow, a visual language that speaks to the soul, a never-ending exploration of the infinite possibilities of creation. They can be simple or complex, soft or sharp, symmetrical or asymmetrical, yet all of them together create the beauty and diversity of the world we live in. They evoke emotions, and can create a sense of movement, depth, and structure. They are the foundation of art, design, and architecture, and they are everywhere, from the smallest microbe to the largest galaxy.",
  intangibleEmotions:
    "Emotions, the internal experiences that shape our perceptions and understanding of the world, they are complex and varied, and can range from positive to negative. They can be triggered by various stimuli, both internal and external and can change rapidly, often in response to different situations. They are a product of the interaction between our thoughts, feelings, and physiological responses. They can be felt physically in the body and can be accompanied by specific actions or behaviors. Emotions play a crucial role in our social interactions, relationships, and decision making, and can be used to express oneself, empathize with others, and navigate through life. They are essential for human experience, and are what makes us human. Emotions can be fleeting, or long-lasting, and can be managed and understood, through different techniques and practices.",
  intangibleConcepts:
    "Concepts are abstract ideas, principles or theories that are used to explain or understand a particular phenomenon or subject. They are the building blocks of knowledge, and are used to organize and make sense of information. They can be simple or complex, and can be found in a wide range of fields such as science, philosophy, mathematics, and art. They can be used to explain natural phenomena, describe social behaviors, or guide decision making. Concepts can be defined and operationalized, and can be tested and validated through research. They can also change over time, as new information and knowledge is acquired. They are essential to human understanding and communication, and are used to convey meaning, express ideas, and make connections.",
  intangibleSymbols:
    "Symbols are visual or linguistic representations that stand for or convey an idea, concept, or meaning. They can be found in a wide range of forms, such as signs, images, words, or gestures. They are often used in communication, art, literature, and religion to convey complex ideas and emotions. They can be cultural or personal, and can have different meanings for different people and in different contexts. Some symbols are universally understood, such as traffic signs, while others are more open to interpretation, such as a work of art. They can be used to convey information, express emotions or ideologies, create a sense of identity or belonging, and can be used as a way of storytelling, in literature, or art. They can be powerful tools of communication, and can convey complex ideas or emotions through simple forms.",
  intangibleZodiac:
    "The Zodiac is a band of the sky that includes the twelve constellations that the sun appears to pass through as it moves through its annual cycle. These constellations are Aries, Taurus, Gemini, Cancer, Leo, Virgo, Libra, Scorpio, Sagittarius, Capricorn, Aquarius and Pisces. They are used in astrology to divide the sky into twelve equal parts, called signs, each one associated with a specific date range and specific personality traits. Astrology is not considered a science, but many people believe in the influence of the position of the stars and planets on human affairs and natural phenomena. Each sign is associated with certain characteristics, personality traits, strengths and weaknesses, and is said to be influenced by the planet that rules it. The zodiac has been used for centuries in many cultures and belief systems, and is still used today as a way to understand human behavior, and to make predictions about the future.",
  intangibleNumbers:
    "Numbers are a system of representing quantities, and are used in a variety of fields such as mathematics, science, finance, and art. They can be represented by digits or symbols, and have been used for thousands of years to count, measure, and communicate information. They can be natural numbers, such as 1,2,3, or they can be irrational numbers, such as pi or e. They can be used to describe patterns and relationships, and are used in mathematical operations such as addition, subtraction, multiplication, and division. Numbers can also be used to express probabilities, statistics, and measurements, and can be used to represent time, money, and other quantities. They can also be used in art and literature to create meaning, represent ideas, or convey emotions. Numbers are considered a fundamental concept in human culture and have been used for centuries in many cultures and belief systems.",
  intangibleNumbersystem:
    "Number systems are a way of representing numbers using a specific set of symbols or digits. The most common number system is the decimal system, also known as base 10, in which the digits 0 through 9 are used to represent numbers. However, there are many other number systems, such as binary (base 2), octal (base 8), and hexadecimal (base 16), which are commonly used in computer science and digital electronics. Each number system has its own unique set of digits or symbols, and its own rules for performing mathematical operations. The base of the number system is the number of unique digits or symbols that are used to represent numbers. For example, in base 10 (decimal) there are 10 unique digits (0-9) while in base 2 (binary) there are only 2 unique digits (0 and 1). Number systems can also be represented in negative bases, also known as negabinary or negative base number systems.",
  referenceGames:
    "The realm of video games is a vast and wondrous landscape, filled with digital worlds that beguile and beguile. It is a place where imagination and technology converge to create immersive experiences that transport players to fantastical realms beyond the bounds of reality. From the pixelated landscapes of the early days of gaming, to the photorealistic worlds of today, the medium has evolved in ways that were once thought impossible. The characters we control, the stories we experience, and the worlds we explore are all crafted with meticulous care and attention to detail, inviting us to lose ourselves in the magic of the game. And as we traverse this digital terrain, we are reminded of the boundless potential of human creativity and the enduring power of the interactive medium.",
  referenceAnimeStudio:
    "Anime studios are the creative hearts and minds behind the mesmerizing world of anime. These production houses are responsible for bringing to life the colorful and dynamic characters, fantastical landscapes, and engaging storylines that have captivated audiences around the globe. From the earliest days of anime, these studios have been at the forefront of the medium, pushing the boundaries of animation and storytelling to new heights. Whether it's the imaginative worlds of Studio Ghibli, the action-packed dramas of Studio Bones, or the heart-wrenching romance of Kyoto Animation, anime studios continue to inspire and enchant audiences with their boundless creativity and passion. Like a masterful artist, they use the medium of animation to create captivating works of art that transport us to new worlds and introduce us to unforgettable characters that will stay with us long after the final credits have rolled.",
    artistAcademism: "Artist - Academism",
    artistArtsandCrafts: "Artist - Arts and Crafts",
    artistArtNouveau: "Artist - Art Nouveau",
    artistBaroque: "Artist - Baroque",
    artistBauhaus: "Artist - Bauhaus",
    artistBayArea: "Artist - Bay Area",
    artistContemporary: "Artist - Contemporary",
    artistEnvironmentalism: "Artist - Environmentalism",
    artistExpressionism: "Artist - Expressionism",
    artistFuturism: "Artist - Futurism",
    artistGothic: "Artist - Gothic",
    artistHeiseiEstheticism: "Artist - Heisei Estheticism",
    artistImpressionist: "Artist - Impressionist",
    artistInstallationArt: "Artist - Installation Art",
    artistLandscape: "Artist - Landscape",
    artistLowbrow: "Artist - Lowbrow",
    artistLuminism: "Artist - Luminism",
    artistNaturalism: "Artist - Naturalism",
    artistMannerism: "Artist - Mannerism",
    artistModernism: "Artist - Modernism",
    artistOrientalism: "Artist - Orientalism",
    artistPhotorealism: "Artist - Photorealism",
    artistPostImpressionist: "Artist - Post-Impressionist",
    artistPopArt: "Artist - Pop Art",
    artistPostmodern: "Artist - Postmodern",
    artistPsycadelic: "Artist - Psycadelic",
    artistRealist: "Artist - Realist",
    artistReligiousArt: "Artist - Religious Art",
    artistRenaissance: "Artist - Renaissance",
    artistRococo: "Artist - Rococo",
    artistRomantisism: "Artist - Romantisism",
    artistScienceFiction: "Artist - Science Fiction",
    artistSocialRealism: "Artist - Social Realism",
    artistStreetArt: "Artist - Street Art",
    artistSurrealist: "Artist - Surrealist",
    artistSymbolism: "Artist - Symbolism",
    artistHudsonRiver: "Artist - Hudson River",
    artistukiyoe: "Artist - Ukiyoe",
    artistVisionaryArt: "Artist - Visionary Art",
    artistartistartstation: "Artist - ArtStation",
    artistartistVideoGames: "Artist - Video Games",
    artistartistComicManga: "Artist - Comic/Manga",
    artistartistIllustrator: "Artist - Illustrator",
    artistnartistFilmDirector: "Artist - Film Director",
    nartistMusician: "Artist - Musician",
    nartistEtcher: "Artist - Etcher",
    nartistArchitect: "Artist - Architect",
    nartistAnimator: "Artist - Animator",
    nartistPhotography: "Artist - Photography",
    nartistSculpter: "Artist - Sculpter",
    nartistWriter: "Artist - Writer",

  };

export const GROUP_TITLES = {
  mediumsDrawing: "Mediums - Drawing",
  mediumsPencil: "Mediums - Pencil",
  mediumsPen: "Mediums - Pen",
  mediumsCrayon: "Mediums - Crayon",
  mediumsPaint: "Mediums - Paint",
  mediumsText: "Mediums - Text",
  mediumsPrint: "Mediums - Print",
  mediumsFabric: "Mediums - Fabric",
  mediumsPhotography: "Mediums - Photography",
  mediumsDigital: "Mediums - Digital",
  physicalmediums: "Mediums - Physical",

  cameraResolution: "Camera - Resolution",
  cameraPerspective: "Camera - Perspective",
  cameraLens: "Camera - Lens",
  cameraScene: "Camera - Scene",
  cameraFilms: "Camera - Films",
  cameraCompanies: "Camera - Companies",
  camerasettings: "Camera - Settings",
  cameraOther: "Camera - Other",
  postprocessing: "Post Processing",
  postprocessingmisc: "Post Processing - Misc",
  postprocessingreflections: "Post Processing - Reflections",
  lddLighting: "LDD - Lighting",
  ldddimensionality: "LDD - Dimensionality",

  materialsMetals: "Materials - Metals",
  materialsGemstones: "Materials - Gemstones",
  materialsWood: "Materials - Wood",
  materialsPlastic: "Materials - Plastic",
  materialsRubber: "Materials - Rubber",
  materialsWax: "Materials - Wax",
  materialsWater: "Materials - Water and Ice",
  materialsLiquid: "Materials - Liquids",
  materialsGas: "Materials - Gas",
  materialsOrganic: "Materials - Organics",
  materialsEnergy: "Materials - Energy",
  materialsFood: "Materials - Food",
  materialsPlantsFungi: "Materials - Plants and Fungi",
  materialsMusical: "Materials - Musical",
  materialsMiscellaneous: "Materials - Miscellaneous",
  materialsGel: "Materials - Gel",
  materialsGlue: "Materials - Glue",

  stylesPhotosites: "Styles - Photosites",
  stylesTimeframes: "Styles - Timeframes",
  stylesAbstractions: "Styles - Abstractions",
  stylesRenderer: "Styles - Renderer",
  stylesComplexity: "Styles - Complexity",
  stylesPunk: "Styles - Punk",
  stylesWave: "Styles - Wave",
  colorsSimple: "Colors - Simple",
  colorsPalletes: "Colors - Palettes",
  shapesForms: "Shapes & Forms",
  intangibleEmotions: "Intangible - Emotions",
  intangibleConcepts: "Intangible - Concepts",
  intangibleSymbols: "Intangible - Symbols",
  intangibleZodiac: "Intangible - Zodiac",
  intangibleNumbers: "Intangible - Numbers",
  intangibleNumbersystem: "Intangible - Number System",
  referenceGames: "Reference - Video Games",
  referenceAnimeStudio: "Reference - Anime Studios",

  artistAcademism: "Artist - Academism",
  artistArtsandCrafts: "Artist - Arts and Crafts",
  artistArtNouveau: "Artist - Art Nouveau",
  artistBaroque: "Artist - Baroque",
  artistBauhaus: "Artist - Bauhaus",
  artistBayArea: "Artist - Bay Area",
  artistContemporary: "Artist - Contemporary",
  artistEnvironmentalism: "Artist - Environmentalism",
  artistExpressionism: "Artist - Expressionism",
  artistFuturism: "Artist - Futurism",
  artistGothic: "Artist - Gothic",
  artistHeiseiEstheticism: "Artist - Heisei Estheticism",
  artistImpressionist: "Artist - Impressionist",
  artistInstallationArt: "Artist - Installation Art",
  artistLandscape: "Artist - Landscape",
  artistLowbrow: "Artist - Lowbrow",
  artistLuminism: "Artist - Luminism",
  artistNaturalism: "Artist - Naturalism",
  artistMannerism: "Artist - Mannerism",
  artistModernism: "Artist - Modernism",
  artistOrientalism: "Artist - Orientalism",
  artistPhotorealism: "Artist - Photorealism",
  artistPostImpressionist: "Artist - Post-Impressionist",
  artistPopArt: "Artist - Pop Art",
  artistPostmodern: "Artist - Postmodern",
  artistPsycadelic: "Artist - Psycadelic",
  artistRealist: "Artist - Realist",
  artistReligiousArt: "Artist - Religious Art",
  artistRenaissance: "Artist - Renaissance",
  artistRococo: "Artist - Rococo",
  artistRomantisism: "Artist - Romantisism",
  artistScienceFiction: "Artist - Science Fiction",
  artistSocialRealism: "Artist - Social Realism",
  artistStreetArt: "Artist - Street Art",
  artistSurrealist: "Artist - Surrealist",
  artistSymbolism: "Artist - Symbolism",
  artistHudsonRiver: "Artist - Hudson River",
  artistukiyoe: "Artist - Ukiyoe",
  artistVisionaryArt: "Artist - Visionary Art",
  artistartistartstation: "Artist - ArtStation",
  artistartistVideoGames: "Artist - Video Games",
  artistartistComicManga: "Artist - Comic/Manga",
  artistartistIllustrator: "Artist - Illustrator",
  artistnartistFilmDirector: "Artist - Film Director",
  nartistMusician: "Artist - Musician",
  nartistEtcher: "Artist - Etcher",
  nartistArchitect: "Artist - Architect",
  nartistAnimator: "Artist - Animator",
  nartistPhotography: "Artist - Photography",
  nartistSculpter: "Artist - Sculpter",
  nartistWriter: "Artist - Writer",
};

export const INTANGIBLES = {
  emotions: {
    happy: "Happy",
    excited: "Excited",
    sad: "Sad",
    angry: "Angry",
    angelic: "Angelic",
    good: "Good",
    evil: "Evil",
    benevolent: "Benevolent",
    malevolent: "Malevolent",
    creepy: "Creepy",
    horror: "Horror",
  },
  concepts: {
    infused: "Infused",
    refreshing: "Refreshing",
    essence: "Essence",
    supersonic: "Supersonic",
    weak: "Weak",
    strong: "Strong",
    significant: "Significant",
    thin: "Thin",
    thick: "Thick",
    nano: "Nano",
    micro: "Micro",
    tiny: "Tiny",
    mini: "Mini",
    big: "Big",
    large: "Large",
    huge: "Huge",
    massive: "Massive",
    massivescale: "Massive Scale",
    fengshui: "Feng Shui",
    perfectionism: "Perfectionism",
    ocd: "OCD",
    organized: "Organized",
    sorted: "Sorted",
    array: "Array",
    flexible: "Flexible",
    upsidedown: "Upside-Down",
    muted: "Muted",
    visualperception: "Visual Perception",
    visualagnosia: "Visual Agnosia",
    beginning: "Beginning",
    end: "End",
    paradox: "Paradox",
  },

  symbols: {
    yinyang: "Yin-Yang",
  },
  zodiac: {
    capricornus: "Capricornus",
    aquarius: "Aquarius",
    pisces: "Pisces",
    taurus: "Taurus",
    gemini: "Gemini",
    cancer: "Cancer",
    leo: "Leo",
    virgo: "Virgo",
    libra: "Libra",
    scorpio: "Scorpio",
    sagittarius: "Sagittarius",
    aries: "Aries",
  },
  numbers: {
    n10: "10",
    ten: "Ten",
    n100: "100",
    hundred: "Hundred",
    n1000: "1000",
    thousand: "Thousand",
    n10000: "10000",
    tenthousand: "Ten Thousand",
    n100000: "100000",
    hundredthousand: "Hundred Thousand",
    n1000000: "1000000",
    million: "Million",
    n10000000: "10000000",
    tenmillion: "Ten Million",
    n100000000: "100000000",
    hundredmillion: "Hundred Million",
    n1000000000: "1000000000",
    billion: "Billion",
    n10000000000: "10000000000",
    tenbillion: "Ten Billion",
    n100000000000: "100000000000",
    hundredbillion: "Hundred Billion",
    trillion: "Trillion",
    tentrillion: "Ten Trillion",
    hundredtrillion: "Hundred Trillion",
    quadrillion: "Quadrillion",
  },
  numbersystem: {
    unary: "Unary",
    binary: "Binary",
    ternary: "Ternary",
    quaternary: "Quaternary",
    quinary: "Quinary",
    senary: "Senary",
    septnary: "Septnary",
    octal: "Octal",
    nonary: "Nonary",
    decimal: "Decimal",
    hexadecimal: "Hexadecimal",
    base2: "Base-2",
    base4: "Base-4",
    base8: "Base-8",
    base10: "Base-10",
    base16: "Base-16",
    base20: "Base-20",
    base24: "Base-24",
    base32: "Base-32",
    base64: "Base-64",
  },
};

export const INTANGIBLES_DESC = {
  emotions: {
    happy: "A warm, golden sunbeam of joy radiating through every inch of the body, filling the mind with a sense of contentment and peace.",
    excited: "A bubbling cauldron of exhilaration, effervescent energy fizzing through every vein, sparking of anticipation crackling in the air.",
    sad: "A heavy, leaden weight pressing on the chest, tears like raindrops falling down the cheeks, a sense of overwhelming melancholy.",
    angry: "A fiery inferno of wrath, molten lava coursing through the bloodstream, fists clenched and jaws tightened in righteous indignation.",
    angelic: "A celestial light that shines down and illuminates the soul, a sense of purity and goodness, a gentle touch of grace.",
    good: "A shining beacon of righteousness, a pure and selfless force that brings warmth to the hearts of all it touches.",
    evil: "A writhing serpent of darkness, a cold and malevolent force that seeks to corrupt and destroy all that is good.",
    benevolent: "A gentle breeze of kindness, a benevolent force that spreads compassion and generosity like a warm hug.",
    malevolent: "A ruthless storm of malice, a malevolent force that spreads destruction and chaos wherever it goes.",
    creepy: "A shivering chill that runs down the spine, a sense of unease and dread that clings to the skin like a thick fog.",
    horror: "A paralyzing fear that grips the heart and mind, a sense of terror that makes the blood run cold and the hairs stand on end.",
  },
  concepts: {
    infused: "The sensation of emotions seeping into every fiber of one's being, saturating the soul with their vibrant hues.",
    refreshing: "The crisp, invigorating feeling of renewed energy and vitality that washes over the senses like a cool breeze on a hot summer day.",
    essence: "The core and fundamental nature of something, distilled to its purest and most essential form.",
    supersonic: "A force of nature that transcends the boundaries of time and space, hurtling through the atmosphere with a speed and power that defies comprehension.",
    weak: "A frail and fragile state, lacking the resilience and fortitude to withstand the trials of life.",
    strong: "A powerful and unyielding presence, imbued with an unshakable determination and an unbreakable spirit.",
    significant: "A weighty and meaningful presence, carrying a profound importance and impact that resonates deeply within the soul.",
    thin: "A delicate and ethereal quality, resembling a wispy veil that flutters in the wind.",
    thick: "A dense and substantial quality, possessing a palpable weight and texture that can be felt with every sense.",
    nano: "A minuscule and infinitesimal scale, so small that it can barely be perceived by the naked eye.",
    micro: "A minuscule scale, requiring the use of a microscope to see, but still too small to be seen by the naked eye.",
    tiny: "A minuscule and diminutive scale, small enough to fit in the palm of your hand.",
    mini: "A small and compact scale, but still larger and more noticeable than nano, micro and tiny scales.",
    big: "A size that is noticeable and substantial, but not necessarily enormous.",
    large: "A size that is bigger than average, but not necessarily huge.",
    huge: "A size that is much larger than average, striking the observer as being immense.",
    massive: "A size that is overwhelmingly large, dwarfing everything around it and commanding attention.",
    massivescale: "A size that is beyond comprehension, so large that it defies understanding and imagination.",
    fengshui: "The ancient Chinese practice of arranging objects and spaces in harmony with the natural flow of energy, creating a sense of balance and serenity in the environment.",
    perfectionism: "A desire for flawlessness and the relentless pursuit of excellence, where every detail must align with a rigid and uncompromising standard.",
    ocd: "A disorder characterized by persistent and unwanted thoughts, feelings, or behaviors that drive an individual to engage in repetitive actions or mental acts in an attempt to reduce anxiety.",
    organized: "The methodical arrangement of elements in a logical and efficient manner, creating an atmosphere of clarity and purpose.",
    sorted: "SorThe act of classifying and arranging things in a specific order, bringing a sense of order and control to a previously chaotic situation.ted",
    array: "A orderly arrangement of items, arranged in a specific fashion, creating a visual representation of information.",
    flexible: "The ability to adapt and change in response to different situations, remaining resilient and open to new possibilities.",
    upsidedown: "A complete reversal of the expected or normal order or orientation, where things are viewed from a different perspective and understanding.",
    muted: "A subdued or toned-down version of something, lacking the usual intensity or vibrancy, creating a sense of calmness.",
    visualperception: "The ability to interpret and understand the visual information that is presented to the eyes, including the ability to recognize patterns, shapes, and colors.",
    visualagnosia: "A neurological condition where an individual is unable to recognize or interpret visual information, despite having normal vision.",
    beginning: "The starting point of something, where an idea, process, or journey starts to take shape, signifying the start of something new.",
    end: "The final outcome or conclusion of something, marking the completion of a journey, process or idea.",
    paradox: "A seemingly contradictory statement or situation that may actually be true, defying logical understanding or expectation.",
  },
  symbols: {
    yinyang:
      "The ancient Chinese philosophical concept of dualism, where opposite forces are believed to be interconnected and interdependent in the natural world, such as dark and light, female and male, passive and active. It symbolizes the balance and harmony of the universe.",
  },
  zodiac: {
    capricornus: "The tenth astrological sign in the zodiac, symbolized by a sea-goat, it is associated with the characteristics of ambition, practicality, and traditional values.",
    aquarius: "The eleventh astrological sign in the zodiac, symbolized by a water-bearer, it is associated with the characteristics of individuality, innovation, and humanitarianism.",
    pisces: "The twelfth astrological sign in the zodiac, symbolized by two fish, it is associated with the characteristics of empathy, intuition, and creativity.",
    taurus: "The second astrological sign in the zodiac, symbolized by a bull, it is associated with the characteristics of determination, sensuality, and practicality.",
    gemini: "The third astrological sign in the zodiac, symbolized by twins, it is associated with the characteristics of adaptability, communication, and curiosity.",
    cancer: "The fourth astrological sign in the zodiac, symbolized by a crab, it is associated with the characteristics of emotionality, intuition, and nurturing.",
    leo: "The fifth astrological sign in the zodiac, symbolized by a lion, it is associated with the characteristics of leadership, self-expression, and generosity.",
    virgo: "The sixth astrological sign in the zodiac, symbolized by a virgin, it is associated with the characteristics of practicality, attention to detail, and helpfulness.",
    libra: "The seventh astrological sign in the zodiac, symbolized by a scales, it is associated with the characteristics of balance, diplomacy, and a love of beauty.",
    scorpio: "The eight astrological sign in the zodiac, symbolized by a scorpion, it is associated with the characteristics of intensity, passion, and resourcefulness.",
    sagittarius: "The ninth astrological sign in the zodiac, symbolized by an archer, it is associated with the characteristics of optimism, adventure, and a love of learning.",
    aries: "The first astrological sign in the zodiac, symbolized by a Ram, it is associated with the characteristics of energy, assertiveness, and leadership.",
  },
  numbers: {
    n10: "The embodiment of completeness and wholeness, a culmination of the journey from one to nine, a satisfying finish.",
    ten: "The embodiment of completeness and wholeness, a culmination of the journey from one to nine, a satisfying finish.",
    n100: "A grand and majestic number, representing a vast and abundant quantity, the symbol of greatness and achievement.",
    hundred: "A grand and majestic number, representing a vast and abundant quantity, the symbol of greatness and achievement.",
    n1000: "A seemingly endless expanse, an overwhelming multitude, a plethora of possibilities and opportunities.",
    thousand: "A seemingly endless expanse, an overwhelming multitude, a plethora of possibilities and opportunities.",
    n10000: "A staggering and impressive number, representing an unmeasurable amount, a symbol of boundless potential and magnitude.",
    tenthousand: "A staggering and impressive number, representing an unmeasurable amount, a symbol of boundless potential and magnitude.",
    n100000: "A monumental and awe-inspiring quantity, a symbol of unparalleled wealth and prosperity, a number that embodies grandeur and opulence.",
    hundredthousand: "A monumental and awe-inspiring quantity, a symbol of unparalleled wealth and prosperity, a number that embodies grandeur and opulence.",
    n1000000: "A dizzying, incomprehensible number, representing an unfathomable amount, a symbol of boundless wealth and success.",
    million: "A dizzying, incomprehensible number, representing an unfathomable amount, a symbol of boundless wealth and success.",
    n10000000: "A truly staggering and awe-inspiring quantity, embodying an unimaginable magnitude, a symbol of immense power and influence.",
    tenmillion: "A truly staggering and awe-inspiring quantity, embodying an unimaginable magnitude, a symbol of immense power and influence.",
    n100000000: "An astronomical and incomprehensible number, representing a truly massive and incomprehensible quantity, a symbol of unrivaled grandeur and prestige.",
    hundredmillion: "An astronomical and incomprehensible number, representing a truly massive and incomprehensible quantity, a symbol of unrivaled grandeur and prestige.",
    n1000000000: "A number so large it becomes difficult to comprehend, representing an astronomical and almost incomprehensible quantity, a symbol of unfathomable wealth and success.",
    billion: "A number so large it becomes difficult to comprehend, representing an astronomical and almost incomprehensible quantity, a symbol of unfathomable wealth and success.",
    n10000000000: "An truly mind-boggling quantity, embodying an unimaginable magnitude, a symbol of immense power and influence that defies comprehension.",
    tenbillion: "An truly mind-boggling quantity, embodying an unimaginable magnitude, a symbol of immense power and influence that defies comprehension.",
    n100000000000: "A number so grand, vast and incomprehensible, representing wealth and success on an unprecedented level, a symbol of unparalleled grandeur and prestige.",
    hundredbillion: "A number so grand, vast and incomprehensible, representing wealth and success on an unprecedented level, a symbol of unparalleled grandeur and prestige.",
    trillion: "A number so staggeringly large, it boggles the mind and defies imagination, a never-ending expanse of zeroes stretching to infinity.",
    tentrillion: "A number so incomprehensibly vast, it transcends human understanding, a monument to the boundless potential of humanity.",
    hundredtrillion: "A number so enormous, it becomes almost abstract, a representation of the infinite possibilities and complexity of the universe.",
    quadrillion: "A number of such unfathomable magnitude, it represents an age, an eon of time, a incomprehensible measure of anything.",
  },
  numbersystem: {
    unary: "A solitary and distinct entity, representing the simplest and most fundamental form of something.",
    binary: "The foundation of computation, a duality of opposite states, a system of true and false, on and off.",
    ternary: "A trinity of possibilities, a balance of three elements, a representation of the past, present and future.",
    quaternary: "A harmonious composition of four parts, a system of stability and balance, a representation of the four seasons, the four cardinal directions, and the four elements.",
    quinary: "A quintessence of five parts, a representation of the five senses, the five elements, and the five fingers on a hand, a number of balance and harmony.",
    senary: "The number of perfection, completeness, and harmony, representing the six days of creation in the Bible, and the six sides of a cube.",
    septnary: "The number of mystery, the number of the goddess, the number of the sacred and the divine, representing the seven days of the week, and the seven colors of the rainbow.",
    octal: "The number of balance, of harmony and symmetry, representing the eight directions of the compass, and the eight limbs of yoga.",
    nonary: "The number of intuition, of inner wisdom, and of spiritual insight, representing the nine months of pregnancy, and the nine muses in Greek mythology.",
    decimal: "The number system used in everyday life, based on the number ten, representing completeness and wholeness.",
    hexadecimal: "A number system used in computing, based on the number sixteen, representing a larger set of values than decimal or binary.",
    base2: "The binary number system, used in computing and digital systems, with only two digits 0 and 1, representing on and off states.",
    base4: "A quaternary number system, used in some computing applications, with four digits, representing a balance of four elements.",
    base8: "An octal number system, used in some computing applications, with eight digits, representing balance and symmetry.",
    base10: "The decimal number system, used in everyday life, with ten digits, representing completeness and wholeness.",
    base16: "The hexadecimal number system, used in computing, with sixteen digits, representing a larger set of values than decimal or binary.",
    base20: "A vigesimal number system, used in some ancient cultures and still in use in some cultures around the world, with twenty digits, representing a larger set of values than decimal.",
    base24: "A base-24 system, used in some computing applications, with 24 digits, representing a larger set of values than decimal or binary.",
    base32: "A base-32 system, used in some computing applications, with 32 digits, representing a larger set of values than decimal or binary.",
    base64: "A base-64 system, used in some computing applications, with 64 digits, representing a larger set of values than decimal or binary.",
  },
};

export const REFERENCEMEDIA = {
  animestudios: {
    animemadhousestudio: "Madhouse Studios",
    animebonesstudio: "Studio Bones",
    animekyotoanimationstudio: "Kyoto Animation Studio",
    animewitstudio: "Wit Studio",
    animetoeianimationsstudio: "Toei Animation Studio",
    animemappastudio: "MAPPA Studio",
    animeghiblistudio: "Studio Ghibli",
    animesunrisestudio: "Sunrise Studio",
    animea1picturesstudio: "A-1 Pictures",
    animeufotablestudio: "Ufotable",
    animepierrotstudio: "Studio Pierrot",
    animetriggerstudio: "Studio Trigger",
    animepaworksstudio: "P.A.Works",
    animejcstaffstudio: "J.C.Staff",
    animebrainsbasestudio: "Brain's Base",
    animecloverworksstudio: "Cloverworks",
    animegainaxstudio: "GainAX",
    animeproductionigstudio: "Production IG",
    animeshaftstudio: "Shaft",
    animewhitefoxstudio: "White Fox",
  },

  videogames: {
    pubgbattlegrounds: "PUBG: Battlegrounds",
    crossfire: "CrossFire",
    dungeonfighteronline: "Dungeon Fighter Online",
    minecraft: "Minecraft",
    qqspeed: "QQ Speed",
    pacman: "Pac-Man",
    mario: "Mario",
    candycrush: "Candy Crush",
    fortnite: "Fortnite",
    runescape: "Runescape",
    worldofwarcraft: "World of Warcraft",
    roblox: "Roblox",
    maplestory: "Maple Story",
    terraria: "Terraria",
    grandtheftautov: "Grand Theft Auto V",
    clubpenguin: "Club Penguin",
    worldoftanks: "World of Tanks",
    farmville: "Farmville",
    leagueoflegends: "League of Legends",
    cityville: "Cityville",
    overwatch: "Overwatch",
    csgo: "CSGO",
    teamfortress2: "Team Fortress 2",
    warframe: "Warframe",
    leftfordead: "Left for Dead",
    callofduty: "Call of Duty",
    finalfantasy: "Final Fantasy",
    pokemon: "Pokemon",
    osu: "OSU!",
    doom: "Doom",
    starwars: "Star Wars",
    skyrim: "Skyrim",
    fallout: "Fallout",
    elderscrolls: "Elder Scrolls",
    robocraft: "Robocraft",
    pong: "Pong",
    sonic: "Sonic",
    mortalcombat: "Mortal Combat",
    fifa: "FIFA",
    guitarhero: "Guitar Hero",
    halo: "Halo",
  },
};

export const REFERENCEMEDIA_DESC = {
  animestudios: {
    animemadhousestudio:
      'Known for their visually stunning animation and attention to detail, Madhouse Studios creates anime that are both beautiful and intense. Their most famous work, "Death Note", is a psychological thriller that explores the blurred lines between good and evil.',
    animebonesstudio:
      'Studio Bones is known for their ability to bring complex stories to life through dynamic animation and character development. Their most famous work, "Fullmetal Alchemist: Brotherhood", is a masterful retelling of the original manga that delves deep into the human condition.',
    animekyotoanimationstudio:
      'Kyoto Animation Studio is renowned for their emotive and relatable stories, brought to life through stunning animation and heartwarming characters. Their most famous work, "K-On!", is a slice-of-life anime that captures the joys and struggles of youth with undeniable warmth and charm.',
    animewitstudio:
      'Wit Studio is known for their visually striking animation and masterful storytelling, creating anime that are both epic and thought-provoking. Their most famous work, "Attack on Titan", is a dystopian epic that explores the human condition in the face of seemingly insurmountable adversity.',
    animetoeianimationsstudio:
      'Toei Animation Studio is one of the oldest and most established anime studios in Japan, known for their iconic and enduring anime series such as "Dragon Ball" and "Sailor Moon". Their style is characterized by its dynamic action, colorful animation, and memorable characters.',
    animemappastudio:
      'MAPPA Studio is a relatively new but rapidly rising studio, known for their innovative and visually striking anime such as "Yuri!!! on Ice" and "Jujutsu Kaisen". Their style is characterized by its unique animation techniques and storytelling that pushes the boundaries of the genre.',
    animeghiblistudio:
      'Studio Ghibli is a legendary anime studio known for their heartwarming and visually stunning anime, such as "Spirited Away" and "My Neighbor Totoro". Their style is characterized by its masterful storytelling, detailed animation, and breathtaking landscapes that transport viewers to another world.',
    animesunrisestudio:
      'Sunrise Studio is known for their groundbreaking anime such as "Mobile Suit Gundam" and "Cowboy Bebop". Their style is characterized by its complex and thought-provoking storylines, cutting-edge animation, and memorable characters that shape the future of anime.',
    animea1picturesstudio:
      'A-1 Pictures is known for their versatile style that ranges from fantasy to action to romance and comedy, as seen in anime such as "Sword Art Online" and "Your Lie in April". Their animation is smooth and polished, with a special attention to fine details.',
    animeufotablestudio:
      'Ufotable is known for their visually spectacular anime, such as "Fate/Stay Night" and "Demon Slayer: Kimetsu no Yaiba". Their animation is fluid and dynamic, with breathtaking fight scenes and stunning landscapes. They also have a special attention to lighting and color.',
    animepierrotstudio:
      'Studio Pierrot is known for their long-running anime series and their iconic adaptations of famous manga series such as "Naruto" and "Bleach". Their animation is colorful, lively and engaging, with a special attention to movement and facial expressions.',
    animetriggerstudio:
      'Studio Trigger is known for their innovative and visually striking anime, such as "Kill la Kill" and "Little Witch Academia". Their animation is dynamic, creative and bold, with a special attention to creative storytelling and character development. They also have a special attention to action and movement.',
    animepaworksstudio:
      'Known for their visually stunning animation and attention to detail, P.A.Works creates anime that are both beautiful and emotionally engaging. Their most famous work, "Nagi no Asukara", is a coming-of-age story that explores the complexities of growing up and falling in love.',
    animejcstaffstudio:
      'J.C.Staff is known for their ability to bring complex stories to life through dynamic animation and character development. Their most famous work, "Toradora!", is a romantic comedy that explores the complexities of teenage love and friendship with heart and humor.',
    animebrainsbasestudio:
      'Brain\'s Base is renowned for their emotive and relatable stories, brought to life through stunning animation and heartwarming characters. Their most famous work, "Bungo Stray Dogs", is an action-packed anime that explores the power of literature and the human spirit.',
    animecloverworksstudio:
      'Cloverworks is known for their visually striking animation and masterful storytelling, creating anime that are both epic and thought-provoking. Their most famous work, "Darling in the FranXX", is a dystopian epic that explores the human condition in the face of seemingly insurmountable adversity.',
    animegainaxstudio:
      'Known for their visually stunning animation and attention to detail, GainAX creates anime that are both beautiful and intellectually stimulating. Their most famous work, "Neon Genesis Evangelion", is a psychological thriller that explores the blurred lines between good and evil.',
    animeproductionigstudio:
      'Production IG is known for their ability to bring complex stories to life through dynamic animation and character development. Their most famous work, "Ghost in the Shell", is a masterful retelling of the original manga that delves deep into the human condition.',
    animeshaftstudio:
      'Shaft is renowned for their emotive and relatable stories, brought to life through stunning animation and heartwarming characters. Their most famous work, "Monogatari Series", is a series of anime that captures the joys and struggles of youth with undeniable warmth and charm.',
    animewhitefoxstudio:
      'White Fox is known for their visually striking animation and masterful storytelling, creating anime that are both epic and thought-provoking. Their most famous work, "Re:ZERO - Starting Life in Another World", is a fantasy epic that explores the human condition in the face of seemingly insurmountable adversity.',
  },

  videogames: {
    pubgbattlegrounds: "A heart-pumping, action-packed battle royale game where players fight to be the last one standing on a deserted island.",
    crossfire: "A fast-paced, adrenaline-fueled first-person shooter where players choose between two rival factions and engage in intense multiplayer battles.",
    dungeonfighteronline: "A thrilling, beat-em-up action RPG where players battle hordes of monsters and bosses in side-scrolling dungeons.",
    minecraft: "A creative, open-world sandbox game where players can explore, build, and survive in a block-based world full of wonder and adventure.",
    qqspeed: "A high-speed racing game where players race against each other on various tracks with different types of vehicles.",
    pacman: "A classic, fast-paced arcade game where players control Pac-Man as he navigates through a maze, eating dots and avoiding ghosts.",
    mario: "A beloved platformer where players guide Mario through a variety of worlds, collecting coins and defeating enemies to rescue Princess Peach.",
    candycrush: "A colorful and addictive puzzle game where players match different types of cand to progress through levels and achieve high scores.",
    fortnite: "A wildly popular battle royale game where players fight to be the last one standing on a deserted island, utilizing a variety of weapons and building skills.",
    runescape: "A massively multiplayer online role-playing game (MMORPG) where players can explore a vast fantasy world, complete quests, and engage in player vs player combat.",
    worldofwarcraft:
      "A massively multiplayer online role-playing game (MMORPG) set in a fantasy world, where players can choose from a variety of races and classes to create a unique character and embark on epic quests and battles.",
    roblox: "A massively multiplayer online game platform where players can create and share their own games, socialize with other players, and engage in a variety of activities.",
    maplestory: "A whimsical, massively multiplayer online role-playing game where players embark on epic quests and battle monsters in a colorful fantasy world.",
    terraria: "A captivating, 2D sandbox adventure game where players can explore, build, and fight their way through a variety of biomes and bosses.",
    grandtheftautov: "A open world action-adventure game that players can explore the city, commit crimes, and complete missions, all while immersing themselves in a living, breathing world.",
    clubpenguin: "A light-hearted, massively multiplayer online game where players can create their own penguin avatars, socialize with other players, and play mini-games in a virtual world.",
    worldoftanks: "A tactical, armored warfare game where players command historically accurate tanks and engage in intense multiplayer battles.",
    farmville: "A casual, farming simulation game where players can build and manage their own virtual farm, grow crops and raise livestock.",
    leagueoflegends: "A strategic, fast-paced MOBA game where players control powerful champions and team up to destroy the enemy's base.",
    cityville: "A town-building simulation game where players can construct and manage their own city, grow it and earn rewards by completing various missions.",
    overwatch: "A fast-paced, team-based first-person shooter where players select from a diverse cast of heroes and work together to complete objectives and eliminate the enemy team.",
    csgo: "A tactical, first-person shooter where teams compete in bomb-defusal and hostage-rescue scenarios and players must work together to outsmart and outshoot the opposing team.",
    teamfortress2:
      "A class-based, team-oriented first-person shooter where players select from a variety of character classes, each with their own unique abilities, and work together to complete objectives and eliminate the enemy team.",
    warframe:
      "A fast-paced, co-operative third-person shooter where players control ancient warriors known as Warframes and battle through hordes of enemies to complete missions and uncover the mysteries of the universe.",
    leftfordead: "A cooperative, first-person shooter where players fight against hordes of zombies and other monsters in a desperate attempt to survive and escape.",
    callofduty: "A fast-paced, intense first-person shooter where players engage in multiplayer battles and fight to complete objectives and eliminate the enemy team.",
    finalfantasy: "A epic, fantasy RPG where players embark on an epic journey through a vast world filled with magic and monsters, and make choices that shape their destiny.",
    pokemon: "A charming, turn-based RPG where players catch and train pocket monsters, battle against other trainers, and work to become the ultimate Pokemon Master.",
    osu: "A rhythm-based, music game where players use a cursor to hit notes in time to the beat of the music.",
    doom: "A classic, first-person shooter where players fight against hordes of demons and other monsters in a fast-paced, gory battle to save humanity from certain doom.",
    starwars: "An epic, space-fantasy game where players can immerse themselves in the iconic Star Wars universe and experience thrilling lightsaber battles and interstellar adventures.",
    skyrim: "A vast, open-world RPG set in the rugged wilderness of Tamriel, where players can explore ancient ruins, battle dragons, and forge their own destiny.",
    fallout: "A post-apocalyptic RPG where players navigate a world ravaged by nuclear war and make choices that will shape the future of humanity.",
    elderscrolls: "A rich, immersive RPG series that invites players to explore the vast and diverse world of Tamriel and discover its many secrets and stories.",
    robocraft: "A creative, building-based multiplayer game where players design, build and pilot their own robots, and engage in epic robot battles in various game modes.",
    pong: "A classic, simple and addictive two-dimensional game where players control paddles and hit a ball back and forth, trying to outscore their opponent.",
    sonic: "A fast-paced, platformer game featuring the iconic blue hedgehog as the main character, who runs, jumps and spin-attacks his way through various levels.",
    mortalcombat: "A intense, fighting game where players control a diverse cast of characters and use their unique fighting styles and special moves to defeat their opponents.",
    fifa: "A realistic and immersive soccer simulation game where players control their favorite teams and players and compete in matches and tournaments.",
    guitarhero: "A rhythm-based game where players use a special guitar-shaped controller to simulate playing along with popular songs.",
    halo: "A first-person shooter game that immerses players in a futuristic war between humanity and an alien threat known as the Covenant, in a epic and cinematic single-player campaign and multiplayer modes.",
  },
};

export const generatorKeys = {
  concepts: {
    end: "End",
    beginning: "Beginning",
    love: "Love",
    hate: "Hate",
    anger: "Anger",
    sadness: "Sadness",
    joy: "Joy",
    fear: "Fear",
    disgust: "Disgust",
    surprise: "Surprise",
    trust: "Trust",
    anticipation: "Anticipation",
    pity: "Pity",
    gloating: "Gloating",
    remorse: "Remorse",
    vigilance: "Vigilance",
    grief: "Grief",
    embarrassment: "Embarrassment",
    admiration: "Admiration",
    compassion: "Compassion",
    contentment: "Contentment",
    despair: "Despair",
    envy: "Envy",
    excitement: "Excitement",
    gratification: "Gratification",
    hope: "Hope",
    humiliation: "Humiliation",
    insecurity: "Insecurity",
    jealousy: "Jealousy",
    loathing: "Loathing",
    lust: "Lust",
    pride: "Pride",
    relief: "Relief",
    satisfaction: "Satisfaction",
    serenity: "Serenity",
    shame: "Shame",
    sympathy: "Sympathy",
    triumph: "Triumph",
    abandon: "Abandon",
    absence: "Absence",
    absurdity: "Absurdity",
    acceptance: "Acceptance",
    accessibility: "Accessibility",
    accountability: "Accountability",
    accuracy: "Accuracy",
    acquisition: "Acquisition",
    adaptability: "Adaptability",
    addiction: "Addiction",
    adherence: "Adherence",
    adjustment: "Adjustment",
    advancement: "Advancement",
    advantage: "Advantage",
    aggression: "Aggression",
    agility: "Agility",
    ailment: "Ailment",
    air: "Air",
    alarm: "Alarm",
    alertness: "Alertness",
    allergy: "Allergy",
    alternative: "Alternative",
    ambition: "Ambition",
    amusement: "Amusement",
    anguish: "Anguish",
    animosity: "Animosity",
    anonymity: "Anonymity",
    transcendence: "Transcendence",
    misanthropy: "Misanthropy",
    somnambulism: "Somnambulism",
    paralysis: "Paralysis",
    narcissism: "Narcissism",
    agoraphobia: "Agoraphobia",
    aesthesia: "Aesthesia",
    amnesia: "Amnesia",
    anorexia: "Anorexia",
    anxiety: "Anxiety",
    apathy: "Apathy",
    autophobia: "Autophobia",
    bulimia: "Bulimia",
    catatonia: "Catatonia",
    claustrophobia: "Claustrophobia",
    derealization: "Derealization",
    depersonalization: "Depersonalization",
    depression: "Depression",
    dysthymia: "Dysthymia",
    ellipsis: "Ellipsis",
    euphoria: "Euphoria",
    glossolalia: "Glossolalia",
    hallucination: "Hallucination",
    homesickness: "Homesickness",
    power: "Power",
    unknown: "Unknown",
    thephysicalworld: " the physical world",
    thegods: "The gods",
    deity: "Deity",
    theafterlife: "The afterlife",
    reincarnation: "Reincarnation",
    karma: "Karma",
    nirvana: "Nirvana",
    samsara: "Samsara",
    enlightenment: "Enlightenment",
    consciousness: "Consciousness",
    subconsciousness: "Subconsciousness",
    unconsciousness: "Unconsciousness",
    supernatural: "Supernatural",
    occult: "Occult",
    mystical: "Mystical",
    spiritual: "Spiritual",
    psychic: "Psychic",
    telepathic: "Telepathic",
    extrasensory: "Extrasensory",
    clairsentient: "Clairsentient",
    empathic: "Empathic",
    astral: "Astral",
    etheric: "Etheric",
    dimension: "Dimension",
    paralleluniverse: "Parallel universe",
    multiverse: "Multiverse",
    simulation: "Simulation",
  },
  objects: {
    utahteapot: "Utah Teapot",
    teapot: "Teapot",
    book: "book",
    pencil: "pencil",
    pen: "pen",
    paper: "paper",
    chair: "chair",
    desk: "desk",
    computer: "computer",
    television: "television",
    camera: "camera",
    lamp: "lamp",
    tree: "tree",
    tomato: "tomato",
    car: "car",
    house: "house",
    phone: "phone",
    newspaper: "newspaper",
    magazine: "magazine",
    fork: "fork",
    knife: "knife",
    spoon: "spoon",
    plate: "plate",
    bowl: "bowl",
    window: "window",
    door: "door",
    blanket: "blanket",
    pillow: "pillow",
    sheet: "sheet",
    laptop: "laptop",
    castle: "castle",
    mirror: "mirror",
    rock: "rock",
    geode: "geode",
    gemstone: "gemstone",
    motercycle: "motercycle",
    canvas: "Canvas",
    crowbar: "Crowbar",
    fryingpan: "Frying Pan",
    incenseholder: "Incense Holder",
    bottleofglue: "Bottle of Glue",
    pinecone: "Pinecone",
    comb: "Comb",
    perfume: "Perfume",
    lipgloss: "Lip Gloss",
    spider: "Spider",
    fly: "Fly",
    candle: "Candle",
    cup: "Cup",
    dish: "Dish",
    box: "Box",
    container: "Container",
    lid: "Lid",
    package: "Package",
    envelope: "Envelope",
    garbagecan: "Garbage Can",
    trashcan: "Trash Can",
    sword: "Sword",
    bow: "Bow",
    axe: "Axe",
    club: "Club",
    dagger: "Dagger",
    halberd: "Halberd",
    lance: "Lance",
    mace: "Mace",
    morningstar: "Morningstar",
    pike: "Pike",
    rapier: "Rapier",
    scimitar: "Scimitar",
    sickle: "Sickle",
    spear: "Spear",
    staff: "Staff",
    wand: "Wand",
    warhammer: "Warhammer",
    crossbow: "Crossbow",
    flail: "Flail",
    glaive: "Glaive",
    greateaxe: "Greateaxe",
    greatclub: "Greatclub",
    greatsword: "Greatsword",
    handaxe: "Handaxe",
    katana: "Katana",
    longbow: "Longbow",
    longsword: "Longsword",
    quarterstaff: "Quarterstaff",
    shortbow: "Shortbow",
    shortspear: "Shortspear",
    scythe: "Scythe",
    shield: "Shield",
    towershield: "Tower Shield",
    buckler: "Buckler",
    chain: "Chain",
    chainmail: "Chainmail",
    magicdoor: "Magic Door",
    magicgate: "Magic Gate",
    magictreasure: "Magic Treasure",
    magicbean: "Magic Bean",
    magiclamp: "Magic Lamp",
    magiccarpet: "Magic Carpet",
    magicflute: "Magic Flute",
    magichorn: "Magic Horn",
    magicspinningwheel: "Magic Spinning Wheel",
    magicshovel: "Magic Shovel",
    magicsickle: "Magic Sickle",
    magicbroom: "Magic Broom",
    magicpot: "Magic Pot",
    magickey: "Magic Key",
    magicspell: "Magic Spell",
    magicscroll: "Magic Scroll",
    magicwand: "Magic Wand",
    magicmirror: "Magic Mirror",
    magicscales: "Magic Scales",
    magicwallet: "Magic Wallet",
    magiccoin: "Magic Coin",
    magiccup: "Magic Cup",
    magicdagger: "Magic Dagger",
    magictree: "Magic Tree",
    magicflower: "Magic Flower",
    magicriver: "Magic River",
    magicocean: "Magic Ocean",
    magicisland: "Magic Island",
    magicsun: "Magic Sun",
    magicmoon: "Magic Moon",
    magicstars: "Magic Stars",
    magicstaff: "Magic Staff",
    magicorb: "Magic Orb",
    rune: "rune",
    magicsword: "Magic Sword",
    magicshield: "Magic Shield",
    magicring: "Magic Ring",
    magicamulet: "Magic Amulet",
    magicarmor: "Magic Armor",
    magictome: "Magic Tome",
    magicbow: "Magic Bow",
    magichat: "Magic Hat",
    magicboots: "Magic Boots",
    magiccloak: "Magic Cloak",
    magicgauntlets: "Magic Gauntlets",
    magichorse: "Magic Horse",
    magicboat: "Magic Boat",
    magicbridge: "Magic Bridge",
    pistol: "Pistol",
    rifle: "Rifle",
    shotgun: "Shotgun",
    machinegun: "Machine Gun",
    sniperrifle: "Sniper Rifle",
    assaultrifle: "Assault Rifle",
    submachinegun: "Submachine Gun",
    flaregun: "Flare Gun",
    paintballgun: "Paintball Gun",
    BBgun: "BB Gun",
    pelletgun: "Pellet Gun",
    airsoftgun: "Airsoft Gun",
    stungun: "Stun Gun",
    taser: "Taser",
    nunchaku: "Nunchaku",
    unbreakablefield: "Unbreakable Field",
    covertchip: "Covert Chip",
    cyberweave: "Cyberweave",
    datajack: "Datajack",
    digitalmask: "Digital Mask",
    eclipsecontact: "Eclipse Contact",
    fiberopticcable: "Fiber Optic Cable",
    gravchute: "Gravchute",
    hologramprojector: "Hologram Projector",
    hovercar: "Hovercar",
    invisibilitycloak: "Invisibility Cloak",
    jumppack: "Jumppack",
    lasercutter: "Laser Cutter",
    maglevtrain: "Maglev Train",
    molecularassembler: "Molecular Assembler",
    nanobot: "Nanobot",
    neuralinterface: "Neural Interface",
    oracle: "Oracle",
    personalforcefield: "Personal Force Field",
    pulserifle: "Pulse Rifle",
    roboticexoskeleton: "Robotic Exoskeleton",
    sentientcomputer: "Sentient Computer",
    smartgunsystem: "Smartgun System",
    spaceship: "Spaceship",
    stasischamber: "Stasis Chamber",
    teleportationdevice: "Teleportation Device",
    thermopticcamo: "Thermoptic Camo",
    timemachine: "Time Machine",
    virtualreality: "Virtual Reality",
    weaponizeddrone: "Weaponized Drone",
    zeropointenergy: "Zero-Point Energy",
    hoverbike: "Hoverbike",
    laserpistol: "Laser Pistol",
    nanofactory: "Nanofactory",
    omnitool: "Omnitool",
    powerarmor: "Power Armor",
    psionicamplifier: "Psionic Amplifier",
    quantumbreakdownfield: "Quantum Breakdown Field",
    rocketpack: "Rocket Pack",
    smartgun: "Smartgun",
    stasisfieldgenerator: "Stasis Field Generator",
    teleporter: "Teleporter",
    thermaldetonator: "Thermal Detonator",
    vibroblade: "Vibroblade",
    virtualrealitysystem: "Virtual Reality System",
    warpfieldgenerator: "Warp Field Generator",
    xraygoggles: "X-Ray Goggles",
    bus: "Bus",
    taxi: "Taxi",
    bicycle: "Bicycle",
    motorcycle: "Motorcycle",
    boat: "Boat",
    airplane: "Airplane",
    helicopter: "Helicopter",
    rocket: "Rocket",
    truck: "Truck",
  },
  people_jobs: {
    monk: "Monk",
    nun: "Nun",
    pilgrim: "Pilgrim",
    missionary: "Missionary",
    preacher: "Preacher",
    evangelist: "Evangelist",
    pastor: "Pastor",
    priest: "Priest",
    rabbi: "Rabbi",
    imam: "Imam",
    guru: "Guru",
    swami: "Swami",
    engineer: "engineer",
    accountant: "accountant",
    lawyer: "lawyer",
    doctor: "doctor",
    dentist: "dentist",
    veterinarian: "veterinarian",
    pharmacist: "pharmacist",
    physicaltherapist: "physical therapist",
    occupationaltherapist: "occupational therapist",
    speechtherapist: "speech therapist",
    psychologist: "psychologist",
    counselor: "counselor",
    socialworker: "social worker",
    lifeguard: "lifeguard",
    coach: "coach",
    personaltrainer: "personal trainer",
    nutritionist: "nutritionist",
    dietitian: "dietitian",
    chef: "chef",
    barista: "barista",
    babysitter: "babysitter",
    petsitter: "pet sitter",
    housekeeper: "housekeeper",
    scribe: "scribe",
    jester: "jester",
    knight: "knight",
    page: "page",
    maid: "maid",
    butler: "butler",
    cook: "cook",
    gardener: "gardener",
    nurse: "nurse",
    teacher: "teacher",
    coachman: "coachman",
    artist: "artist",
    pilot: "pilot",
    sailor: "sailor",
    soldier: "soldier",
    farmer: "farmer",
    baker: "baker",
    carpenter: "carpenter",
    miner: "miner",
    barber: "barber",
    waiter: "waiter",
    blacksmith: "blacksmith",
    bricklayer: "bricklayer",
    samurai: "samurai",
    barbarian: "barbarian",
    berserker: "berserker",
    champion: "champion",
    conqueror: "conqueror",
    crusader: "crusader",
    defender: "defender",
    guardian: "guardian",
    hero: "hero",
    legend: "legend",
    paladin: "paladin",
    patriot: "patriot",
    protector: "protector",
    savage: "savage",
    sentinel: "sentinel",
    templar: "templar",
    viking: "viking",
    warlord: "warlord",
    wizard: "wizard",
    mage: "mage",
    necromancer: "necromancer",
    enchanter: "enchanter",
    conjurer: "conjurer",
    sorcerer: "sorcerer",
    warlock: "warlock",
    witch: "witch",
    alchemist: "alchemist",
    magus: "magus",
    thaumaturge: "thaumaturge",
    arcanist: "arcanist",
    elementalist: "elementalist",
    runemaster: "runemaster",
    geomancer: "geomancer",
    cryomancer: "cryomancer",
    pyromancer: "pyromancer",
    aeromancer: "aeromancer",
    hydromancer: "hydromancer",
    lumicant: "lumicant",
    spellbinder: "spellbinder",
    illusionist: "illusionist",
    mindmage: "mind mage",
    psychic: "psychic",
    seer: "seer",
    oracle: "oracle",
    prophet: "prophet",
  },
  people_ethnicities: {
    strecatist: "Strecatist",
    zihetist: "Zihetist ",
    promusni: "Promusni ",
    lucusist: "Lucusist ",
    xenophilist: "Xenophilist ",
    pantheist: "Pantheist ",
    nihilist: "Nihilist ",
    egoist: "Egoist ",
    fideist: "Fideist ",
    deist: "Deist ",
    christian: "Christian",
    buddhist: "Buddhist",
    hindu: "Hindu",
    muslim: "Muslim",
    atheist: "Atheist",
    taoist: "Taoist",
    sikh: "Sikh",
    jain: "Jain",
    bahai: "Baha'i",
    confucian: "Confucian",
    shinto: "Shinto",
    zoroastrian: "Zoroastrian",
    animist: "Animist",
    pagan: "Pagan",
    secular: "Secular",
    asian: "asian",
    black: "black",
    inuit: "inuit",
    indian: "indian",
    middleeastern: "middle eastern",
    pakistani: "pakistani",
    chinese: "chinese",
    japanese: "japanese",
    korean: "korean",
    mongolian: "mongolian",
    tibetan: "tibetan",
    thai: "thai",
    laotian: "laotian",
    cambodian: "cambodian",
    vietnamese: "vietnamese",
    malaysian: "malaysian",
    burmese: "burmese",
    indonesian: "indonesian",
    singaporean: "singaporean",
    hongkonger: "hong konger",
    taiwanese: "taiwanese",
    nepalese: "nepalese",
    bhutanese: "bhutanese",
    bangladeshi: "bangladeshi",
    american: "american",
    srilankan: "sri lankan",
    afghan: "afghan",
    iranian: "iranian",
    iraqi: "iraqi",
    israeli: "israeli",
    palestinian: "palestinian",
    syrian: "syrian",
    turkish: "turkish",
    human: "human",
    elf: "elf",
    elemental: "elemental",
    dwarf: "dwarf",
    giant: "giant",
    halfling: "halfling",
    lizardfolk: "lizardfolk",
    merfolk: "merfolk",
    orc: "orc",
    aasimar: "aasimar",
    bugbear: "bugbear",
    changeling: "changeling",
    dragonborn: "dragonborn",
    firbolg: "firbolg",
    gnome: "gnome",
    goblin: "goblin",
    griffon: "griffon",
    hobgoblin: "hobgoblin",
    kenku: "kenku",
    kirin: "kirin",
    kitsune: "kitsune",
    kobold: "kobold",
    leonin: "leonin",
    loxodon: "loxodon",
    minotaur: "minotaur",
    mule: "mule",
    nagaji: "nagaji",
    nezumi: "nezumi",
    oni: "oni",
    pony: "pony",
    rakshasa: "rakshasa",
    ratfolk: "ratfolk",
    samurai: "samurai",
    satyr: "satyr",
    sea_elf: "sea elf",
    shifter: "shifter",
    siren: "siren",
    sprite: "sprite",
    strix: "strix",
    tengu: "tengu",
    triton: "triton",
    vanara: "vanara",
    vedalken: "vedalken",
    warforged: "warforged",
    wemic: "wemic",
    yuan_ti_pureblood: "yuan-ti pureblood",
  },

  animal: {
    cow: "cow",
    dog: "dog",
    cat: "cat",
    mouse: "mouse",
    rat: "rat",
    pig: "pig",
    horse: "horse",
    donkey: "donkey",
    sheep: "sheep",
    goat: "goat",
    chicken: "chicken",
    duck: "duck",
    turkey: "turkey",
    lizard: "lizard",
    turtle: "turtle",
    frog: "frog",
    toad: "toad",
    bird: "bird",
    tiger: "tiger",
    bear: "bear",
    wolf: "wolf",
    snake: "snake",
    dragon: "dragon",
    phoenix: "phoenix",
    griffin: "griffin",
    mermaid: "mermaid",
    centaur: "centaur",
    minotaur: "minotaur",
    pegasus: "pegasus",
    wyvern: "wyvern",
    unicorn: "unicorn",
    ant: "ant",
    beetle: "beetle",
    butterfly: "butterfly",
    cicada: "cicada",
    cockroach: "cockroach",
    dragonfly: "dragonfly",
    fly: "fly",
    grasshopper: "grasshopper",
    ladybug: "ladybug",
    moth: "moth",
    termite: "termite",
    wasp: "wasp",
    locust: "locust",
    cricket: "cricket",
    earwig: "earwig",
    firefly: "firefly",
    lacewing: "lacewing",
    prayingmantis: "prayingmantis",
  },
  buildings: {
    room: "room",
    officebuildinginterior: "office building interior",
    restaurant: "restaurant",
    bar: "bar",
    club: "club",
    movie_theater: "movie theater",
    stadium: "stadium",
    concert_hall: "concert hall",
    amusement_park: "amusement park",
    zoo: "zoo",
    aquarium: "aquarium",
    museum: "museum",
    art_gallery: "art gallery",
    library: "library",
    school: "school",
    university: "university",
    daycare: "daycare",
    preschool: "preschool",
    home: "home",
    apartment: "apartment",
    condo: "condo",
    house: "house",
    bathroom: "bathroom",
    bedroom: "bedroom",
    kitchen: "kitchen",
    living_room: "living room",
    dining_room: "dining room",
    attic: "attic",
    basement: "basement",
    garage: "garage",
    closet: "closet",
    mansion: "mansion",
    hotel: "hotel",
    church: "church",
    mosque: "mosque",
    temple: "temple",
    synagogue: "synagogue",
    shrine: "shrine",
    park: "park",
    playground: "playground",
    track: "track",
    pool: "pool",
    beach: "beach",
    river: "river",
    lake: "lake",
    ocean: "ocean",
    cave: "cave",
  },
  landscape: {
    grasslands: "grasslands",
    moonscape: "moonscape",
    wasteland: "wasteland",
    rainforest: "rainforest",
    jungle: "jungle",
    tundra: "tundra",
    desert: "desert",
    canyon: "canyon",
    valley: "valley",
    cliff: "cliff",
    shore: "shore",
    mountain: "mountain",
    volcano: "volcano",
    seascape: "seascape",
    geyser: "geyser",
    aurora: "aurora",
    glacier: "glacier",
    ocean: "ocean",
    beach: "beach",
    woodland: "woodland",
    meadow: "meadow",
    swamp: "swamp",
    marsh: "marsh",
    river: "river",
    waterfall: "waterfall",
    spring: "spring",
    brook: "brook",
    path: "path",
    trail: "trail",
    lakescape: "lakescape",
    cityscape: "cityscape",
    streetscape: "streetscape",
    skyscraper: "skyscraper",
    farmland: "farmland",
    orchard: "orchard",
    vineyard: "vineyard",
    prairie: "prairie",
    savanna: "savanna",
    steppe: "steppe",
    stream: "stream",
    forest: "Forest",
    grassland: "grassland",
    chaparral: "chaparral",
    scrubland: "scrubland",
    taiga: "taiga",
    estuary: "estuary",
    coastline: "coastline",
    mangrove: "mangrove",
    coral: "coral",
    seagrass: "seagrass",
    city: "City",
    village: "Village",
    town: "Town",
    suburb: "Suburb",
    hamlet: "Hamlet",
    metropolis: "Metropolis",
    megalopolis: "Megalopolis",
    agglomoration: "Agglomoration",
    sprawl: "Sprawl",
    slum: "Slum",
    ghetto: "Ghetto",
    barrio: "Barrio",
    favela: "Favela",
    shantytown: "Shantytown",
    settlement: "Settlement",
    colony: "Colony",
    outpost: "Outpost",
    station: "Station",
    camp: "Camp",
    base: "Base",
    township: "Township",
    reservation: "Reservation",
    planet: "Planet",
    sun: "Sun",
    moon: "Moon",
    star: "Star",
    comet: "Comet",
    asteroid: "Asteroid",
    meteor: "Meteor",
    nebula: "Nebula",
    galaxy: "Galaxy",
    quasar: "Quasar",
    black_hole: "Black Hole",
    supernova: "Supernova",
    pulsar: "Pulsar",
    white_dwarf: "White Dwarf",
    red_giant: "Red Giant",
    solar_system: "Solar System",
    milky_way: "Milky Way",
    andromeda: "Andromeda",
    triangulum: "Triangulum",
    local_group: "Local Group",
    virgo_supercluster: "Virgo Supercluster",
    laniakea_supercluster: "Laniakea Supercluster",
    observable_universe: "Observable Universe",
    multiverse: "Multiverse",
    wood: "Wood",
    copse: "Copse",
    bush: "Bush",
    trees: "Trees",
    stand: "Stand",
    wetland: "Wetland",
    fen: "Fen",
    bog: "Bog",
    moor: "Moor",
    heath: "Heath",
    fells: "fells",
    morass: "Morass",
    cloudforest: "Cloudforest",
    plains: "Plains",
    fields: "Fields",
    grass: "Grass",
    savannah: "Savannah",
    floodplain: "Flood plain",
    flats: "Flats",
    iceberg: "Iceberg",
    snowfields: "Snowfields",
    hills: "Hills",
    highland: "Highland",
    heights: "Heights",
    plateau: "Plateau",
    badland: "Badland",
    kame: "Kame",
    shield: "Shield",
    downs: "Downs",
    downland: "Downland",
    ridge: "Ridge",
    ridgeline: "Ridgeline",
    hollow: "Hollow",
    vale: "Vale",
    glen: "Glen",
    dell: "Dell",
    peak: "Peak",
    summit: "Summit",
    rise: "Rise",
    pass: "Pass",
    notch: "Notch",
    crown: "Crown",
    mount: "Mount",
    switchback: "Switchback",
    furth: "Furth",
    bluff: "Bluff",
    ravine: "Ravine",
    gully: "Gully",
    gulch: "Gulch",
    gorge: "Gorge",
    scrub: "Scrub",
    waste: "Waste",
    sands: "Sands",
    dunes: "Dunes",
    crater: "Crater",
    cone: "Cone",
    lava_fields: "Lava Fields",
    sea: "Sea",
    coast: "Coast",
    strand: "Strand",
    bay: "Bay",
    port: "Port",
    harbour: "Harbour",
    fjord: "Fjord",
    vike: "Vike",
    cove: "Cove",
    shoals: "Shoals",
    lagoon: "Lagoon",
    firth: "Firth",
    bight: "Bight",
    sound: "Sound",
    strait: "Strait",
    gulf: "Gulf",
    inlet: "Inlet",
    loch: "Loch",
    bayou: "Bayou",
    dock: "Dock",
    pier: "Pier",
    anchorage: "Anchorage",
    jetty: "Jetty",
    wharf: "Wharf",
    marina: "Marina",
    landing: "Landing",
    mooring: "Mooring",
    berth: "Berth",
    quay: "Quay",
    staith: "Staith",
    creek: "Creek",
    waterway: "Waterway",
    rill: "Rill",
    delta: "Delta",
    bank: "Bank",
    runoff: "Runoff",
    channel: "Channel",
    bend: "Bend",
    meander: "Meander",
    backwater: "Backwater",
    lake: "Lake",
    pool: "Pool",
    pond: "Pond",
    dugout: "Dugout",
    fountain: "Fountain",
    watering_hole: "Watering Hole",
    oasis: "Oasis",
    well: "Well",
    cistern: "Cistern",
    reservoir: "Reservoir",
    falls: "Falls",
    rapids: "Rapids",
    cataract: "Cataract",
    cascade: "Cascade",
    bridge: "Bridge",
    crossing: "Crossing",
    causeway: "Causeway",
    viaduct: "Viaduct",
    aquaduct: "Aquaduct",
    ford: "Ford",
    ferry: "Ferry",
    dam: "Dam",
    dike: "Dike",
    bar: "Bar",
    canal: "Canal",
    ditch: "Ditch",
    peninsula: "Peninsula",
    isthmus: "Isthmus",
    island: "Island",
    isle: "Isle",
    sandbar: "Sandbar",
    reef: "Reef",
    atoll: "Atoll",
    archipelago: "Archipelago",
    cay: "Cay",
    shipwreck: "Shipwreck",
    derelict: "Derelict",
    clearing: "Clearing",
    grove: "Grove",
    glade: "Glade",
    fairy_ring: "Fairy Ring",
    ruin: "Ruin",
    acropolis: "Acropolis",
    desolation: "Desolation",
    remnant: "Remnant",
    remains: "Remains",
    henge: "Henge",
    cairn: "Cairn",
    circle: "Circle",
    mound: "Mound",
    barrow: "Barrow",
    earthworks: "Earthworks",
    petroglyphs: "Petroglyphs",
    lookout: "Lookout",
    aerie: "Aerie",
    promontory: "Promontory",
    outcropping: "Outcropping",
    ledge: "Ledge",
    overhang: "Overhang",
    mesa: "Mesa",
    butte: "Butte",
    outland: "Outland",
    outback: "Outback",
    territory: "Territory",
    reaches: "Reaches",
    wild: "Wild",
    wilderness: "Wilderness",
    expanse: "Expanse",
    view: "View",
    vista: "Vista",
    tableau: "Tableau",
    spectacle: "Spectacle",
    landscape: "Landscape",
    landmark: "Landmark",
    battlefield: "Battlefield",
    trenches: "Trenches",
    gambit: "Gambit",
    folly: "Folly",
    conquest: "Conquest",
    claim: "Claim",
    muster: "Muster",
    post: "Post",
    road: "Road",
    track: "Track",
    route: "Route",
    highway: "Highway",
    way: "Way",
    lane: "Lane",
    thoroughfare: "Thoroughfare",
    pike: "Pike",
    alley: "Alley",
    street: "Street",
    avenue: "Avenue",
    boulevard: "Boulevard",
    promenade: "Promenade",
    esplanade: "Esplanade",
    boardwalk: "Boardwalk",
    crossroad: "Crossroad",
    junction: "Junction",
    intersection: "Intersection",
    turn: "Turn",
    corner: "Corner",
    plaza: "Plaza",
    terrace: "Terrace",
    square: "Square",
    courtyard: "Courtyard",
    court: "Court",
    park: "Park",
    marketplace: "Marketplace",
    bazaar: "Bazaar",
    fairground: "Fairground",
    realm: "Realm",
    land: "Land",
    country: "Country",
    nation: "Nation",
    state: "State",
    protectorate: "Protectorate",
    empire: "Empire",
    kingdom: "Kingdom",
    principality: "Principality",
    domain: "Domain",
    dominion: "Dominion",
    demesne: "Demesne",
    province: "Province",
    county: "County",
    duchy: "Duchy",
    barony: "Barony",
    baronetcy: "Baronetcy",
    march: "March",
    canton: "Canton",
    earldom: "Earlom",
    fief: "Fief",
    shire: "Shire",
    pit: "Pit",
    hole: "Hole",
    abyss: "Abyss",
    sinkhole: "Sinkhole",
    crack: "Crack",
    chasm: "Chasm",
    scar: "Scar",
    rift: "Rift",
    trench: "Trench",
    fissure: "Fissure",
    cavern: "Cavern",
    cave: "Cave",
    gallery: "Gallery",
    grotto: "Grotto",
    karst: "Karst",
    mine: "Mine",
    quarry: "Quarry",
    shaft: "Shaft",
    vein: "Vein",
    darkness: "Darkness",
    shadow: "Shadow",
    depths: "Depths",
    void: "Void",
    tomb: "Tomb",
    grave: "Grave",
    crypt: "Crypt",
    sepulchre: "Sepulchre",
    mausoleum: "Mausoleum",
    ossuary: "Ossuary",
    boneyard: "Boneyard",
    graveyard: "Graveyard",
    cemetery: "Cemetery",
    maze: "Maze",
    labyrinth: "Labyrinth",
    nest: "Nest",
    burrow: "Burrow",
    lair: "Lair",
    den: "Den",
    boltHole: "Bolt Hole",
    warren: "Warren",
    roost: "Roost",
    rookery: "Rookery",
    hibernaculum: "Hibernaculum",
    home: "Home",
    rest: "Rest",
    hideout: "Hideout",
    hideaway: "Hideaway",
    retreat: "Retreat",
    restingPlace: "Resting Place",
    safehouse: "Safehouse",
    sanctuary: "Sanctuary",
    respite: "Respite",
    lodge: "Lodge",
    meeting_place: "Meeting Place",
    bivouac: "Bivouac",
    campsite: "Campsite",
    encampment: "Encampment",
    tepee: "Tepee",
    tent: "Tent",
    wigwam: "Wigwam",
    shelter: "Shelter",
    lean_to: "Lean-To",
    yurt: "Yurt",
    house: "House",
    mansion: "Mansion",
    estate: "Estate",
    villa: "Villa",
    hut: "Hut",
    palace: "Palace",
    outbuilding: "Outbuilding",
    shack: "Shack",
    tenement: "Tenement",
    hovel: "Hovel",
    manse: "Manse",
    manor: "Manor",
    longhouse: "Longhouse",
    cottage: "Cottage",
    cabin: "Cabin",
    parsonage: "Parsonage",
    rectory: "Rectory",
    vicarge: "Vicarge",
    friary: "Friary",
    priory: "Priory",
    abbey: "Abbey",
    monastery: "Monastery",
    nunnery: "Nunnery",
    cloister: "Cloister",
    convent: "Convent",
    hermitage: "Hermitage",
    castle: "Castle",
    keep: "Keep",
    fort: "Fort",
    fortress: "Fortress",
    citadel: "Citadel",
    bailey: "Bailey",
    motte: "Motte",
    stronghold: "Stronghold",
    hold: "Hold",
    chateau: "Chateau",
    redoubt: "Redoubt",
    commune: "Commune",
    temple: "Temple",
    shrine: "Shrine",
    church: "Church",
    cathedral: "Cathedral",
    tabernacle: "Tabernacle",
    ark: "Ark",
    sanctum: "Sanctum",
    parish: "Parish",
    chapel: "Chapel",
    synagogue: "Synagogue",
    mosque: "Mosque",
    pyramid: "Pyramid",
    ziggurat: "Ziggurat",
    prison: "Prison",
    jail: "Jail",
    dungeon: "Dungeon",
    oubliette: "Oubliette",
    hospital: "Hospital",
    hospice: "Hospice",
    stocks: "Stocks",
    gallows: "Gallows",
    asylum: "Asylum",
    madhouse: "Madhouse",
    bedlam: "Bedlam",
    vault: "Vault",
    treasury: "Treasury",
    warehouse: "Warehouse",
    cellar: "Cellar",
    relicry: "Relicry",
    repository: "Repository",
    barracks: "Barracks",
    armoury: "Armoury",
    sewer: "Sewer",
    gutter: "Gutter",
    catacombs: "Catacombs",
    dump: "Dump",
    middens: "Middens",
    pipes: "Pipes",
    baths: "Baths",
    heap: "Heap",
    mill: "Mill",
    windmill: "Windmill",
    sawmill: "Sawmill",
    smithy: "Smithy",
    forge: "Forge",
    workshop: "Workshop",
    brickyard: "Brickyard",
    shipyard: "Shipyard",
    forgeworks: "Forgeworks",
    foundry: "Foundry",
    bakery: "Bakery",
    brewery: "Brewery",
    almshouse: "Almshouse",
    countinghouse: "Counting House",
    courthouse: "Courthouse",
    apothecary: "Apothecary",
    haberdashery: "Haberdashery",
    cobbler: "Cobbler",
    garden: "Garden",
    menagerie: "Menagerie",
    zoo: "Zoo",
    aquarium: "Aquarium",
    terrarium: "Terrarium",
    conservatory: "Conservatory",
    lawn: "Lawn",
    greenhouse: "Greenhouse",
    farm: "Farm",
    ranch: "Ranch",
    apiary: "Apiary",
    farmstead: "Farmstead",
    homestead: "Homestead",
    pasture: "Pasture",
    commons: "Commons",
    granary: "Granary",
    silo: "Silo",
    crop: "Crop",
    barn: "Barn",
    stable: "Stable",
    pen: "Pen",
    kennel: "Kennel",
    mews: "Mews",
    hutch: "Hutch",
    pound: "Pound",
    coop: "Coop",
    stockade: "Stockade",
    yard: "Yard",
    lumber_yard: "Lumber Yard",
    tavern: "Tavern",
    inn: "Inn",
    pub: "Pub",
    brothel: "Brothel",
    whorehouse: "Whorehouse",
    cathouse: "Cathouse",
    discotheque: "Discotheque",
    lighthouse: "Lighthouse",
    beacon: "Beacon",
    amphitheatre: "Amphitheatre",
    colosseum: "Colosseum",
    stadium: "Stadium",
    arena: "Arena",
    circus: "Circus",
    academy: "Academy",
    university: "University",
    campus: "Campus",
    college: "College",
    library: "Library",
    scriptorium: "Scriptorium",
    laboratory: "Laboratory",
    observatory: "Observatory",
    museum: "Museum",
    hall: "Hall",
    chamber: "Chamber",
    room: "Room",
    nave: "Nave",
    aisle: "Aisle",
    vestibule: "Vestibule",
    antechamber: "Antechamber",
    chantry: "Chantry",
    pulpit: "Pulpit",
    dome: "Dome",
    arch: "Arch",
    colonnade: "Colonnade",
    stair: "Stair",
    ladder: "Ladder",
    climb: "Climb",
    ramp: "Ramp",
    steps: "Steps",
    portal: "Portal",
    mouth: "Mouth",
    opening: "Opening",
    door: "Door",
    gate: "Gate",
    entrance: "Entrance",
    maw: "Maw",
    tunnel: "Tunnel",
    passage: "Passage",
    corridor: "Corridor",
    hallway: "Hallway",
    chute: "Chute",
    slide: "Slide",
    tube: "Tube",
    trapdoor: "Trapdoor",
    tower: "Tower",
    turret: "Turret",
    belfry: "Belfry",
    wall: "Wall",
    fortifications: "Fortifications",
    ramparts: "Ramparts",
    pallisade: "Pallisade",
    battlements: "Battlements",
    portcullis: "Portcullis",
    barbican: "Barbican",
    throne_room: "Throne Room",
    ballroom: "Ballroom",
    roof: "Roof",
    rooftops: "Rooftops",
    chimney: "Chimney",
    attic: "Attic",
    loft: "Loft",
    gable: "Gable",
    eaves: "Eaves",
    belvedere: "Belvedere",
    balcony: "Balcony",
    balustrade: "Balustrade",
    parapet: "Parapet",
    walkway: "Walkway",
    catwalk: "Catwalk",
    pavillion: "Pavillion",
    pagoda: "Pagoda",
    gazebo: "Gazebo",
    mirror: "Mirror",
    megalith: "Megalith",
    menhir: "Menhir",
    dolmen: "Dolmen",
    obelisk: "Obelisk",
    statue: "Statue",
    gargoyle: "Gargoyle",
    grotesque: "Grotesque",
    bonfire: "Bonfire",
    hearth: "Hearth",
    fireplace: "Fireplace",
    furnace: "Furnace",
    stove: "Stove",
    grate: "Grate",
    peephole: "Peephole",
    arrowslit: "Arrowslit",
    balistraria: "Balistraria",
    lancet: "Lancet",
    aperture: "Aperture",
    dormer: "Dormer",
  },
  landscapemodifier: {
    vast: "vast",
    desolate: "desolate",
    expansive: "expansive",
    pictureque: "pictureque",
    majestic: "majestic",
    serene: "serene",
    lush: "lush",
    dynamic: "dynamic",
    verdant: "verdant",
    elegant: "elegant",
    pristine: "pristine",
    stunning: "stunning",
    breathtaking: "breath-taking",
    inviting: "inviting",
    rejuvenating: "rejuvenating",
    tranquil: "tranquil",
    calm: "calm",
    peaceful: "peaceful",
    idyllic: "idyllic",
    gorgeous: "gorgeous",
    magnificent: "magnificent",
    splendid: "splendid",
    lovely: "lovely",
    radiant: "radiant",
    glowing: "glowing",
    exotic: "exotic",
    mysterious: "mysterious",
    fascinating: "fascinating",
    intriguing: "intriguing",
    captivating: "captivating",
    alluring: "alluring",
    charming: "charming",
    delightful: "delightful",
    pleasing: "pleasing",
    appealing: "appealing",
    attractive: "attractive",
    beauteous: "beauteous",
    comely: "comely",
    fair: "fair",
    goodlooking: "good-looking",
    handsome: "handsome",
    nicelooking: "nice-looking",
    pretty: "pretty",
    wellformed: "well-formed",
    ravishing: "ravishing",
    graceful: "graceful",
    imposing: "imposing",
    impressive: "impressive",
    sublime: "sublime",
    grand: "grand",
    stately: "stately",
    dignified: "dignified",
    noble: "noble",
    regal: "regal",
    resplendent: "resplendent",
    simple: "Simple",
    soft: "Soft",
    tropical: "Tropical",
    perfect: "Perfect",
    harsh: "Harsh",
    immediate: "Immediate",
    foreign: "Foreign",
    local: "Local",
    surreal: "Surreal",
    best: "Best",
    stark: "Stark",
    shadowy: "Shadowy",
    mental: "Mental",
    variegated: "Variegated",
    enchanting: "Enchanting",
    actual: "Actual",
    immense: "Immense",
    silent: "Silent",
    pure: "Pure",
    true: "True",
    greatest: "Greatest",
    rough: "Rough",
    famous: " Famous ",
    nearer: "Nearer",
    dull: "Dull",
    artificial: "Artificial",
    african: "African",
    ideal: "Ideal",
    dry: "Dry",
    icy: "Icy",
    japanese: "Japanese",
    internal: "Internal",
    particular: "Particular",
    fertile: "Fertile",
    visible: "Visible",
    chinese: "Chinese",
    classical: "Classical",
    cold: "Cold",
    fairy: "Fairy",
    savage: "Savage",
    yellow: "Yellow",
    diversified: "Diversified",
    sombre: "Sombre",
    sterile: " Sterile ",
    finest: "Finest",
    gentle: " Gentle ",
    swiss: "Swiss",
    pale: "Pale",
    lifeless: "Lifeless",
    inverted: "Inverted",
    western: "Western",
    wet: "Wet",
    imaginary: "Imaginary",
    ragged: "Ragged",
    spacious: "Spacious",
    sylvan: "Sylvan",
    golden: "Golden",
    mere: "Mere",
    sweet: "Sweet",
    uneven: "Uneven",
    drab: "Drab",
    woodland: "Woodland",
    dusky: "Dusky",
    superb: "Superb",
    hazy: "Hazy",
    depressing: "Depressing",
    southern: "Southern",
    austere: "Austerian",
    jagged: "Jagged",
    nocturnal: "Nocturnal",
    stony: "Stony",
    brilliant: "Brilliant",
    craggy: "Craggy",
    irregular: "Irregular",
    peculiar: "Peculiar",
    social: "Social",
    various: "Various",
    distinct: "Distinct",
    bizarre: "Bizarre",
    frosty: "Frosty",
    watery: "Watery",
    human: "Human",
    primeval: "Primeval",
    bare: "Bare",
    ancient: "Ancient",
    foggy: "Foggy",
    wellknown: "Well-known",
    sodden: "Sodden",
    native: "Native",
    interesting: "Interesting",
    industrial: "Industrial",
    moral: "Morally",
    literary: "Literary",
    beloved: "Beloved",
    eternal: "Eternal",
    crumpled: "Crumpled",
    hot: "Hot",
    delicate: "Delicate",
    fleeting: "Fleeting",
    unknown: "Unknown",
    quaint: "Quaint",
    dreamy: "Dreamy",
    loveliest: "Loveliest",
    delicious: "Delicious",
    historical: "Historical",
    planetary: "Planetary",
    fresh: "Fresh",
    striking: "Striking",
    regular: "Regular",
    grim: "Grim",
    nightmarish: "Nightmarish",
    hostile: "Hostile",
    european: "European",
    panoramic: "Panoramic",
    rustic: "Rustic",
    rumpled: "Rumbled",
    green: "Green",
    lowlying: "Low-lying",
    solitary: "Solitary",
    primal: "Primal",
    terrestrial: "Terrestrial",
    low: "Low",
    excellent: "Excellent",
    huge: "Huge",
    colored: "Colored",
    naked: "Naked",
    canadian: "Canadian",
    cheerful: "Cheerful",
    heroic: "Heroic",
    normal: "Normal",
    dazzling: "Dazzling",
    suburban: "Suburban",
    sandy: "Sandy",
    complete: "Complete",
    nearby: "Nearby",
    single: "Single",
    extraordinary: "Extraordinary",
    monochrome: "Monochrome",
    ordinary: "Ordinary",
    endless: "Endless",
    mighty: "Mighty",
    windswept: "Windswept",
    distant: "Distant",
    dusty: "Dusty",
    impossible: "Impossible",
    common: "Common",
    unreal: "Unreal",
    abstract: "Abstract",
    sad: "Sad",
    incomparable: "Incomparable",
    tawny: "Tawny",
    wide: "Wide",
    beautiful: "Beautiful",
    gay: "Gay",
    orange: "Orange",
    electronic: "Electronic",
    british: "British",
    characteristic: "Characteristic",
    fairest: "Fairest",
    agreeable: "Agreeable",
    boundless: "Boundless",
    conventional: "Conventional",
    poetic: "Poetic",
    bold: "Bold",
    typical: "Typical",
    egyptian: "Egyptian",
    outer: "Outer",
    murky: "Murky",
    chaotic: "Chaotic",
    everchanging: "Ever-changing",
    terrible: "Terrible",
    treeless: "Treeless",
    vernal: "Vernal",
    unbroken: "Unbroken",
    fanciful: "Fanciful",
    decorative: "Decorative",
    gracious: "Gracious",
    adjacent: "Adjacent",
    inimitable: "Inimitable",
    semitropical: "Semi-tropical",
    uninhabited: "Uninhabited",
  },

  aspectlandscape: {
    base21: "2:1",
    base169: "16:9",
    base219: "21:9",
    base32: "3:2",
    base52: "5:2",
    base31: "3:1",
    base149: "14:9",
    base53: "5:3",
    base43: "4:3",
    base143100: "143:100",
    base185100: "185:100",
    base235100: "235:100",
  },
  aspectportrait: {
    base12: "1:2",
    base916: "9:16",
    base921: "9:21",
    base23: "2:3",
    base25: "2:5",
    base13: "1:3",
    base914: "9:14",
    base35: "3:5",
    base34: "3:4",
    base100143: "100:143",
    base100185: "100:185",
    base100235: "100:235",
  },
};
